<div class="container-fluid" id="mainbody">
  <div class="row" style="margin-bottom:70px">

    <!-- My Plans -->
    <div class="col-12 col-sm-6 col-xxl-3 col-md-4 px-md-0">
      <div class="card dependentDiv">
        <div class="card-header bg-headers d-flex justify-content-between align-items-center">
          <span class="text-white title">{{ lang?.My_Plans }}</span>
        </div>
        <div class="card-body p-2">
          <section id="tranding" *ngIf="filteredPlans && filteredPlans.length > 1">
            <div class="container"></div>
            <div class="container">
              <div class="swiper tranding-slider">
                <div class="swiper-wrapper">
                  <!-- Slide-start -->
                  <div class="swiper-slide tranding-slide" *ngFor="let plan of filteredPlans">
                    <div class="card activecard">
                      <div class="card-header p-0" style="height: 67px">
                        <img id="image" *ngIf="plan.logo != null; else backgroundImage" src="{{ plan.logo }}"
                          width="100%" />
                        <ng-template #backgroundImage>
                          <div style="height: 67px" *ngIf="plan.backgroundImage != null;">
                            <img id="image" src="{{ plan.backgroundImage }}" width="100%" />
                          </div>
                        </ng-template>
                        <div class="imagetext">
                          <span>{{ plan.name }}&nbsp;<i class="bi bi-info-circle" title="Activation Date:{{
                                  plan.activationDate | customDate
                                }},Enrollment Date:{{ plan.enrolledDate | customDate }}"></i></span>
                        </div>
                      </div>
                      <div class="card-body py-2 px-1" [style.background-color]="plan">
                        <div class="planBody" [style.color]="plan">
                          <div *ngFor="let feature of plan.content">
                            <div style="font-size: 12px">
                              <b>{{ feature.name ?? feature?.feature?.name }}</b>
                            </div>
                            <p style="text-align: left; font-size: 12px" [innerHTML]="feature.description"></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tranding-slider-control">
                  <div class="swiper-button-prev slider-arrow">
                    <i class="fa fa-angle-left" style="font-size: 20px"></i>
                                      </div>
                  <div class="swiper-button-next slider-arrow">
                    <i class="fa fa-angle-right" style="font-size: 20px"></i>
                                      </div>
                  <div class="swiper-pagination"></div>
                </div>
              </div>
            </div>
          </section>
          <div *ngIf="filteredPlans && filteredPlans.length == 1">
            <div *ngFor="let plan of filteredPlans">
              <div class="card shadow subcardheight">
                <div class="card-header p-0" style="height: 67px">
                  <img id="image" *ngIf="plan.logo != null; else backgroundImage" src="{{ plan.logo }}" width="100%" />
                  <ng-template #backgroundImage>
                    <div style="height: 67px" *ngIf="plan.backgroundImage != null;">
                      <img id="image" src="{{ plan.backgroundImage }}" width="100%" />
                    </div>
                  </ng-template>
                  <div class="imagetext">
                    <span>{{ plan.name }}&nbsp;<i class="bi bi-info-circle" title="Activation Date:{{
                        plan.activationDate | customDate
                      }},Enrollment Date:{{ plan.enrolledDate | customDate }}"></i></span>
                  </div>
                </div>
                <div class="card-body py-2 px-1" [style.background-color]="plan.backgroundColor"
                  style="border-radius: 0px 0px 5px 5px">
                  <div class="planBody" [style.color]="plan.color">
                    <div *ngFor="let feature of plan.content">
                      <div style="font-size: 12px">
                        <b>{{ feature.name ?? feature?.feature?.name }}</b>
                      </div>
                      <p style="text-align: left; font-size: 12px" [innerHTML]="feature.description"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Downloads -->
    <div class="col-12 col-sm-6 col-xxl-3 col-md-4 px-md-0">
      <div class="card dependentDiv">
        <div class="card-header bg-headers d-flex justify-content-between align-items-center">
          <span class="text-white title">{{ lang?.Downloads }}</span>
                    <span id="downloadall" class="title">
            <img src="/assets/img/download2.png" role="button" width="45%" data-bs-toggle="tooltip"
              data-bs-placement="top" title="{{lang?.Download_All}}" (click)="downloadAllHpBooklets()" />
          </span>
        </div>
        <div class="card-body p-2">
          <section id="tranding">
            <div class="container"></div>
            <div class="container">
              <div class="swiper tranding-slider">
                <div class="swiper-wrapper">
                  <div class="swiper-slide tranding-slide">
                    <div class="card activecard">
                      <div class="card-header p-0">
                        <div class="imagetext">
                          <span>{{ lang?.Member_Booklets }}</span>
                        </div>
                        <img id="image" *ngIf="
                              logo && logo.booklets.image != '';
                              else backgroundImage
                            " src="{{ logo.booklets.image }}" width="100%" />
                        <ng-template #backgroundImage>
                          <div>
                            <img id="image" *ngIf="logo" src="{{ logo.booklets.image }}" width="100%" />
                          </div>
                        </ng-template>
                      </div>
                      <div class="card-body py-2 px-1">
                        <div class="planBody">
                          <div *ngIf="bookletList.length > 0">
                            <div class="row mb-1" *ngFor="let booklet of bookletList">
                              <div class="col-9 carousellabels">
                                <div>{{ booklet.name }}</div>
                                                              </div>
                              <div class="col-3 d-flex ps-0">
                                <img src="/assets/img/view2.png" id="viewing" role="button" data-bs-toggle="modal"
                                  data-bs-target="#hpbooklet" data-bs-placement="top" title="View"
                                  (click)="viewBooklet(booklet.link)" />&nbsp;
                                <img src="/assets/img/download2.png" id="viewing" role="button" data-bs-toggle="tooltip"
                                  data-bs-placement="top" title="{{lang?.Download}}"
                                  (click)="downloadHpbooklet(booklet)" />
                              </div>
                            </div>
                          </div>
                          <div *ngIf="bookletList.length == 0">
                            <p class="text-center" style="font-size: 12px">
                              {{ lang?.Member_Booklets_are_not_available }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide tranding-slide" *ngIf="!waddelCustomer">
                    <div class="card activecard">
                      <div class="card-header p-0">
                        <div class="imagetext">
                          <span>{{ lang?.Membership_Cards }}</span>
                        </div>
                        <img id="image" *ngIf="
                              logo && logo.healthCards.image != '';
                              else backgroundImage
                            " src="{{ logo.healthCards.image }}" width="100%" />
                        <ng-template #backgroundImage>
                          <div>
                            <img id="image" *ngIf="logo" src="{{ logo.healthCards.image }}" width="100%" />
                          </div>
                        </ng-template>
                      </div>
                      <div class="card-body py-2 px-1">
                        <div class="planBody">
                          <div class="downloads">
                            <div *ngIf="hicList.length > 0">
                              <div class="row" *ngFor="let hic of hicList">
                                <div class="col-9 carousellabels">
                                  <div>{{ hic.name }}</div>
                                </div>
                                <div class="col-3 d-flex ps-0">
                                  <img src="/assets/img/view2.png" id="viewing" role="button" data-bs-toggle="modal"
                                    data-bs-target="#hicDetails" data-bs-placement="top" title="{{lang?.View}}"
                                    (click)="viewHealthCard(hic)" />&nbsp;
                                  <img src="/assets/img/download2.png" id="viewing" role="button"
                                    data-bs-toggle="tooltip" data-bs-placement="top" title="{{lang?.Download}}"
                                    (click)="downloadHic(hic)" />
                                </div>
                              </div>
                            </div>
                            <div *ngIf="hicList.length == 0">
                              <p class="text-center" style="font-size: 12px">
                                {{ lang?.Membership_cards_are_not_available }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide tranding-slide">
                    <div class="card activecard">
                      <div class="card-header p-0">
                        <div class="imagetext">
                          <span>{{ lang?.My_Applications }}</span>
                        </div>
                        <img id="image" *ngIf="
                              logo && logo.roe.image != '';
                              else backgroundImage
                            " src="{{ logo.roe.image }}" width="100%" />
                        <ng-template #backgroundImage>
                          <div>
                            <img id="image" *ngIf="logo" src="{{ logo.roe.image }}" width="100%" />
                          </div>
                        </ng-template>
                      </div>
                      <div class="card-body py-2 px-1">
                        <div class="planBody">
                          <div class="downloads">
                            <div class="row" *ngFor="let roe of showROES">
                              <div class="col-9 carousellabels">
                                {{ lang?.Record_of_Enrollment }}-<small>{{
                                  roe.time | customDate
                                  }}</small>
                              </div>
                              <div class="col-3 d-flex ps-0">
                                <img src="/assets/img/view2.png" id="viewing" role="button" data-bs-toggle="modal"
                                  data-bs-target="#roe" data-bs-placement="top" title="{{lang?.View}}"
                                  (click)="getRoe(roe)" />&nbsp;
                                <img src="/assets/img/download2.png" id="viewing" role="button" data-bs-toggle="tooltip"
                                  data-bs-placement="top" title="{{lang?.Download}}" (click)="downloadRoe(roe)" />
                              </div>
                            </div>
                            <div *ngIf="showROAS.length > 0">
                              <div class="row" *ngFor="let roe of showROAS">
                                <div class="col-9 carousellabels">
                                  Record of Amendment-<small>{{
                                    roe.time | customDate
                                    }}</small>
                                </div>
                                <div class="col-3 d-flex ps-0">
                                  <img src="/assets/img/view2.png" id="viewing" role="button" data-bs-toggle="modal"
                                    data-bs-target="#roa" data-bs-placement="top" title="{{lang?.View}}"
                                    (click)="getRoe(roe)" />&nbsp;
                                  <img src="/assets/img/download2.png" id="viewing" role="button"
                                    data-bs-toggle="tooltip" data-bs-placement="top" title="{{lang?.Download}}"
                                    (click)="downloadRoe(roe)" />
                                </div>

                              </div>
                            </div>
                            <div class="row" *ngIf="padAgreement">
                              <div class="col-9 carousellabels">
                                Pre Authorized Debit (PAD)
                              </div>
                              <div class="col-3 d-flex ps-0">
                                <img src="/assets/img/view2.png" id="viewing" role="button" data-bs-toggle="modal"
                                  data-bs-target="#view-padAgreement" data-bs-placement="top" title="{{lang?.View}}"
                                  (click)="viewPadAgreement()" />&nbsp;
                                <img src="/assets/img/download2.png" id="viewing" role="button" data-bs-toggle="tooltip"
                                  data-bs-placement="top" title="{{lang?.Download}}"
                                  (click)="downloadPAD(padAgreement)" />
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tranding-slider-control">
                  <div class="swiper-button-prev slider-arrow">
                    <i class="fa fa-angle-left" style="font-size: 20px"></i>
                  </div>
                  <div class="swiper-button-next slider-arrow">
                    <i class="fa fa-angle-right" style="font-size: 20px"></i>
                  </div>
                  <div class="swiper-pagination"></div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>

 <div class="col-12 col-sm-6 col-xxl-3 col-md-4 px-md-0" *ngIf="(hasMedcanMembership || planLevelId === 18) && false">
  <lib-order-services-carousel
    [customerId]="customerid"
    [accessToken]="accessToken"
    [apiUrl]="api.url"
    [authorizeApiUrl]="api.authorizeApiUrl"
    [formConfig]="formConfiguration"
    [lang]="lang"

  >
  </lib-order-services-carousel>
</div>

    <!-- Benefits -->
    <div class="col-12 col-sm-6 col-xxl-3 col-md-4 px-md-0">
      <div class="card dependentDiv">
        <div class="card-header bg-headers d-flex justify-content-between align-items-center">
          <span class="text-white title">{{ lang?.My_Resources }}</span>
        </div>
        <div class="card-body p-2">
          <section id="tranding" *ngIf="benefits && benefits.length > 1">
            <div class="container"></div>
            <div class="container">
              <div class="swiper tranding-slider">
                <div class="swiper-wrapper">
                  <!-- Slide-start -->
                  <div class="swiper-slide tranding-slide" *ngFor="let benefit of benefits">
                    <div class="card activecard">
                      <div class="card-header p-0" style="height: 70px">
                        <div class="imagetext">
                          <span *ngIf="benefit.logo == ''">{{
                            benefit.name
                            }}</span>
                        </div>
                        <img id="image" *ngIf="benefit.logo != ''; else backgroundImage" src="{{ benefit.logo }}"
                          width="100%" />

                        <ng-template #backgroundImage>
                          <div>
                            <img id="image" src="{{ benefit.backgroundImage }}" width="100%" />
                          </div>
                        </ng-template>
                      </div>

                      <div class="card-body py-2 px-1" [style.background-color]="benefit.backgroundColor">
                        <div class="benefitplanBody" [style.color]="benefit.color">
                          <p style="text-align: left; font-size: 10px"
                            [innerHTML]="filterEmptyListItems(benefit.content)" (click)="handleContentClick($event)">
                          </p>
                          <div *ngIf="copiedText" class="copied-msg">
                            Copied to Clipboard
                          </div>
                        </div>
                        <div>
                          <button #videoPopup type="button" hidden data-bs-target="#videoform"
                            data-bs-toggle="modal"></button>
                          <button #iframePopup type="button" hidden data-bs-target="#iframeform"
                            data-bs-toggle="modal"></button>
                          <button #equitablePopup type="button" hidden data-bs-target="#equitable"
                            data-bs-toggle="modal"></button>
                          <button #supportPopup type="button" hidden data-bs-target="#support"
                            data-bs-toggle="modal"></button>
                        </div>
                      </div>

                      <div class="card-footer corosalfooter py-0" [style.background-color]="benefit.color">
                        <div class="row" *ngIf="benefit && benefit.footer.length > 0">
                          <div class="col-12 text-center">
                            <div [innerHTML]="benefit.footer"></div>
                                                      </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="tranding-slider-control">
                  <div class="swiper-button-prev slider-arrow">
                    <i class="fa fa-angle-left" style="font-size: 20px"></i>
                  </div>
                  <div class="swiper-button-next slider-arrow">
                    <i class="fa fa-angle-right" style="font-size: 20px"></i>
                  </div>
                  <div class="swiper-pagination"></div>
                </div>
              </div>
            </div>
          </section>
          <div *ngIf="benefits && benefits.length == 1">
            <div class="card shadow subcardheight" *ngFor="let benefit of benefits">
              <div class="card-header p-0" style="height: 67px">
                <div class="imagetext">
                  <span *ngIf="benefit.logo == ''">{{ benefit.name }}</span>
                </div>
                <img id="image" *ngIf="benefit.logo != ''; else backgroundImage" src="{{ benefit.logo }}"
                  width="100%" />

                <ng-template #backgroundImage>
                  <div>
                    <img id="image" src="{{ benefit.backgroundImage }}" width="100%" />
                  </div>
                </ng-template>
              </div>

              <div class="card-body py-2 px-1" [style.background-color]="benefit.backgroundColor">
                <div class="benefitplanBody">
                  <p style="text-align: left; font-size: 10px" [innerHTML]="filterEmptyListItems(benefit.content)"></p>
                </div>
                <div>
                  <button #videoPopup type="button" hidden data-bs-target="#videoform" data-bs-toggle="modal"></button>
                  <button #iframePopup type="button" hidden data-bs-target="#iframeform"
                    data-bs-toggle="modal"></button>
                  <button #equitablePopup type="button" hidden data-bs-target="#equitable"
                    data-bs-toggle="modal"></button>
                  <button #supportPopup type="button" hidden data-bs-target="#support" data-bs-toggle="modal"></button>
                </div>
              </div>

              <div class="card-footer corosalfooter py-0" [style.background-color]="benefit.color">
                <div class="row" *ngIf="benefit && benefit.footer.length > 0">
                  <div class="col-12 text-center">
                    <div [innerHTML]="benefit.footer"></div>
                                      </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="benefits && benefits.length <= 0">
            <p p class="text-center" style="font-size: 12px">
              {{ lang?.No_Data_Found }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-6 col-xxl-3 col-md-4 px-md-0">
      <div class="card dependentDiv">
        <div class="card-header bg-headers d-flex justify-content-between align-items-center" id="cardheader">
          <span class="text-white title">{{ lang?.Member_Support }}</span>
                  </div>
        <div class="card-body p-2">
          <div class="card subcardheight shadow" id="planheader">
            <div class="card-header p-0">
              <img id="singlecardimage" *ngIf="logo" src="{{ logo.memberSupport.image }}" width="100%" />
            </div>
            <div class="card-body py-2" id="scrollcard" *ngIf="advisor">
              <div>
                <div class="row">
                  <div class="col-1 ps-1">
                    <img src="/assets/img/tel.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                      data-bs-placement="top" title="{{ lang?.Telephone }}" />
                  </div>
                  <div class="col-10 mt-auto primaryInfoLabels">
                    {{ advisor.phone | phoneNoFormat }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-1 ps-1">
                    <img src="/assets/img/email.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                      data-bs-placement="top" title="{{ lang?.Email }}" />
                  </div>
                  <div class="col-10 mt-auto primaryInfoLabels">
                    {{ advisor.email }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-1 ps-1">
                    <img src="/assets/img/planholder.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                      data-bs-placement="top" title="{{ lang?.Name }}" />
                  </div>
                  <div class="col-10 mt-auto primaryInfoLabels">
                    {{ advisor.name }}
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer" id="paymentfooter" *ngIf="advisor">
              <div *ngIf="advisor.shortlink != ''">
                              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Invoices -->
    <div class="col-12 col-sm-6 col-xxl-3 col-md-4 px-md-0">
      <div class="card dependentDiv">
        <div class="card-header bg-headers d-flex justify-content-between align-items-center">
          <span class="text-white title">{{ lang?.Invoices }}</span>
          <div class="dropdown">
            <!-- Custom dropdown toggle -->
            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
              data-bs-toggle="dropdown" aria-expanded="false">
              {{ filterInvoice === 'Custom' ? 'Custom' : filterInvoice || 'Select Year' }}
            </button>

            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <li><a class="dropdown-item" (click)="filterInvoice = 'All'; filterInvoices()">All</a></li>
              <li><a class="dropdown-item"
                  (click)="filterInvoice = currentYear-1; filterInvoices()">{{currentYear-1}}</a></li>
              <li><a class="dropdown-item" (click)="filterInvoice = currentYear; filterInvoices()">{{currentYear}}</a>
              </li>
              <li><a class="dropdown-item"
                  (click)="filterInvoice = currentYear+1; filterInvoices()">{{currentYear+1}}</a></li>
              <li><a class="dropdown-item" (click)="onCustomClick($event)">Custom</a></li>

              <!-- Custom date input -->
              <li class="dropdown-item">
                <div *ngIf="filterInvoice === 'Custom'">
                  <input type="text" id="filterDateSelection" [(ngModel)]="filterDateSelection" class="form-control"
                    placeholder="Select Month" bsDaterangepicker
                    [bsConfig]="{ dateInputFormat: 'MMM YYYY', minMode: 'month', showWeekNumbers: false }"
                    [maxDate]="maxDateForPicker" (ngModelChange)="CustomInvoiceFilter()" />
                </div>
              </li>
            </ul>
          </div>
                  </div>
        <div class="card-body p-2">
          <div class="card subcardheight shadow" id="invoicecard">
            <div class="card-header p-0">
                            <img id="singlecardimage" src="{{ logo?.invoice?.image }}" width="100%" />
            </div>
            <div class="card-body" style="overflow-y: auto">
              <div *ngIf="showinvoiceMessage">
                <small>{{lang?.No_invoice_available_for_child_member_premium_is_paid_by_corporate}}
                </small>
              </div>
              <div *ngIf="!showinvoiceMessage" class="row">
                <div class="d-flex flex-wrap mt-1" *ngIf="
                      customerFinalInvoices && customerFinalInvoices.length > 0;
                      else noInvoice
                    ">
                  <div class="col-12" *ngFor="let invoice of customerFinalInvoices">
                    <div class="row primaryInfoLabels">
                      <div class="col-8" style="margin-left: 0px" [ngStyle]="{
                            color: invoice.status == 'PAID' ? 'green' : 
                             (invoice.status == 'OVERDUE' ? 'red' : 
                                  (invoice.status == 'POST' ? 'orange' : 
                                  (invoice.status == 'VOID' ? 'rgb(93, 124, 155)':
                                  (invoice.status == 'DRAFT' ? '#07a3d4' : 'black'))) )}" style="font-size:12px;">
                        {{ invoice.dueDate | customDate : 'MMM YYYY' }} ({{ invoice.status | titlecase }})
                      </div>
                      <div class="col-4">
                        <img role="button" src="/assets/img/view.png" alt="" width="22" height="20px" id="viewing"
                          role="button" data-bs-toggle="modal" data-bs-target="#viewinvoice" data-bs-placement="top"
                          title="{{lang?.View}}" (click)="viewinvoices(invoice.file??invoice.link)" />&nbsp;&nbsp;

                        <img role="button" src="/assets/img/download.png" alt="" width="20px" id="viewing" role="button"
                          data-bs-toggle="tooltip" data-bs-placement="top" title="{{lang?.Download}}"
                          (click)="downloadinvoices(invoice)" height="20px" />
                      </div>
                    </div>
                  </div>
                </div>
                  <div class="d-flex flex-wrap mt-1" *ngIf="customerAdhocInvoices && customerAdhocInvoices.length > 0">
    <div class="col-12" *ngFor="let invoice of customerAdhocInvoices">
      <div class="row primaryInfoLabels">
        <div class="col-8" style="margin-left: 0px" [ngStyle]="{
              color: invoice.status == 'COMPLETED' ? 'green' :
               (invoice.status == 'FAILED' ? 'red' :
                    (invoice.status == 'PENDING' ? 'orange' : 'black'))}" style="font-size:12px;">
          {{ invoice.invoiceDate | customDate : 'MMM YYYY' }} - {{ getAdhocPlanName(invoice) }} ({{ invoice.status | titlecase }})
        </div>
        <div class="col-4">
          <img role="button" src="/assets/img/view.png" alt="" width="22" height="20px" id="viewing"
            role="button" data-bs-toggle="modal" data-bs-target="#viewinvoice" data-bs-placement="top"
            title="{{lang?.View}}" (click)="viewinvoices(invoice.file??invoice.link)" />&nbsp;&nbsp;
          <img role="button" src="/assets/img/download.png" alt="" width="20px" id="viewing" role="button"
            data-bs-toggle="tooltip" data-bs-placement="top" title="{{lang?.Download}}"
            (click)="downloadinvoices(invoice)" height="20px" />
        </div>
      </div>
    </div>
  </div>
                <ng-template #noInvoice>
                  <div class="my-auto col-12 primaryInfoLabels row p-0 m-0">
                    <span *ngIf="(!getCustomerDraftDate || getCustomerDraftDate.length == 0)"
                      class="col-12 primaryInfoLabels">
                      {{lang?.No_Invoices_Available}}
                    </span>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Payment Info -->
    <div class="col-12 col-sm-6 col-xxl-3 col-md-4 px-md-0">
      <div class="card dependentDiv">
        <div class="card-header bg-headers justify-content-between align-items-center" id="cardheader">
          <div class="text-white title">{{ lang?.Payment_Method }}</div>
        </div>

        <div class="card-body p-2" *ngIf="isCorporateAccount && showinvoiceMessage">
          <div class="card subcardheight shadow" id="planheader" *ngIf="showinvoiceMessage">
            <div class="card-header p-0">
              <span class="imagetext1" *ngIf="!showinvoiceMessage">{{
                lang?.Credit_Card
                }}</span>
              <img id="singlecardimage" src="{{ logo?.paymentMethod?.image }}" width="100%" />
            </div>
            <div class="card-body py-2" id="scrollcard">
              <small *ngIf="!eqationStaffing">
                {{ lang?.Company_paid_for_all_the_selected_plans }}
              </small>
              <small *ngIf="eqationStaffing">
                {{
                lang?.The_cost_of_the_benefit_plan_is_a_shared_cost_between_employee_and_employer ??
                'The cost of the benefit plan is a shared cost between employee and employer'
                }}
              </small>
            </div>
          </div>
        </div>

        <div *ngIf="!showinvoiceMessage">
          <div class="card-body p-2" *ngIf="paymentMethod === 'CREDIT_CARD'">
            <div class="card subcardheight shadow" id="planheader" *ngIf="
                  paymentMethodId != 0 ||
                  paymentMethodId != null ||
                  paymentMethodId != ''
                ">
              <div class="card-header p-0">
                <span class="imagetext" style="font-size: 14px">{{
                  lang?.Credit_Card
                  }}</span>
                <img id="singlecardimage" *ngIf="logo" src="{{ logo.paymentMethod.image }}" width="100%" />
              </div>
              <div class="card-body py-2" id="scrollcard">
                                <div class="row" *ngIf="paymentMethodId != '0'">
                  <div class="form-group col-6 col-md-12 col-xl-6">
                    <div>
                      <label class="primaryInfoLabels">{{
                        lang?.Card_holder_name
                        }}</label>
                    </div>
                    <div class="primaryInfoLabels">
                      {{ fullName | titlecase }}
                    </div>
                  </div>
                  <div class="form-group col-6 col-md-12 col-xl-6">
                    <div>
                      <label class="primaryInfoLabels">Card number</label>
                    </div>
                    <div class="primaryInfoLabels">{{ creditCardNo }}</div>
                  </div>
                  <div class="form-group col-6 col-md-12 col-xl-6">
                    <div class="d-flex justify-content-between">
                      <label class="primaryInfoLabels">{{
                        lang?.Expire
                        }}</label>
                                          </div>
                                        <div class="primaryInfoLabels" [style.color]="ccExpiryColor" data-bs-toggle="tooltip"
                      title="{{ ccExpiryTitle }}" data-bs-placement="top">
                      <span *ngIf="ccExpiryColor == 'red'" class="blinker"></span>
                      {{ expire }}
                    </div>
                  </div>
                </div>
                <div *ngIf="paymentMethodId == '0'">
                  <p style="font-size: 14px">{{ lang?.No_Details_found }}</p>
                </div>
              </div>
              <div class="card-footer" id="paymentfooter">
                <div class="row align-items-end mt-auto">
                  <button id="viewButton" class="btn btn-sm btn-light col-2 mt-2 text-nowrap" *ngIf="!waddelCustomer"
                    data-bs-toggle="modal" data-bs-target="#updatePaymentMethodPAD" (click)="openpad()">
                    {{ lang?.Change_to_PAD }}
                  </button>
                  <button id="viewButton" *ngIf="isReauth===true"
                    class="btn btn-sm btn-light col-2 mt-2 ms-auto ms-md-0 ms-xl-auto text-nowrap"
                    (click)="reAuthorize()">
                    Re-authorize
                  </button>
                  <button id="viewButton" *ngIf="isRetryPayment===true"
                    class="btn btn-sm btn-light col-2 mt-2 ms-auto ms-md-0 ms-xl-auto text-nowrap"
                    (click)="retryPayment()">
                    Retry Payment
                  </button>
                  <button id="viewButton" *ngIf="paymentMethodId != '0' && formAttr!='occ'"
                    class="btn btn-sm btn-light col-3 mt-2 ms-auto ms-md-0 ms-xl-auto text-nowrap"
                    data-bs-toggle="modal" data-bs-target="#updatePaymentInfo" (click)="ccUpdate()">
                    {{ lang?.Update_Credit_Card }}
                  </button>
                  <button id="viewButton" class="btn btn-sm btn-light col-6 mt-2"
                    *ngIf="paymentMethodId == '0' && formAttr!='opd'" data-bs-toggle="modal"
                    data-bs-target="#changeToCC" (click)="changeToCC()">
                    {{ lang?.Change_to_Credit_Card }}
                  </button>
                </div>
              </div>
            </div>
            <div *ngIf="
                  paymentMethodId != 0 ||
                  paymentMethodId != null ||
                  paymentMethodId != ''
                ">
              <h6 class="title"></h6>
            </div>
          </div>
          <div class="card-body p-2" *ngIf="paymentMethod === 'ACH'">
            <div class="card subcardheight shadow" id="planheader">
              <div class="card-header p-0">
                <span class="imagetext" style="font-size: 14px">{{
                  lang?.Pre_Authorized_Debit_PAD
                  }}</span>
                <img id="singlecardimage" *ngIf="logo" src="{{ logo.paymentMethod.image }}" width="100%" />
              </div>
              <div class="card-body py-2" id="scrollcard">
                                <div class="row">
                  <div class="form-group col-4 col-md-12 col-xl-3 pe-0">
                    <div>
                      <label class="primaryInfoLabels">{{
                        lang?.Bank_Id
                        }}</label>

                    </div>
                    <div class="primaryInfoLabels">{{ bankCode }}</div>
                  </div>
                  <div class="form-group col-4 col-md-12 col-xl-4 paddingStart">
                    <div class="d-flex justify-content-between">
                      <label class="primaryInfoLabels">{{
                        lang?.Transit
                        }}</label>
                    </div>
                    <div class="primaryInfoLabels">{{ transitNumber }}</div>
                  </div>
                  <div class="form-group col-4 col-md-12 col-xl-5 paddingStart">
                    <div class="d-flex justify-content-between">
                      <label class="primaryInfoLabels">{{
                        lang?.Account
                        }}</label>
                    </div>
                    <div class="primaryInfoLabels">{{ accountNumber }}</div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12">
                    <div class="d-flex justify-content-between">
                      <label class="primaryInfoLabels">{{
                        lang?.Bank_Details
                        }}</label>
                    </div>
                    <div class="primaryInfoLabels">{{ bankinformation }}</div>
                  </div>
                </div>
              </div>
              <div class="card-footer" id="paymentfooter">
                <div class="row align-items-end mt-auto" id="paymentbuttons">
                  <button *ngIf="formAttr!='occ'" id="viewButton"
                    class="btn btn-sm btn-light col-4 mt-2 ms-auto ms-md-0 ms-xl-auto text-nowrap updatepad"
                    data-bs-toggle="modal" data-bs-target="#updatePADinfo" (click)="padUpdate()">
                    {{ lang?.Update_PAD }}
                  </button>

                  <button *ngIf="formAttr!='opd'" id="viewButton"
                    class="btn btn-sm btn-light col-4 mt-2 ms-auto ms-md-0 ms-xl-auto text-nowrap updatepad"
                    data-bs-toggle="modal" data-bs-target="#changeToCC" (click)="changeToCC()">
                    {{ lang?.Change_to_Credit_Card }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body p-2" *ngIf="paymentMethod != 'ACH' && paymentMethod != 'CREDIT_CARD'">
            <div class="card subcardheight shadow" id="planheader">
              <div class="card-header p-0">
                <img id="singlecardimage" *ngIf="logo" src="{{ logo.paymentMethod.image }}" width="100%" />
              </div>
              <small>
                <span style="font-size: 12px">
                                    Missing Payment Method
                </span>
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
   <!-- Claims Deposit Info -->
<div class="col-12 col-sm-6 col-xxl-3 col-md-4 px-md-0" *ngIf="isVikingCustomer">
  <div class="card dependentDiv">
    <div class="card-header bg-headers d-flex justify-content-between align-items-center">
      <span class="text-white title">{{ lang?.Claims_Payment_Account ?? 'Claims Payment Account' }}</span>
    </div>
    <div class="card-body p-2">
      <div class="card subcardheight shadow" id="planheader">
        <div class="card-header p-0">
          <span class="imagetext" style="font-size: 14px">
            {{ claimsUpdate
              ? (lang?.Claims_Payment_Account ?? 'Claims Payment Account')
              : (lang?.Add_Claims_Payment_Account ?? 'Add Claims Payment Account') }}
          </span>
          <img id="singlecardimage" *ngIf="logo" src="{{ logo.paymentMethod.image }}" width="100%" />
        </div>
        <div class="card-body py-2" id="scrollcard">
          <ng-container *ngIf="claimsUpdate && claimsDepositInfo; else noClaimsData">
            <div class="row">
              <div class="form-group col-4 col-md-12 col-xl-4 pe-0">
                <label class="primaryInfoLabels">{{ lang?.Bank_Id }}</label>
                <div class="primaryInfoLabels">{{ claimsDepositInfo.bankCode }}</div>
              </div>
              <div class="form-group col-4 col-md-12 col-xl-4 paddingStart">
                <label class="primaryInfoLabels">{{ lang?.Transit }}</label>
                <div class="primaryInfoLabels">{{ claimsDepositInfo.transitNumber }}</div>
              </div>
              <div class="form-group col-4 col-md-12 col-xl-4 paddingStart">
                <label class="primaryInfoLabels">{{ lang?.Account }}</label>
                <div class="primaryInfoLabels" style="white-space: nowrap;">{{ claimsDepositInfo.accountNumber?.substring(0, claimsDepositInfo.accountNumber.length - 3) }}***</div>
              </div>
            </div>
            <div class="row" *ngIf="claimsDepositInfo.bankDetails?.address">
              <div class="form-group col-12">
                <label class="primaryInfoLabels">{{ lang?.Bank_Details }}</label>
                <div class="primaryInfoLabels">{{ claimsDepositInfo.bankDetails.bank?.name }} {{ claimsDepositInfo.bankDetails.address.split(',').join(' ') }}</div>
              </div>
            </div>
          </ng-container>
          <ng-template #noClaimsData>
            <small>{{ lang?.No_Claims_Deposit_Info_On_File_Yet ?? 'No claims deposit info on file yet.' }}</small>
          </ng-template>
        </div>
        <div class="card-footer" id="paymentfooter">
          <div class="row align-items-end mt-auto" id="paymentbuttons">
            <button id="viewButton"
              class="btn btn-sm btn-light col-6 mt-2 ms-auto ms-md-0 ms-xl-auto text-nowrap updatepad"
              data-bs-toggle="modal" data-bs-target="#updateClaimsInfo"
              (click)="openClaimsModal()">
              {{ claimsUpdate
                ? (lang?.Update_Claims ?? 'Update Claims')
                : (lang?.Add_Claims ?? 'Add Claims') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

    <!-- Member Information -->
    <div class="col-12 col-sm-6 col-xxl-3 col-md-4 px-md-0">
      <div class="card dependentDiv">
        <div class="card-header text-white bg-headers d-flex justify-content-between align-items-center">
          <span class="title">{{ lang?.Member_Information }}</span>
        </div>
        <div class="card-body p-2">
          <div class="card shadow subcardheight" id="planInfoCard">
            <div class="card-header p-0" *ngIf="logo">
              <img id="singlecardimage" src="{{ logo.personalInfo.image }}" width="100%" />
            </div>
            <div class="card-body py-2" id="scrollcard" *ngIf="customerData">
              <div>
                <i class="fa fa-pencil-square-o icon" style="float: right" role="button" data-bs-toggle="modal"
                  data-bs-target="#updateAddress" (click)="updateAddressForm()"></i>
              </div>

              <div>
                <div class="row">
                  <div class="col-1 ps-1">
                    <img src="/assets/img/planholder.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                      data-bs-placement="top" title="Name" />
                  </div>
                  <div class="col-10 mt-auto primaryInfoLabels">
                    {{ customerData.firstName | titlecase }}
                    {{ customerData.lastName | titlecase }}
                  </div>
                </div>
                <div class="row" *ngIf="!waddelCustomer">
                  <div class="col-1 ps-1">
                    <img src="/assets/img/gender.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                      data-bs-placement="top" title="Gender" />
                  </div>
                  <div class="col-10 mt-auto primaryInfoLabels">
                    {{ gender }}
                  </div>
                </div>
                <div class="row" *ngIf="!waddelCustomer">
                  <div class="col-1 ps-1">
                    <img src="/assets/img/dob2.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                      data-bs-placement="top" title="{{ lang?.Date_of_Birth }}" />
                  </div>
                  <div class="col-10 mt-auto primaryInfoLabels">
                    {{ customerData.dob | customDate }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-1 ps-1">
                    <img src="/assets/img/email.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                      data-bs-placement="top" title="{{ lang?.Email }}" />
                  </div>
                  <div class="col-10 mt-auto primaryInfoLabels">
                    {{ customerData.email }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-1 ps-1">
                    <img src="/assets/img/mobile.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                      data-bs-placement="top" title="{{ lang?.Mobile }}" />
                  </div>
                  <div class="col-10 mt-auto primaryInfoLabels">
                    {{ customerData.primaryPhone }}
                  </div>
                </div>
                <div class="row" *ngIf="customerData.secondaryPhone">
                  <div class="col-1 ps-1">
                    <img src="/assets/img/tel.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                      data-bs-placement="top" title="{{ lang?.Telephone }}" />
                  </div>
                  <div class="col-10 mt-auto primaryInfoLabels">
                    {{ customerData.secondaryPhone }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-1 ps-1">
                    <img src="/assets/img/location.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                      data-bs-placement="top" title="{{ lang?.Address }}" />
                  </div>
                  <div class="col-10 mt-auto primaryInfoLabels">
                    {{ customerData?.homeProvinceDetails?.line1 }},
                    <span
                      *ngIf="customerData?.homeProvinceDetails?.line2 && customerData?.homeProvinceDetails?.line2 != ' '">{{
                      customerData?.homeProvinceDetails?.line2 }}, </span>{{ customerData?.homeProvinceDetails?.city }},
                    <div>
                      {{ customerData?.province }}, {{ customerData?.homeProvinceDetails?.postalCode }}
                    </div>

                  </div>
                </div>
                <div class="row" *ngIf="isViking">
                  <div class="col-1 ps-1">
                    <img src="/assets/img/health_card_number.png" width="16px" height="16px" data-bs-toggle="tooltip"
                      data-bs-placement="top" title="provincial Health Card Number" />
                  </div>
                  <div class="col-10 mt-auto primaryInfoLabels">
                    {{ customerData?.additionalDetails?.provinceHealthCareNumber }}
                  </div>
                </div>
                <div class="row" *ngIf="isCorpCustomer==true">
                  <div class="col-1 ps-1">
                    <img src="/assets/img/tier.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                      data-bs-placement="top" title="Tier Name" />
                  </div>
                  <div class="col-10 mt-auto primaryInfoLabels">
                    {{ customerData?.tierInfo?.name }}
                  </div>
                </div>
                <div class="row" *ngIf="!isViking">
                  <div class="col-1 ps-1">
                    <img src="/assets/img/planholder.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                      data-bs-placement="top" title="Company Name" />
                  </div>
                  <div class="col-10 mt-auto primaryInfoLabels">
                    {{ customerData?.companyName }}
                  </div>
                </div>
                <div class="row" *ngIf="!isViking">
                  <div class="col-1 ps-1">
                    <img src="/assets/img/other_coverage.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                      data-bs-placement="top" title="Job Title" />
                  </div>
                  <div class="col-10 mt-auto primaryInfoLabels">
                    {{ customerData?.jobTitle }}
                  </div>
                </div>
                <div class="row" *ngIf="customerData?.employerNameApplicable==true">
                  <div class="col-1 ps-1">
                    <img src="/assets/img/planholder.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                      data-bs-placement="top" title="Employer Name" />
                  </div>
                  <div class="col-10 mt-auto primaryInfoLabels">
                    {{ customerData?.employerName }}
                  </div>
                </div>
                <div class="row" *ngIf="isCorpCustomer==true">
                  <div class="col-1 ps-1">
                    <img src="/assets/img/location.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                      data-bs-placement="top" title="Working Province" />
                  </div>
                  <div class="col-10 mt-auto primaryInfoLabels">
                    {{ customerData?.workingProvince }}
                  </div>
                </div>
                <div class="row" *ngIf="!isViking">
                  <div class="col-1 ps-1">
                    <img src="/assets/img/calender.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                      data-bs-placement="top" title="Working Hours" />
                  </div>
                  <div class="col-10 mt-auto primaryInfoLabels">
                    {{ customerData?.workingHours }}
                  </div>
                </div>
                <div class="row" *ngIf="!isViking">
                  <div class="col-1 ps-1">
                    <img src="/assets/img/date.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                      data-bs-placement="top" title="Hiring Date" />
                  </div>
                  <div class="col-10 mt-auto primaryInfoLabels">
                    {{ customerData?.hiringDate | customDate }}
                  </div>
                </div>
                <div class="row" *ngIf="isViking && customerData?.additionalDetails?.dateOfRetirement">
                  <div class="col-1 ps-1">
                    <img src="/assets/img/date.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                      data-bs-placement="top" title="Retirement Date" />
                  </div>
                  <div class="col-10 mt-auto primaryInfoLabels">
                    {{ customerData?.additionalDetails?.dateOfRetirement | customDate }}
                  </div>
                </div>
                <div class="row"
                  *ngIf="isViking && customerData?.additionalDetails?.viking_input_data?.viking_policy_number">
                  <div class="col-1 ps-1">
                    <img src="/assets/img/health_card_number.png" width="16px" height="16px" data-bs-toggle="tooltip"
                      data-bs-placement="top" title="Viking Policy Number" />
                  </div>
                  <div class="col-10 mt-auto primaryInfoLabels">
                    {{ customerData?.additionalDetails?.viking_input_data?.viking_policy_number }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Dependents Information -->
    <div class="col-12 col-sm-6 col-xxl-3 col-md-4 px-md-0" *ngIf="!waddelCustomer">
      <div class="card dependentDiv">
        <div class="card-header bg-headers d-flex justify-content-between align-items-center">
          <span class="text-white title">{{ lang?.Dependent_Info }}</span>
        </div>
        <div class="card-body p-2">
          <section id="tranding" *ngIf="childrenInfo && childrenInfo.length > 1">
            <div class="container"></div>
            <div class="container">
              <div class="swiper tranding-slider">
                <div class="swiper-wrapper">
                  <!-- Slide-start -->
                  <div class="swiper-slide tranding-slide" *ngFor="let children of childrenInfo; let i = index">
                    <div class="card activecard">
                      <div class="card-header p-0" *ngIf="logo">
                        <div *ngIf="children.relationType == 'spouse'">
                          <img id="image" src="{{ logo.dependents.SPOUSE.images.MALE }}" width="100%" />
                        </div>
                        <div *ngIf="children.relationType == 'child'">
                          <img id="image" *ngIf="children.gender == 'Male'"
                            src="{{ logo.dependents.CHILDREN.images.MALE }}" width="100%" />
                          <img id="image" *ngIf="children.gender == 'Female'"
                            src="{{ logo.dependents.CHILDREN.images.FEMALE }}" width="100%" />
                          <img id="image" *ngIf="
                                children.gender == 'Non-Binary' ||
                                children.gender == 'Undisclosed'
                              " src="{{
                                logo.dependents.CHILDREN.images.UNDISCLOSED
                              }}" width="100%" />
                        </div>
                      </div>

                      <div class="card-body py-2 px-1" [style.background-color]="dependentBackgroundColor[i]">
                        <div class="planBody">

                          <div>
                            <i class="fa fa-pencil-square-o icon" style="float: right" role="button"
                              data-bs-toggle="modal" data-bs-target="#updateDependent"
                              (click)="updateDependentForm(children, 'one')"></i>
                          </div>

                          <div class="row mx-0">
                            <div class="col-1 px-1">
                              <img src="/assets/img/user.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                title="{{ lang?.Dependent_Name }}" id="carousellogos" />
                            </div>
                            <div class="col-11 ps-2">
                              <span class="carousellabels">
                                {{ children.firstName | titlecase }}
                                {{ children.lastName | titlecase }}
                              </span>
                            </div>
                          </div>
                          <div class="row mx-0">
                            <div class="col-1 px-1">
                              <img src="/assets/img/dob2.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                title="{{ lang?.Date_of_Birth }}" id="carousellogos" />
                            </div>
                            <div class="col-11 ps-2">
                              <span class="carousellabels">
                                {{ children.dob | customDate }}
                              </span>
                            </div>
                          </div>
                          <div class="row mx-0">
                            <div class="col-1 px-1">
                              <img src="/assets/img/gender.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                title="Gender" id="carousellogos" />
                            </div>
                            <div class="col-11 ps-2">
                              <span class="carousellabels">
                                {{ children.gender }}
                              </span>
                            </div>
                          </div>
                          <div class="row mx-0" *ngIf="
                                children.relationType == 'child' &&
                                children.specialNeeds == 'true' &&
                                !!children?.specialNeeds
                              ">
                            <div class="col-1 px-1">
                              <img src="/assets/img/special_needs.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                title="{{ lang?.Dependent_with_Special_Needs }}" id="carousellogos" />
                            </div>
                            <div class="col-11 ps-2">
                              <span class="carousellabels">
                                {{ children.specialNeeds }}
                              </span>
                            </div>
                          </div>
                          <div class="row mx-0" *ngIf="
                                children.relationType == 'child' &&
                                !!children?.graduationDate
                              ">
                            <div class="col-1 px-1">
                              <img src="/assets/img/graduation_date.svg" data-bs-toggle="tooltip"
                                data-bs-placement="top" title="{{ lang?.Graduation_Date }}" id="carousellogos" />
                            </div>
                            <div class="col-11 ps-2">
                              <span class="carousellabels">
                                {{ children.graduationDate | customDate }}
                              </span>
                            </div>
                          </div>
                          <div class="row mx-0" *ngIf="
                                children.relationType == 'spouse' &&
                                !!children?.insurer
                              ">
                            <div class="col-1 px-1">
                              <img src="/assets/img/other_coverage.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                title="{{ lang?.Name_of_the_Carrier }}" id="carousellogos" />
                            </div>
                            <div class="col-11 ps-2">
                              <span class="carousellabels">
                                {{ children.insurer | titlecase }}
                              </span>
                            </div>
                          </div>
                          <div class="row mx-0" *ngIf="
                                children.relationType == 'child' &&
                                !!children?.carrierName
                              ">
                            <div class="col-1 px-1">
                              <img src="/assets/img/other_coverage.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                title="{{ lang?.Name_of_the_Carrier }}" id="carousellogos" />
                            </div>
                            <div class="col-11 ps-2">
                              <span class="carousellabels">
                                {{ children.carrierName | titlecase }}
                              </span>
                            </div>
                          </div>
                          <div class="row mx-0" *ngIf="
                                children.relationType == 'spouse' &&
                                !!children?.healthPlan
                              ">
                            <div class="col-1 px-1">
                              <img src="/assets/img/coverage.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                title="{{ lang?.COB }}" id="carousellogos" />
                            </div>
                            <div class="col-11 ps-2">
                              <span class="carousellabels">
                                {{ children.healthPlan }}
                              </span>
                            </div>
                          </div>

                          <div class="row mx-0" *ngIf="
                                children.relationType == 'spouse' && !!children?.maritalType
                              ">
                            <div class="col-1 px-1">
                              <img src="/assets/img/coverage.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                title="Marital Type" id="carousellogos" />
                            </div>
                            <div class="col-11 ps-2">
                              <span class="carousellabels">
                                {{ children.maritalType ?? "" }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="tranding-slider-control">
                  <div class="swiper-button-prev slider-arrow" (change)="onSlideChangeDependents($event)">
                    <i class="fa fa-angle-left" style="font-size: 20px"></i>
                  </div>
                  <div class="swiper-button-next slider-arrow" (click)="onSlideChangeDependents($event)">
                    <i class="fa fa-angle-right" style="font-size: 20px"></i>
                  </div>
                  <div class="swiper-pagination"></div>
                </div>
              </div>
            </div>
          </section>
          <div *ngIf="childrenInfo && childrenInfo.length == 1">
            <div class="card shadow singledependentcard subcardheight"
              *ngFor="let children of childrenInfo; let i = index">
              <div class="card-header p-0" *ngIf="logo">
                <div *ngIf="children.relationType == 'spouse'">
                  <img id="singlecardimage" src="{{ logo.dependents.SPOUSE.images.MALE }}" width="100%" />
                </div>
                <div *ngIf="children.relationType == 'child'">
                  <img id="image" *ngIf="children.gender == 'Male'" src="{{ logo.dependents.CHILDREN.images.MALE }}"
                    width="100%" />
                  <img id="image" *ngIf="children.gender == 'Female'" src="{{ logo.dependents.CHILDREN.images.FEMALE }}"
                    width="100%" />
                  <img id="image" *ngIf="
                        children.gender == 'Non-Binary' ||
                        children.gender == 'Undisclosed'
                      " src="{{ logo.dependents.CHILDREN.images.UNDISCLOSED }}" width="100%" />
                </div>
              </div>

              <div class="card-body py-2 px-1" [style.background-color]="dependentBackgroundColor[i]"
                id="singledependent">
                <div class="planBody">

                  <div>
                    <i class="fa fa-pencil-square-o icon" style="float: right" role="button" data-bs-toggle="modal"
                      data-bs-target="#updateDependent" (click)="updateDependentForm(children, 'two')"></i>
                  </div>

                  <div class="row mx-0">
                    <div class="col-1 px-1">
                      <img src="/assets/img/user.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                        title="{{ lang?.Dependent_Name }}" id="carousellogos" />
                    </div>
                    <div class="col-11 ps-2">
                      <span class="carousellabels">
                        {{ children.firstName | titlecase }}
                        {{ children.lastName | titlecase }}
                      </span>
                    </div>
                  </div>
                  <div class="row mx-0">
                    <div class="col-1 px-1">
                      <img src="/assets/img/gender.svg" data-bs-toggle="tooltip" data-bs-placement="top" title="Gender"
                        id="carousellogos" />
                    </div>
                    <div class="col-11 ps-2">
                      <span class="carousellabels">
                        {{ children.gender }}
                      </span>
                    </div>
                  </div>
                  <div class="row mx-0">
                    <div class="col-1 px-1">
                      <img src="/assets/img/dob2.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                        title="{{ lang?.Date_of_Birth }}" id="carousellogos" />
                    </div>
                    <div class="col-11 ps-2">
                      <span class="carousellabels"> {{ children.dob | customDate }} </span>
                    </div>
                  </div>

                  <div class="row mx-0" *ngIf="
                        children.relationType == 'child' &&
                        children.specialNeeds == 'true' &&
                        !!children?.specialNeeds
                      ">
                    <div class="col-1 px-1">
                      <img src="/assets/img/special_needs.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                        title="{{ lang?.Dependent_with_Special_Needs }}" id="carousellogos" />
                    </div>
                    <div class="col-11 ps-2">
                      <span class="carousellabels">
                        {{ children.specialNeeds }}
                      </span>
                    </div>
                  </div>
                  <div class="row mx-0" *ngIf="
                        children.relationType == 'child' &&
                        !!children?.graduationDate
                      ">
                    <div class="col-1 px-1">
                      <img src="/assets/img/graduation_date.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                        title="{{ lang?.Graduation_Date }}" id="carousellogos" />
                    </div>
                    <div class="col-11 ps-2">
                      <span class="carousellabels">
                        {{ children.graduationDate | customDate }}
                      </span>
                    </div>
                  </div>
                  <div class="row mx-0" *ngIf="
                        children.relationType == 'spouse' && !!children?.insurer
                      ">
                    <div class="col-1 px-1">
                      <img src="/assets/img/other_coverage.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                        title="{{ lang?.Name_of_the_Carrier }}" id="carousellogos" />
                    </div>
                    <div class="col-11 ps-2">
                      <span class="carousellabels">
                        {{ children.insurer | titlecase }}
                      </span>
                    </div>
                  </div>
                  <div class="row mx-0" *ngIf="
                        children.relationType == 'child' && !!children?.carrierName
                      ">
                    <div class="col-1 px-1">
                      <img src="/assets/img/other_coverage.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                        title="{{ lang?.Name_of_the_Carrier }}" id="carousellogos" />
                    </div>
                    <div class="col-11 ps-2">
                      <span class="carousellabels">
                        {{ children.carrierName | titlecase }}
                      </span>
                    </div>
                  </div>
                  <div class="row mx-0" *ngIf="
                        children.relationType == 'spouse' && !!children?.healthPlan
                      ">
                    <div class="col-1 px-1">
                      <img src="/assets/img/coverage.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                        title="{{ lang?.COB }}" id="carousellogos" />
                    </div>
                    <div class="col-11 ps-2">
                      <span class="carousellabels">
                        {{ children.healthPlan }}
                      </span>
                    </div>
                  </div>

                  <div class="row mx-0" *ngIf="
                    children.relationType == 'spouse' && !!children?.maritalType
                  ">
                    <div class="col-1 px-1">
                      <img src="/assets/img/coverage.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                        title="Marital Type" id="carousellogos" />
                    </div>
                    <div class="col-11 ps-2">
                      <span class="carousellabels">
                        {{ children.maritalType ?? "" }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="childrenInfo && childrenInfo.length <= 0">
            <div class="card shadow singledependentcard subcardheight">
              <div class="card-header p-0">
                <div>
                  <img id="singlecardimage" *ngIf="logo" src="{{ logo.dependents.SPOUSE.images.MALE }}" width="100%" />
                </div>
              </div>

              <div class="card-body py-2 px-1" id="singledependent">
                <div class="planBody">
                  <small>{{ lang?.Member_has_no_dependents }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Life Event change -->
    <div class="col-12 col-sm-6 col-xxl-3 col-md-4 px-md-0" *ngIf="!waddelCustomer">
      <div class="card dependentDiv">
        <div class="card-header text-white bg-headers d-flex justify-content-between align-items-center">
          <span class="title">{{ lang?.Life_Event_Change }}</span>
        </div>
        <div class="card-body p-2">
          <div class="card subcardheight shadow" id="planheader">
            <div class="card-header p-0" *ngIf="logo">
              <span class="imagetext">{{ lang?.Life_Event_Change }}</span>
              <img id="singlecardimage" *ngIf="logo" src="{{ logo.lifeChnageEvent.image }}" width="100%" />
            </div>
            <div class="card-body py-2" id="scrollcard">

              <div style="display: flex; align-items: center;">
                <div style="font-size: 12px;">
                  Add or Remove your spouse and/or child(ren)
                </div>
                <div>
                  <app-add-dependent [formConfig]="formConfiguration"
                    [customerDataInput]="customerData"></app-add-dependent>

                </div>

              </div>
              <span style="font-size: 12px; margin-top: 10px;"><b>Note:</b> All life event changes must be reported in
                the portal within <b>30 days</b> of occurrence. Failing to do so may result in delay or decline of
                coverage based on insurer's review. You may also be subject to medical review to qualify for
                coverage.</span>


              <!-- Show history regarding life change event -->
              <div style="margin-top: 12px;">
                <b>History: </b><br />
                <div *ngFor="let item of lecHistory; let i = index" class="history-line">
                  <div class="event-text">
                    <span class="event-label" style="font-size: 12px;">
                      {{ item.event | titlecase }} -
                      {{ item.eventType === 'add' ? 'Added' : 'Removed' }} on {{item.effectiveDate| customDate }}
                    </span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Beneficiaries -->
    <div class="col-12 col-sm-6 col-xxl-3 col-md-4 px-md-0" *ngIf="beneficiaries?.length > 1 && false">
      <div class="card dependentDiv">
        <div class="card-header bg-headers d-flex justify-content-between align-items-center">
          <span class="text-white title">Beneficiaries</span>
          <button *ngIf="isViking" (click)="openBeneficiaryListModal()" data-bs-toggle="modal"
            data-bs-target="#beneficiaryListModal" style="border: 0px; border-radius: 5px; font-size: 12px; padding: 2px; padding-left: 10px; padding-right: 10px;">
            {{ beneficiaries?.length == 0 ? 'Add' : 'Edit' }}
          </button>
        </div>
        <div class="card-body p-2">
          <section id="tranding">
            <div class="container">
              <div class="swiper tranding-slider">
                <div class="swiper-wrapper">
                  <div class="swiper-slide tranding-slide" *ngFor="let beneficiary of beneficiaries; let i = index">
                    <div class="card activecard">
                      <div class="card-header p-0" style="height: 70px;">
                        <img *ngIf="i % 2 == 0" id="image" src="../../assets/img/life.png" width="100%" height="100%"
                          style="object-fit:cover;" />
                        <img *ngIf="i % 2 == 1" id="image" src="../../assets/img/critical1.png" width="100%"
                          height="100%" style="object-fit:cover;" />
                      </div>
                      <div class="card-body py-2 px-1">
                        <div class="planBody">
                          <div class="row mb-1">
                            <div class="col-12 carousellabels">
                              <div class="row mx-0 d-flex align-items-center">
                                <div class="col-1 px-1">
                                  <img src="/assets/img/user.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="Beneficiary Name" id="carousellogos" />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels">
                                    {{ beneficiary?.firstName | titlecase }}
                                    {{ beneficiary?.lastName | titlecase }}
                                  </span>
                                </div>
                              </div>
                              <div class="row mx-0 d-flex align-items-center">
                                <div class="col-1 px-1">
                                  <img src="/assets/img/dob2.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="{{ lang?.Date_of_Birth }}" id="carousellogos" />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels">
                                    {{ beneficiary?.dob | customDate }}
                                  </span>
                                </div>
                              </div>
                              <div class="row mx-0 d-flex align-items-center"
                                *ngIf="beneficiary?.gender != null && beneficiary?.gender != undefined && beneficiary?.gender != ''">
                                <div class="col-1 px-1">
                                  <img src="/assets/img/gender.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="Gender" id="carousellogos" />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels">
                                    {{ beneficiary?.gender || "" }}
                                  </span>
                                </div>
                              </div>
                              <div class="row mx-0 d-flex align-items-center"
                                *ngIf="beneficiary?.customerType != null && beneficiary?.customerType != undefined && beneficiary?.customerType != ''">
                                <div class="col-1 px-1">
                                  <img src="/assets/img/planholder.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="Customer Type" id="carousellogos" />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels">
                                    {{ capitalizeFirstLetter(beneficiary?.customerType || "") }}
                                  </span>
                                </div>
                              </div>
                              <div class="row mx-0 d-flex align-items-center">
                                <div class="col-1 px-1">
                                  <img src="/assets/img/other_coverage.svg" data-bs-toggle="tooltip"
                                    data-bs-placement="top" title="Relationship" id="carousellogos" />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels text-capitalize">
                                    {{ removeUnderscores(beneficiary?.relationship) || "" }}
                                  </span>
                                </div>
                              </div>
                              <div class="row mx-0 d-flex align-items-center">
                                <div class="col-1 px-0">
                                  <img src="/assets/img/percentage.png" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="Percentage" id="carousellogos" class="w-100" />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels text-capitalize">
                                    {{ beneficiary?.percentage || "" }}
                                  </span>
                                </div>
                              </div>
                              <div
                                *ngIf="beneficiary?.trusteeDetails?.firstName != '' && beneficiary?.trusteeDetails?.firstName != undefined">
                                <p class="mb-0 mt-1" style="font-weight: bold;">
                                  Trustee Details
                                </p>
                                <div class="row mx-0 d-flex align-items-center">
                                  <div class="col-1 px-1">
                                    <img src="/assets/img/user.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                      title="Trustee Name" id="carousellogos" />
                                  </div>
                                  <div class="col-11 ps-2">
                                    <span class="carousellabels">
                                      {{ beneficiary?.trusteeDetails?.firstName | titlecase }}
                                      {{ beneficiary?.trusteeDetails?.lastName | titlecase }}
                                    </span>
                                  </div>
                                </div>
                                <div class="row mx-0 d-flex align-items-center">
                                  <div class="col-1 px-1">
                                    <img src="/assets/img/other_coverage.svg" data-bs-toggle="tooltip"
                                      data-bs-placement="top" title="Relationship" id="carousellogos" />
                                  </div>
                                  <div class="col-11 ps-2">
                                    <span class="carousellabels text-capitalize">
                                      {{ removeUnderscores(beneficiary?.relationship) || "" }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div *ngIf="
                                beneficiary?.contactDetails?.contingentBeneficiary?.firstName !='' && 
                                beneficiary?.contactDetails?.contingentBeneficiary?.firstName != undefined">
                                <p class="mb-0 mt-1" style="font-weight: bold;">Contingent Details</p>
                                <div class="row mx-0 d-flex align-items-center">
                                  <div class="col-1 px-1">
                                    <img src="/assets/img/user.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                      title="Contingent Name" id="carousellogos" />
                                  </div>
                                  <div class="col-11 ps-2">
                                    <span class="carousellabels">
                                      {{ beneficiary?.contactDetails?.contingentBeneficiary?.firstName | titlecase }}
                                      {{ beneficiary?.contactDetails?.contingentBeneficiary?.lastName | titlecase }}
                                    </span>
                                  </div>
                                </div>
                              </div>


                            </div>
                            <div class="col-3 d-flex ps-0"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tranding-slider-control">
                  <div class="swiper-button-prev slider-arrow">
                    <i class="fa fa-angle-left" style="font-size: 20px"></i>
                  </div>
                  <div class="swiper-button-next slider-arrow">
                    <i class="fa fa-angle-right" style="font-size: 20px"></i>
                  </div>
                  <div class="swiper-pagination"></div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>

    <!-- without slider -->
    <div class="col-12 col-sm-6 col-xxl-3 col-md-4 px-md-0" *ngIf="beneficiaries?.length == 1 && false">
      <div class="card dependentDiv" style="width: 98%">
        <div class="card-header text-white bg-headers d-flex justify-content-between align-items-center">
          <span class="title">Beneficiaries</span>
          <button *ngIf="isViking" (click)="openBeneficiaryListModal()" data-bs-toggle="modal"
            data-bs-target="#beneficiaryListModal" style="border: 0px; border-radius: 5px; font-size: 12px; padding: 2px; padding-left: 10px; padding-right: 10px;">
            {{ beneficiaries?.length == 0 ? 'Add' : 'Edit' }}
          </button>
        </div>
        <div class="card-body p-2">
          <div class="card subcardheight shadow" id="planheader" *ngFor="let beneficiary of beneficiaries">
            <div class="card-header p-0">
              <img id="singlecardimage" src="../../assets/img/life.png" width="100%" />
            </div>
            <div class="card-body py-2 px-1">
              <div class="planBody">
                <div class="row mb-1">
                  <div class="col-12 carousellabels">
                    <div class="row mx-0 d-flex align-items-center">
                      <div class="col-1 px-1">
                        <img src="/assets/img/user.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                          title="Beneficiary Name" id="carousellogos" />
                      </div>
                      <div class="col-11 ps-2">
                        <span class="carousellabels">
                          {{ beneficiary?.firstName | titlecase }}
                          {{ beneficiary?.lastName | titlecase }}
                        </span>
                      </div>
                    </div>
                    <div class="row mx-0 d-flex align-items-center">
                      <div class="col-1 px-1">
                        <img src="/assets/img/dob2.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                          title="{{ lang?.Date_of_Birth }}" id="carousellogos" />
                      </div>
                      <div class="col-11 ps-2">
                        <span class="carousellabels">
                          {{ beneficiary?.dob | customDate }}
                        </span>
                      </div>
                    </div>
                    <div class="row mx-0 d-flex align-items-center"
                      *ngIf="beneficiary?.gender != null && beneficiary?.gender != undefined && beneficiary?.gender != ''">
                      <div class="col-1 px-1">
                        <img src="/assets/img/gender.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                          title="Gender" id="carousellogos" />
                      </div>
                      <div class="col-11 ps-2">
                        <span class="carousellabels">
                          {{ beneficiary?.gender || "" }}
                        </span>
                      </div>
                    </div>
                    <div class="row mx-0 d-flex align-items-center"
                      *ngIf="beneficiary?.customerType != null && beneficiary?.customerType != undefined && beneficiary?.customerType != ''">
                      <div class="col-1 px-1">
                        <img src="/assets/img/planholder.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                          title="Customer Type" id="carousellogos" />
                      </div>
                      <div class="col-11 ps-2">
                        <span class="carousellabels">
                          {{ capitalizeFirstLetter(beneficiary?.customerType || "") }}
                        </span>
                      </div>
                    </div>
                    <div class="row mx-0 d-flex align-items-center">
                      <div class="col-1 px-1">
                        <img src="/assets/img/other_coverage.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                          title="Relationship" id="carousellogos" />
                      </div>
                      <div class="col-11 ps-2">
                        <span class="carousellabels text-capitalize">
                          {{ removeUnderscores(beneficiary?.relationship) || "" }}
                        </span>
                      </div>
                    </div>
                    <div class="row mx-0 d-flex align-items-center">
                      <div class="col-1 px-0">
                        <img src="/assets/img/percentage.png" data-bs-toggle="tooltip" data-bs-placement="top"
                          title="Percentage" id="carousellogos" class="w-100" />
                      </div>
                      <div class="col-11 ps-2">
                        <span class="carousellabels text-capitalize">
                          {{ beneficiary?.percentage || "" }}
                        </span>
                      </div>
                    </div>
                    <div
                      *ngIf="beneficiary?.trusteeDetails?.firstName != '' && beneficiary?.trusteeDetails?.firstName != undefined">
                      <p class="mb-0 mt-1" style="font-weight: bold;">
                        Trustee Details
                      </p>
                      <div class="row mx-0 d-flex align-items-center">
                        <div class="col-1 px-1">
                          <img src="/assets/img/user.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                            title="Trustee Name" id="carousellogos" />
                        </div>
                        <div class="col-11 ps-2">
                          <span class="carousellabels">
                            {{ beneficiary?.trusteeDetails?.firstName | titlecase }}
                            {{ beneficiary?.trusteeDetails?.lastName | titlecase }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="
                    beneficiary?.contactDetails?.contingentBeneficiary?.firstName !='' && 
                    beneficiary?.contactDetails?.contingentBeneficiary?.firstName != undefined">
                      <p class="mb-0 mt-1" style="font-weight: bold;">Contingent Details</p>
                      <div class="row mx-0 d-flex align-items-center">
                        <div class="col-1 px-1">
                          <img src="/assets/img/user.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                            title="Contingent Name" id="carousellogos" />
                        </div>
                        <div class="col-11 ps-2">
                          <span class="carousellabels">
                            {{ beneficiary?.contactDetails?.contingentBeneficiary?.firstName | titlecase }}
                            {{ beneficiary?.contactDetails?.contingentBeneficiary?.lastName | titlecase }}
                          </span>
                        </div>
                      </div>
                    </div>


                  </div>
                  <div class="col-3 d-flex ps-0"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Beneficiaries -->
    <div class="col-md-4 px-md-0 col-xxl-3">
      <div class="card dependentDiv">
        <div class="card-header bg-headers d-flex justify-content-between align-items-center">
          <span class="text-white title">Beneficiaries</span>
          <button (click)="openBeneficiaryListModal()" data-bs-toggle="modal" data-bs-target="#beneficiaryListModal"
            style="border: 0px; border-radius: 5px; padding: 1px 5px;">
            {{ beneficiaries?.length == 0 ? 'Add' : 'Edit' }}
          </button>
        </div>
        <div class="card-body p-2">

          <!-- Multiple beneficiaries: slider WITH pagination -->
          <section id="tranding" *ngIf="beneficiaries?.length > 1">
            <div class="container">
              <div class="swiper tranding-slider">
                <div class="swiper-wrapper">
                  <div class="swiper-slide tranding-slide" *ngFor="let beneficiary of beneficiaries; let i = index">
                    <div class="card activecard">
                      <div class="card-header p-0" style="height: 70px;">
                        <img *ngIf="i % 2 == 0" id="image" src="../../assets/img/life.png" width="100%" height="100%"
                          style="object-fit:cover;" />
                        <img *ngIf="i % 2 == 1" id="image" src="../../assets/img/critical1.png" width="100%"
                          height="100%" style="object-fit:cover;" />
                      </div>
                      <div class="card-body py-2 px-1">
                        <div class="planBody">
                          <div class="row mb-1">
                            <div class="col-12 carousellabels">
                              <div class="row mx-0 d-flex align-items-center">
                                <div class="col-1 px-1">
                                  <img src="/assets/img/user.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="Beneficiary Name" id="carousellogos" />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels">
                                    {{ beneficiary?.firstName | titlecase }}
                                    {{ beneficiary?.lastName | titlecase }}
                                  </span>
                                </div>
                              </div>
                              <div class="row mx-0 d-flex align-items-center" *ngIf="!!beneficiary?.dob">
                                <div class="col-1 px-1">
                                  <img src="/assets/img/dob2.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="{{ lang?.Date_of_Birth }}" id="carousellogos" />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels">
                                    {{ beneficiary?.dob | customDate }}
                                  </span>
                                </div>
                              </div>
                              <div class="row mx-0 d-flex align-items-center"
                                *ngIf="beneficiary?.gender != null && beneficiary?.gender != undefined && beneficiary?.gender != ''">
                                <div class="col-1 px-1">
                                  <img src="/assets/img/gender.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="Gender" id="carousellogos" />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels">
                                    {{ beneficiary?.gender || "" }}
                                  </span>
                                </div>
                              </div>
                              <div class="row mx-0 d-flex align-items-center"
                                *ngIf="beneficiary?.customerType != null && beneficiary?.customerType != undefined && beneficiary?.customerType != ''">
                                <div class="col-1 px-1">
                                  <img src="/assets/img/planholder.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="Customer Type" id="carousellogos" />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels">
                                    {{ capitalizeFirstLetter(beneficiary?.customerType || "") }}
                                  </span>
                                </div>
                              </div>
                              <div class="row mx-0 d-flex align-items-center">
                                <div class="col-1 px-1">
                                  <img src="/assets/img/other_coverage.svg" data-bs-toggle="tooltip"
                                    data-bs-placement="top" title="Relationship" id="carousellogos" />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels text-capitalize">
                                    {{ removeUnderscores(beneficiary?.relationship) || "" }}
                                  </span>
                                </div>
                              </div>
                              <div class="row mx-0 d-flex align-items-center">
                                <div class="col-1 px-0">
                                  <img src="/assets/img/percentage.png" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="Percentage" id="carousellogos" class="w-100" />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels text-capitalize">
                                    {{ beneficiary?.percentage ?? "" }}
                                  </span>
                                </div>
                              </div>
                              <div class="row mx-0 d-flex align-items-center"
                                *ngIf="beneficiary?.additionalDetails?.phoneNumber">
                                <div class="col-1 px-1">
                                  <img src="/assets/img/mobile.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="Phone Number" id="carousellogos" />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels">{{ beneficiary?.additionalDetails?.phoneNumber }}</span>
                                </div>
                              </div>
                              <div class="row mx-0 d-flex align-items-center"
                                *ngIf="beneficiary?.additionalDetails?.email">
                                <div class="col-1 px-1">
                                  <img src="/assets/img/email.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="Email" id="carousellogos" />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels">{{ beneficiary?.additionalDetails?.email }}</span>
                                </div>
                              </div>
                              <div
                                *ngIf="beneficiary?.trusteeDetails?.firstName != '' && beneficiary?.trusteeDetails?.firstName != undefined">
                                <p class="mb-0 mt-1" style="font-weight: bold;">
                                  Trustee Details
                                </p>
                                <div class="row mx-0 d-flex align-items-center">
                                  <div class="col-1 px-1">
                                    <img src="/assets/img/user.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                      title="Trustee Name" id="carousellogos" />
                                  </div>
                                  <div class="col-11 ps-2">
                                    <span class="carousellabels">
                                      {{ beneficiary?.trusteeDetails?.firstName | titlecase }}
                                      {{ beneficiary?.trusteeDetails?.lastName | titlecase }}
                                    </span>
                                  </div>
                                </div>
                                <div class="row mx-0 d-flex align-items-center">
                                  <div class="col-1 px-1">
                                    <img src="/assets/img/other_coverage.svg" data-bs-toggle="tooltip"
                                      data-bs-placement="top" title="Relationship" id="carousellogos" />
                                  </div>
                                  <div class="col-11 ps-2">
                                    <span class="carousellabels text-capitalize">
                                      {{ removeUnderscores(beneficiary?.relationship) || "" }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div *ngIf="
                            beneficiary?.contactDetails?.contingentBeneficiary?.firstName !='' &&
                            beneficiary?.contactDetails?.contingentBeneficiary?.firstName != undefined">
                                <p class="mb-0 mt-1" style="font-weight: bold;">Contingent Details</p>
                                <div class="row mx-0 d-flex align-items-center">
                                  <div class="col-1 px-1">
                                    <img src="/assets/img/user.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                      title="Contingent Name" id="carousellogos" />
                                  </div>
                                  <div class="col-11 ps-2">
                                    <span class="carousellabels">
                                      {{ beneficiary?.contactDetails?.contingentBeneficiary?.firstName | titlecase }}
                                      {{ beneficiary?.contactDetails?.contingentBeneficiary?.lastName | titlecase }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-3 d-flex ps-0"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- pagination only shows here, since this block only renders when length > 1 -->
                <div class="tranding-slider-control">
                  <div class="swiper-button-prev slider-arrow" (change)="onSlideChangeDependents($event)">
                    <i class="fa fa-angle-left" style="font-size: 20px"></i>
                  </div>
                  <div class="swiper-button-next slider-arrow" (click)="onSlideChangeDependents($event)">
                    <i class="fa fa-angle-right" style="font-size: 20px"></i>
                  </div>
                  <div class="swiper-pagination"></div>
                </div>
              </div>
            </div>
          </section>

          <!-- Exactly one beneficiary: single card, NO pagination -->
          <div *ngIf="beneficiaries?.length == 1">
            <div class="card shadow singledependentcard subcardheight" *ngFor="let beneficiary of beneficiaries">
              <div class="card-header p-0">
                <img id="singlecardimage" src="../../assets/img/life.png" width="100%" />
              </div>
              <div class="card-body py-2 px-1" id="singledependent">
                <div class="planBody">
                  <div class="row mx-0 d-flex align-items-center">
                    <div class="col-1 px-1">
                      <img src="/assets/img/user.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                        title="Beneficiary Name" id="carousellogos" />
                    </div>
                    <div class="col-11 ps-2">
                      <span class="carousellabels">
                        {{ beneficiary?.firstName | titlecase }}
                        {{ beneficiary?.lastName | titlecase }}
                      </span>
                    </div>
                  </div>
                  <div class="row mx-0 d-flex align-items-center" *ngIf="!!beneficiary?.dob">
                    <div class="col-1 px-1">
                      <img src="/assets/img/dob2.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                        title="{{ lang?.Date_of_Birth }}" id="carousellogos" />
                    </div>
                    <div class="col-11 ps-2">
                      <span class="carousellabels">
                        {{ beneficiary?.dob | customDate }}
                      </span>
                    </div>
                  </div>
                  <div class="row mx-0 d-flex align-items-center"
                    *ngIf="beneficiary?.gender != null && beneficiary?.gender != undefined && beneficiary?.gender != ''">
                    <div class="col-1 px-1">
                      <img src="/assets/img/gender.svg" data-bs-toggle="tooltip" data-bs-placement="top" title="Gender"
                        id="carousellogos" />
                    </div>
                    <div class="col-11 ps-2">
                      <span class="carousellabels">
                        {{ beneficiary?.gender || "" }}
                      </span>
                    </div>
                  </div>
                  <div class="row mx-0 d-flex align-items-center"
                    *ngIf="beneficiary?.customerType != null && beneficiary?.customerType != undefined && beneficiary?.customerType != ''">
                    <div class="col-1 px-1">
                      <img src="/assets/img/planholder.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                        title="Customer Type" id="carousellogos" />
                    </div>
                    <div class="col-11 ps-2">
                      <span class="carousellabels">
                        {{ capitalizeFirstLetter(beneficiary?.customerType || "") }}
                      </span>
                    </div>
                  </div>
                  <div class="row mx-0 d-flex align-items-center">
                    <div class="col-1 px-1">
                      <img src="/assets/img/other_coverage.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                        title="Relationship" id="carousellogos" />
                    </div>
                    <div class="col-11 ps-2">
                      <span class="carousellabels text-capitalize">
                        {{ removeUnderscores(beneficiary?.relationship) || "" }}
                      </span>
                    </div>
                  </div>
                  <div class="row mx-0 d-flex align-items-center">
                    <div class="col-1 px-0">
                      <img src="/assets/img/percentage.png" data-bs-toggle="tooltip" data-bs-placement="top"
                        title="Percentage" id="carousellogos" class="w-100" />
                    </div>
                    <div class="col-11 ps-2">
                      <span class="carousellabels text-capitalize">
                        {{ beneficiary?.percentage ?? "" }}
                      </span>
                    </div>
                  </div>
                  <div class="row mx-0 d-flex align-items-center" *ngIf="beneficiary?.additionalDetails?.phoneNumber">
                    <div class="col-1 px-1">
                      <img src="/assets/img/mobile.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                        title="Phone Number" id="carousellogos" />
                    </div>
                    <div class="col-11 ps-2">
                      <span class="carousellabels">{{ beneficiary?.additionalDetails?.phoneNumber }}</span>
                    </div>
                  </div>
                  <div class="row mx-0 d-flex align-items-center" *ngIf="beneficiary?.additionalDetails?.email">
                    <div class="col-1 px-1">
                      <img src="/assets/img/email.svg" data-bs-toggle="tooltip" data-bs-placement="top" title="Email"
                        id="carousellogos" />
                    </div>
                    <div class="col-11 ps-2">
                      <span class="carousellabels">{{ beneficiary?.additionalDetails?.email }}</span>
                    </div>
                  </div>
                  <div
                    *ngIf="beneficiary?.trusteeDetails?.firstName != '' && beneficiary?.trusteeDetails?.firstName != undefined">
                    <p class="mb-0 mt-1" style="font-weight: bold;">
                      Trustee Details
                    </p>
                    <div class="row mx-0 d-flex align-items-center">
                      <div class="col-1 px-1">
                        <img src="/assets/img/user.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                          title="Trustee Name" id="carousellogos" />
                      </div>
                      <div class="col-11 ps-2">
                        <span class="carousellabels">
                          {{ beneficiary?.trusteeDetails?.firstName | titlecase }}
                          {{ beneficiary?.trusteeDetails?.lastName | titlecase }}
                        </span>
                      </div>
                    </div>
                    <div class="row mx-0 d-flex align-items-center">
                      <div class="col-1 px-1">
                        <img src="/assets/img/other_coverage.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                          title="Relationship" id="carousellogos" />
                      </div>
                      <div class="col-11 ps-2">
                        <span class="carousellabels text-capitalize">
                          {{ removeUnderscores(beneficiary?.relationship) || "" }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="
                beneficiary?.contactDetails?.contingentBeneficiary?.firstName !='' &&
                beneficiary?.contactDetails?.contingentBeneficiary?.firstName != undefined">
                    <p class="mb-0 mt-1" style="font-weight: bold;">Contingent Details</p>
                    <div class="row mx-0 d-flex align-items-center">
                      <div class="col-1 px-1">
                        <img src="/assets/img/user.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                          title="Contingent Name" id="carousellogos" />
                      </div>
                      <div class="col-11 ps-2">
                        <span class="carousellabels">
                          {{ beneficiary?.contactDetails?.contingentBeneficiary?.firstName | titlecase }}
                          {{ beneficiary?.contactDetails?.contingentBeneficiary?.lastName | titlecase }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- No beneficiaries: empty state, NO pagination -->
          <div *ngIf="beneficiaries?.length == 0">
            <div class="card shadow subcardheight" id="planheader">
              <div class="card-header p-0">
                <span class="imagetext1">{{ lang?.Beneficiaries || 'Beneficiaries' }}</span>
                <img id="singlecardimage" src="../../assets/img/life.png" width="100%" />
              </div>
              <div class="card-body py-2 px-1" id="singledependent">
                <div class="planBody">
                  <div class="row mx-0">
                    No beneficiaries added yet
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- LI & CI and AUPE -->
    <ng-container *ngFor="let lifePlan of lifePlansData; let z = index">
      <ng-container *ngIf="getMatchingPlans(lifePlan).length > 1">
        <div class="col-12 col-xxl-6 col-md-8 px-md-0">
          <div class="card dependentDiv">
            <div class="card-header bg-headers d-flex justify-content-between align-items-center">
              <span class="text-white title">
                {{
                lifePlan.name.toLowerCase().includes('aupe')
                ? 'Optional Life and AD&D' :
                lifePlan.name.toLowerCase().includes('all-state')
                ? lifePlan?.name ?? 'All-State Critical Illness'
                : lang?.Life_and_Critical_Illness_Insurance ?? 'Life and Critical Illness Insurance'
                }}
              </span>
            </div>
            <div class="card-body p-2">
              <section id="tranding">
                <div class="container"></div>
                <div class="container">
                  <div class="swiper tranding-slider">
                    <div class="swiper-wrapper">
                      <div class="swiper-slide tranding-slide" style="width: 520px"
                        *ngFor="let plan of getMatchingPlans(lifePlan); let i = index">
                        <div class="card activecard">
                          <div class="card-header p-0">
                            <span class="imagetext1">{{plan.name}}</span>
                            <img *ngIf="i % 2 == 0" id="image" src="../../assets/img/life.png" width="100%" />
                            <img *ngIf="i % 2 == 1" id="image" src="../../assets/img/critical1.png" width="100%" />
                          </div>
                          <div class="card-body py-2 px-1">
                            <div class="planBody">
                              <div class="row mb-1">
                                <div class="col-12 carousellabels">
                                  <div [ngClass]="
                                    plan?.spouse && hasSpouseData(plan?.spouse)
                                      ? 'member-spouse'
                                      : 'member'
                                  ">
                                    <p class="mb-0">{{ plan.name }}</p>
                                    <div class="row">
                                      <div class="col-4"></div>
                                      <div class="col-4">
                                        <b
                                          *ngIf="plan?.selectedDetails?.products?.[0]?.coverage == 'MEMBER & FAMILY'; else normalMember">{{
                                          lang?.Member_Family ?? 'Member & Family' }}</b>
                                        <ng-template #normalMember>{{ lang?.Member }}</ng-template>
                                      </div>
                                      <div class="col-4" *ngIf="plan?.spouse && hasSpouseData(plan?.spouse)">
                                        <b>{{ lang?.Spouse }}</b>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-4"></div>
                                      <div class="col-4 text-nowrap">
                                        <img src="../../assets/img/smoker.png" width="20px" *ngIf="plan.member.smoker"
                                          title="Smoker" />
                                        <img src="../../assets/img/non-smoker.png" width="20px"
                                          *ngIf="!plan.member.smoker" title="Non-Smoker" />
                                        <span *ngIf="plan.member.gender == 'male'" title="Male"> (M) </span>
                                        <span *ngIf="plan.member.gender != 'male'" title="Female"> (F) </span>
                                        {{ plan.member.age }}
                                      </div>
                                      <div class="col-4 text-nowrap"
                                        *ngIf="plan?.spouse && hasSpouseData(plan?.spouse)">
                                        <img src="../../assets/img/smoker.png" width="20px" *ngIf="plan?.spouse.smoker"
                                          title="Smoker" />
                                        <img src="../../assets/img/non-smoker.png" width="20px"
                                          *ngIf="!plan?.spouse.smoker" title="Non-Smoker" />
                                        <span *ngIf="plan?.spouse.gender == 'male'" title="Male"> (M) </span>
                                        <span *ngIf="plan?.spouse.gender != 'male'" title="Female"> (F) </span>
                                        {{ plan?.spouse.age }}
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-4">{{ lang?.Coverage }}</div>
                                      <div class="col-4 text-nowrap">
                                        {{
                                        formatNumber(plan.member.coverageValue)
                                        }} units
                                      </div>
                                      <div class="col-4 text-nowrap"
                                        *ngIf="plan?.spouse && hasSpouseData(plan?.spouse)">
                                        {{
                                        formatNumber(plan?.spouse.coverageValue)
                                        }} units
                                      </div>
                                    </div>
                                    <div class="row"
                                      *ngIf="!plan.name.includes('Critical') && !lifePlan.name.toLowerCase().includes('aupe')">
                                      <div class="col-4 text-nowrap">
                                        {{ lang?.Beneficiary }}
                                      </div>
                                      <div class="col-4 text-nowrap">
                                        {{ benficiaryIsMemberDetails.firstName }}
                                        {{
                                        benficiaryIsMemberDetails.lastName
                                        }}&nbsp;
                                        <i class="fa fa-eye eye-show" role="button" data-bs-toggle="modal"
                                          data-bs-target="#viewBeneficiary"
                                          (click)="addBeneficiary(0, 'member')"></i>&nbsp;
                                        <i class="fa fa-pencil-square-o icon" role="button" data-bs-toggle="modal"
                                          data-bs-target="#updateBeneficiary" (click)="addBeneficiary(0, 'member')"></i>
                                      </div>
                                      <div class="col-4 text-nowrap"
                                        *ngIf="plan?.spouse && hasSpouseData(plan?.spouse)">
                                        {{ benficiaryIsSpouseDetails.firstName }}
                                        {{
                                        benficiaryIsSpouseDetails.lastName
                                        }}&nbsp;
                                        <i class="fa fa-eye eye-show" role="button" data-bs-toggle="modal"
                                          data-bs-target="#viewBeneficiary"
                                          (click)="addBeneficiary(0, 'spouse')"></i>&nbsp;
                                        <i class="fa fa-pencil-square-o icon" role="button" data-bs-toggle="modal"
                                          data-bs-target="#updateBeneficiary" (click)="addBeneficiary(0, 'spouse')"></i>
                                      </div>
                                    </div>

                                    <div class="row" *ngIf="lifePlan.name.toLowerCase().includes('aupe')">
                                      <div class="col-4">Premium</div>
                                      <div class="col-4">${{plan?.member?.premium}}</div>
                                      <div class="col-4" *ngIf="plan?.spouse">
                                        {{ plan?.spouse?.premium == 0 ? 'No coverage' : ('$' + plan?.spouse?.premium) }}
                                      </div>
                                      <div class="col-4" *ngIf="!plan?.spouse"></div>

                                      <div class="col-4"></div>
                                      <div class="col-4">(per {{formatNumber(plan.member.defaultRange)}} units)</div>
                                      <div class="col-4" *ngIf="plan?.spouse && plan?.spouse?.premium > 0">(per
                                        {{formatNumber(plan?.spouse.defaultRange)}} units)</div>
                                    </div>

                                    <div class="row"
                                      *ngIf="!lifePlan.name.toLowerCase().includes('aupe') && !lifePlan.name.toLowerCase().includes('all-state')">
                                      <div class="col-4 text-nowrap">
                                        {{ lang?.Guaranteed }}
                                      </div>
                                      <div class="col-4 text-nowrap">
                                        {{ formatNumber(plan.member.defaultUnits) }}
                                      </div>
                                      <div class="col-4 text-nowrap"
                                        *ngIf="plan?.spouse && hasSpouseData(plan?.spouse)">
                                        {{ formatNumber(plan?.spouse.defaultUnits) }}
                                      </div>
                                    </div>
                                    <div class="row"
                                      *ngIf="!lifePlan.name.toLowerCase().includes('aupe') && !lifePlan.name.toLowerCase().includes('all-state')">
                                      <div class="col-4"></div>
                                      <div class="col-4">
                                        <div *ngIf="plan.member.coverageValue > plan.member.defaultUnits">
                                          {{ lang?.Coverage_exceeds_guaranteed_amount ?? 'Coverage exceeds guaranteed
                                          amount'}}
                                        </div>
                                      </div>
                                      <div class="col-4" *ngIf="plan?.spouse && hasSpouseData(plan?.spouse)">
                                        <div *ngIf="plan?.spouse.coverageValue > plan?.spouse.defaultUnits">
                                          {{ lang?.Coverage_exceeds_guaranteed_amount ?? 'Coverage exceeds guaranteed
                                          amount'}}
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row"
                                      *ngIf="!lifePlan.name.toLowerCase().includes('aupe') && !lifePlan.name.toLowerCase().includes('all-state')">
                                      <div class="col-3"></div>
                                      <div class="col-4 text-nowrap">

                                        <button *ngIf="plan.member.coverageValue < plan.member.defaultUnits"
                                          class="form-group btn btn-sm btn-light text-nowrap" id="viewButton"
                                          (click)="navigateToUpgradePlans()">
                                          {{ lang?.Top_up_to_guaranteed }}
                                        </button>
                                      </div>

                                      <div class="col-4 text-nowrap"
                                        *ngIf="plan?.spouse && hasSpouseData(plan?.spouse) && plan?.spouse.coverageValue < plan?.spouse?.defaultUnits">
                                        <button class="form-group btn btn-sm btn-light text-nowrap" id="viewButton"
                                          (click)="navigateToUpgradePlans()">
                                          {{ lang?.Top_up_to_guaranteed }}
                                        </button>
                                      </div>
                                    </div>
                                    <div class="row" *ngIf="
                                      pendingMedicalQuestionaire &&
                                      (plan.member.coverageValue >
                                        plan.member.defaultRange ||
                                        plan?.spouse.coverageValue >
                                          plan?.spouse.defaultRange)
                                      && !lifePlan.name.toLowerCase().includes('aupe')
                                      && !lifePlan.name.toLowerCase().includes('all-state')
                                    ">
                                      <div class="col-4 text-wrap d-flex align-items-center">
                                        {{ lang?.Medical_Questionnaire_Pending }}
                                      </div>
                                      <div class="col-4">
                                        <button class="form-group btn btn-sm btn-light text-nowrap" *ngIf="
                                          plan.member.coverageValue >
                                          plan.member.defaultRange
                                        " id="viewButton" (click)="
                                          navigateToQuestions(
                                            pendingMedicalQuestionaireCoverage
                                          )
                                        ">
                                          {{ lang?.Complete_Submit }}
                                        </button>
                                      </div>
                                      <div class="col-4" *ngIf="plan?.spouse && hasSpouseData(plan?.spouse)">
                                        <button class="form-group btn btn-sm btn-light text-nowrap" *ngIf="
                                          plan?.spouse.coverageValue >
                                          plan?.spouse.defaultRange
                                        " id="viewButton" (click)="
                                          navigateToQuestions(
                                            pendingMedicalQuestionaireCoverage
                                          )
                                        ">
                                          {{ lang?.Complete_Submit }}
                                        </button>
                                      </div>
                                    </div>
                                    <div class="row text-nowrap" *ngIf="
                                      !pendingMedicalQuestionaire &&
                                      iafgSubscriptionConfirmation &&
                                      (plan.member.coverageValue >
                                        plan.member.defaultRange ||
                                        plan?.spouse.coverageValue >
                                          plan?.spouse.defaultRange)
                                      && !lifePlan.name.toLowerCase().includes('aupe')
                                      && !lifePlan.name.toLowerCase().includes('all-state')
                                    ">
                                      <div class="col-4 d-flex align-items-center">
                                        {{ lang?.Medical_Questionnaire_Status }}
                                      </div>
                                      <div class="col-4 text-wrap">
                                        <span *ngIf="
                                          plan.member.coverageValue >
                                          plan.member.defaultRange
                                        ">
                                          {{ lang?.Submitted_on }}
                                          {{ registrationDate }}
                                          {{ lang?.and_pending_approval }}
                                        </span>
                                      </div>
                                      <div class="col-4 text-wrap" *ngIf="plan?.spouse && hasSpouseData(plan?.spouse)">
                                        <span *ngIf="
                                          plan?.spouse.coverageValue >
                                          plan?.spouse.defaultRange
                                        ">
                                          {{ lang?.Submitted_on }}
                                          {{ registrationDate }}
                                          {{ lang?.and_pending_approval }}
                                        </span>
                                      </div>
                                    </div>
                                    <div class="row"
                                      *ngIf="!lifePlan.name.toLowerCase().includes('aupe') && !lifePlan.name.toLowerCase().includes('all-state')">
                                      <div class="col-4 d-flex align-items-center">
                                        {{ lang?.Max_Coverage }} {{
                                        plan.member.maximumCoverageWithEvidence
                                        ? formatNumber(
                                        plan.member
                                        .maximumCoverageWithEvidence
                                        )
                                        : formatNumber(
                                        plan?.spouse
                                        .maximumCoverageWithEvidence
                                        )
                                        }}
                                      </div>
                                      <div class="col-4" *ngIf="
                                        (plan.member.coverageValue !=
                                        plan.member.maximumCoverageWithEvidence)
                                        && !lifePlan.name.toLowerCase().includes('all-state')
                                      ">
                                        <button class="form-group btn btn-sm btn-light text-nowrap" id="viewButton"
                                          (click)="navigateToUpgradePlans()">
                                          {{ lang?.Increase_Coverage }}
                                        </button>
                                      </div>
                                      <div class="col-4" *ngIf="
                                        plan?.spouse && hasSpouseData(plan?.spouse) &&
                                        (plan?.spouse.coverageValue !=
                                        plan?.spouse.maximumCoverageWithEvidence)
                                      ">
                                        <button class="form-group btn btn-sm btn-light text-nowrap" id="viewButton"
                                          (click)="navigateToUpgradePlans()">
                                          {{ lang?.Increase_Coverage }}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-3 d-flex ps-0"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tranding-slider-control">
                      <div class="swiper-button-prev slider-arrow">
                        <i class="fa fa-angle-left" style="font-size: 20px"></i>
                      </div>
                      <div class="swiper-button-next slider-arrow">
                        <i class="fa fa-angle-right" style="font-size: 20px"></i>
                      </div>
                      <div class="swiper-pagination"></div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <!-- without slider -->
    <ng-container *ngFor="let lifePlan of lifePlansData; let z = index">
      <ng-container *ngIf="getMatchingPlans(lifePlan).length == 1">
        <div class="col-12 col-xxl-6 col-md-8 px-md-0">
          <div class="card dependentDiv">
            <div class="card-header text-white bg-headers d-flex justify-content-between align-items-center">
              <span class="title">
                {{
                lifePlan.name.toLowerCase().includes('aupe')
                ? 'Optional Life and AD&D' :
                lifePlan.name.toLowerCase().includes('all-state')
                ? lifePlan.name
                : lang?.Life_and_Critical_Illness_Insurance ?? 'Life and Critical Illness Insurance'
                }}
              </span>
              <div class="ms-auto col-2 mt-auto text-end title"></div>
            </div>
            <div class="card-body p-2">
              <div class="card subcardheight shadow" id="planheader"
                *ngFor="let plan of getMatchingPlans(lifePlan); let i = index">
                <div class="card-header p-0">
                  <span class="imagetext1">{{plan.name}}</span>
                  <img id="singlecardimage" src="../../assets/img/life.png" width="100%" />
                </div>
                <div class="card-body py-2 px-1">
                  <div class="planBody">
                    <div class="row mb-1">
                      <div class="col-12 carousellabels">
                        <div [ngClass]="
                          hasSpouseData(plan?.spouse) ? 'member-spouse' : 'member'
                        ">
                          <p class="mb-0">{{ plan.name }}</p>
                          <div class="row">
                            <div class="col-4"></div>
                            <div class="col-4">
                              <b
                                *ngIf="plan?.selectedDetails?.products?.[0]?.coverage == 'MEMBER & FAMILY'; else normalMember">{{
                                lang?.Member_Family ?? 'Member & Family' }}</b>
                              <ng-template #normalMember>{{ lang?.Member }}</ng-template>
                            </div>
                            <div class="col-4" *ngIf="plan?.spouse && hasSpouseData(plan?.spouse)">
                              <b>{{ lang?.Spouse }}</b>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-4"></div>
                            <div class="col-4 text-nowrap">
                              <img src="../../assets/img/smoker.png" width="20px" *ngIf="plan.member.smoker"
                                title="Smoker" />
                              <img src="../../assets/img/non-smoker.png" width="20px" *ngIf="!plan.member.smoker"
                                title="Non-Smoker" />
                              <span *ngIf="plan.member.gender == 'male'" title="Male"> (M) </span>
                              <span *ngIf="plan.member.gender != 'male'" title="Female"> (F) </span>
                              {{ plan.member.age }}
                            </div>
                            <div class="col-4 text-nowrap" *ngIf="plan?.spouse && hasSpouseData(plan?.spouse)">
                              <img src="../../assets/img/smoker.png" width="20px" *ngIf="plan?.spouse.smoker"
                                title="Smoker" />
                              <img src="../../assets/img/non-smoker.png" width="20px" *ngIf="!plan?.spouse.smoker"
                                title="Non-Smoker" />
                              <span *ngIf="plan?.spouse.gender == 'male'" title="Male"> (M) </span>
                              <span *ngIf="plan?.spouse.gender != 'male'" title="Female"> (F) </span>
                              {{ plan?.spouse.age }}
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-4">{{ lang?.Coverage }}</div>
                            <div class="col-4 text-nowrap">
                              {{ formatNumber(plan.member.coverageValue) }} units
                            </div>
                            <div class="col-4 text-nowrap" *ngIf="plan?.spouse && hasSpouseData(plan?.spouse)">
                              {{ formatNumber(plan?.spouse.coverageValue) }} units
                            </div>
                          </div>
                          <div class="row"
                            *ngIf="!plan.name.includes('Critical') && !lifePlan.name.toLowerCase().includes('aupe')">
                            <div class="col-4 text-nowrap">
                              {{ lang?.Beneficiary }}
                            </div>
                            <div class="col-4 text-nowrap text-capitalize">
                              {{ benficiaryIsMemberDetails.firstName }}
                              {{ benficiaryIsMemberDetails.lastName }}&nbsp;
                              <i class="fa fa-eye eye-show" role="button" data-bs-toggle="modal"
                                data-bs-target="#viewBeneficiary" (click)="addBeneficiary(0, 'member')"></i>&nbsp;
                              <i class="fa fa-pencil-square-o icon" role="button" data-bs-toggle="modal"
                                data-bs-target="#updateBeneficiary" (click)="addBeneficiary(0, 'member')"></i>
                            </div>
                            <div class="col-4 text-nowrap text-capitalize"
                              *ngIf="plan?.spouse && hasSpouseData(plan?.spouse)">
                              {{ benficiaryIsSpouseDetails.firstName }}
                              {{ benficiaryIsSpouseDetails.lastName }}&nbsp;
                              <i class="fa fa-eye eye-show" role="button" data-bs-toggle="modal"
                                data-bs-target="#viewBeneficiary" (click)="addBeneficiary(0, 'spouse')"></i>&nbsp;
                              <i class="fa fa-pencil-square-o icon" role="button" data-bs-toggle="modal"
                                data-bs-target="#updateBeneficiary" (click)="addBeneficiary(0, 'spouse')"></i>
                            </div>
                          </div>

                          <div class="row" *ngIf="lifePlan.name.toLowerCase().includes('aupe')">
                            <div class="col-4">Premium</div>
                            <div class="col-4">${{plan?.member?.premium}}</div>
                            <div class="col-4" *ngIf="plan?.spouse && hasSpouseData(plan?.spouse)">
                              ${{plan?.spouse?.premium}}</div>
                            <div class="col-4" *ngIf="!plan?.spouse"></div>

                            <div class="col-4"></div>
                            <div class="col-4">(per {{formatNumber(plan.member.defaultRange)}} units)</div>
                            <div class="col-4" *ngIf="plan?.spouse && hasSpouseData(plan?.spouse)">(per
                              {{formatNumber(plan?.spouse.defaultRange)}} units)</div>
                          </div>

                          <div class="row"
                            *ngIf="!lifePlan.name.toLowerCase().includes('aupe') && !lifePlan.name.toLowerCase().includes('all-state')">
                            <div class="col-4 text-nowrap">
                              {{ lang?.Guaranteed }}
                            </div>
                            <div class="col-4 text-nowrap">
                              {{ formatNumber((plan?.member?.maximumCoverageWithoutEvidence >=
                              plan?.member?.coverageValue)
                              ? plan?.member?.coverageValue
                              : plan?.member?.maximumCoverageWithoutEvidence) }}
                            </div>
                            <div class="col-4 text-nowrap" *ngIf="plan?.spouse && hasSpouseData(plan?.spouse)">
                              {{ formatNumber((plan?.spouse?.maximumCoverageWithoutEvidence >=
                              plan?.spouse?.coverageValue)
                              ? plan?.spouse?.coverageValue
                              : plan?.spouse?.maximumCoverageWithoutEvidence) }}
                            </div>
                          </div>
                          <div class="row"
                            *ngIf="!lifePlan.name.toLowerCase().includes('aupe') && !lifePlan.name.toLowerCase().includes('all-state')">
                            <div class="col-4"></div>
                            <div class="col-4">
                              <div *ngIf="
                                plan.member.coverageValue >
                                plan.member.defaultRange
                              ">
                                {{ lang?.Coverage_exceeds_guaranteed_amount }}
                              </div>
                            </div>
                            <div class="col-4">
                              <div *ngIf="
                                plan?.spouse && hasSpouseData(plan?.spouse) &&
                                plan?.spouse.coverageValue >
                                plan?.spouse.defaultRange
                              ">
                                {{ lang?.Coverage_exceeds_guaranteed_amount }}
                              </div>
                            </div>
                          </div>
                          <div class="row"
                            *ngIf="!lifePlan.name.toLowerCase().includes('aupe') && !lifePlan.name.toLowerCase().includes('all-state')">
                            <div class="col-3"></div>
                            <div class="col-4 text-nowrap">
                              <button *ngIf="
                                plan.member.coverageValue <
                                plan.member.defaultRange
                              " class="form-group btn btn-sm btn-light text-nowrap" id="viewButton"
                                (click)="navigateToUpgradePlans()">
                                {{ lang?.Top_up_to_guaranteed }}
                              </button>
                            </div>
                            <div class="col-4 text-nowrap" *ngIf="
                              plan?.spouse && hasSpouseData(plan?.spouse) &&
                              plan?.spouse.coverageValue < plan?.spouse.defaultRange
                            ">
                              <button class="form-group btn btn-sm btn-light text-nowrap" id="viewButton"
                                (click)="navigateToUpgradePlans()">
                                {{ lang?.Top_up_to_guaranteed }}
                              </button>
                            </div>
                          </div>
                          <div class="row" *ngIf="
                            pendingMedicalQuestionaire &&
                            (plan.member.coverageValue >
                              plan.member.defaultRange ||
                              plan?.spouse.coverageValue >
                                plan?.spouse.defaultRange)
                            && !lifePlan.name.toLowerCase().includes('aupe')
                            && !lifePlan.name.toLowerCase().includes('all-state')
                          ">
                            <div class="col-4 text-wrap d-flex align-items-center">
                              {{ lang?.Medical_Questionnaire_Pending }}
                            </div>
                            <div class="col-4">
                              <button class="form-group btn btn-sm btn-light text-nowrap" *ngIf="
                                plan.member.coverageValue >
                                plan.member.defaultRange
                              " id="viewButton" (click)="
                                navigateToQuestions(
                                  pendingMedicalQuestionaireCoverage
                                )
                              ">
                                {{ lang?.Complete_Submit }}
                              </button>
                            </div>
                            <div class="col-4" *ngIf="plan?.spouse && hasSpouseData(plan?.spouse)">
                              <button class="form-group btn btn-sm btn-light text-nowrap" *ngIf="
                                plan?.spouse.coverageValue >
                                plan?.spouse.defaultRange
                              " id="viewButton" (click)="
                                navigateToQuestions(
                                  pendingMedicalQuestionaireCoverage
                                )
                              ">
                                {{ lang?.Complete_Submit }}
                              </button>
                            </div>
                          </div>
                          <div class="row text-nowrap" *ngIf="
                            !pendingMedicalQuestionaire &&
                            iafgSubscriptionConfirmation &&
                            (plan.member.coverageValue >
                              plan.member.defaultRange ||
                              plan?.spouse.coverageValue >
                                plan?.spouse.defaultRange)
                            && !lifePlan.name.toLowerCase().includes('aupe')
                            && !lifePlan.name.toLowerCase().includes('all-state')
                          ">
                            <div class="col-4 d-flex align-items-center">
                              {{ lang?.Medical_Questionnaire_Status }}
                            </div>
                            <div class="col-4 text-wrap">
                              <span *ngIf="
                                plan.member.coverageValue >
                                plan.member.defaultRange
                              ">
                                {{ lang?.Submitted_on }} {{ registrationDate }}
                                {{ lang?.and_pending_approval }}
                              </span>
                            </div>
                            <div class="col-4 text-wrap" *ngIf="plan?.spouse && hasSpouseData(plan?.spouse)">
                              <span *ngIf="
                                plan?.spouse.coverageValue >
                                plan?.spouse.defaultRange
                              ">
                                {{ lang?.Submitted_on }} {{ registrationDate }}
                                {{ lang?.and_pending_approval }}
                              </span>
                            </div>
                          </div>
                          <div class="row"
                            *ngIf="!lifePlan.name.toLowerCase().includes('aupe') && !lifePlan.name.toLowerCase().includes('all-state')">
                            <div class="col-4 d-flex align-items-center">
                              {{ lang?.Max_Coverage }} {{
                              plan.member.maximumCoverageWithEvidence
                              ? formatNumber(
                              plan.member.maximumCoverageWithEvidence
                              )
                              : formatNumber(
                              plan?.spouse.maximumCoverageWithEvidence
                              )
                              }}
                            </div>
                            <div class="col-4" *ngIf="
                              (plan.member.coverageValue !=
                              plan.member.maximumCoverageWithEvidence) &&
                              !plan.name.toLowerCase().includes('aupe')
                            ">
                              <button class="form-group btn btn-sm btn-light text-nowrap" id="viewButton"
                                (click)="navigateToUpgradePlans()">
                                {{ lang?.Increase_Coverage }}
                              </button>
                            </div>
                            <div class="col-4" *ngIf="
                            plan?.spouse && hasSpouseData(plan?.spouse) &&
                              (plan?.spouse.coverageValue !=
                              plan?.spouse.maximumCoverageWithEvidence) &&
                              !plan.name.toLowerCase().includes('aupe')
                            ">
                              <button class="form-group btn btn-sm btn-light text-nowrap" id="viewButton"
                                (click)="navigateToUpgradePlans()">
                                {{ lang?.Increase_Coverage }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-3 d-flex ps-0"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <!-- usecase 3 -- when additionalDetails.length=0-->
    <div class="col-12 col-xxl-6 col-md-8 px-md-0" *ngIf="showIAFG && additionalDetails?.length == 0 && iafgDays > 0">
      <div class="card dependentDiv" style="width: 98%">
        <div class="card-header text-white bg-headers d-flex justify-content-between align-items-center">
          <span class="title">{{
            lang?.Life_and_Critical_Illness_Insurance
            }}</span>
          <div class="ms-auto col-2 mt-auto text-end title"></div>
        </div>
        <div class="card-body p-2">
          <div class="card subcardheight shadow" id="planheader">
            <div class="card-header p-0">
              <img id="singlecardimage" src="../../assets/img/life.png" width="100%" />
            </div>
            <div class="card-body py-2 px-1">
              <div class="planBody">
                <div class="mb-1">
                  <div class="carousellabels">
                    <div class="row text-nowrap px-2">
                      <div class="col-8 text-wrap">
                        {{ lang?.You_have }} {{ iafgDays }}
                        {{
                        lang?.days_left_to_get_Life_and_Critical_Illness_Insurance_with_guaranteed_acceptance
                        }}
                      </div>
                      <div class="col-4">
                        <button class="form-group btn btn-sm btn-light text-nowrap" id="viewButton"
                          (click)="navigateToUpgradePlans()">
                          Add Life & CI
                        </button>
                      </div>
                    </div>
                  </div>
                                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- new scenario -- when iafg is false -->
        <div class="col-12 col-xxl-6 col-md-8 px-md-0" *ngIf="false">
      <div class="card dependentDiv" style="width: 98%">
        <div class="card-header text-white bg-headers d-flex justify-content-between align-items-center">
          <span class="title">{{
            lang?.Life_and_Critical_Illness_Insurance
            }}</span>
          <div class="ms-auto col-2 mt-auto text-end title"></div>
        </div>
        <div class="card-body p-2">
          <div class="card subcardheight shadow" id="planheader">
            <div class="card-header p-0">
              <img id="singlecardimage" src="../../assets/img/life.png" width="100%" />
            </div>
            <div class="card-body py-2 px-1">
              <div class="planBody">
                <div class="mb-1">
                  <div class="carousellabels">
                    <div class="row text-nowrap px-2">
                      <div class="col-8 text-wrap">
                        {{ lang?.You_have }} {{ iafgDays }}
                        {{
                        lang?.days_left_to_get_Life_and_Critical_Illness_Insurance_with_guaranteed_acceptance
                        }}.
                      </div>
                      <div class="col-4">
                        <button class="form-group btn btn-sm btn-light text-nowrap" id="viewButton"
                          (click)="navigateToUpgradePlans()">
                          {{lang?.Add}} Life & CI
                        </button>
                      </div>
                    </div>
                  </div>
                                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Address Update Modal -->
<div id="updateAddress" class="modal modalposition" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered" [ngClass]="{'modal-lg': isViking}">
    <div class="modal-content">
      <div class="modal-header" id="backgroundColor">
        <h6 class="modal-title">{{ lang?.Update_Member_Information }}</h6>
        <i #closeAddressmodal class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
      </div>
      <div class="modal-body" style="max-height: 70vh; overflow-y: auto">
        <form [formGroup]="addressform">
          <div class="row">
            <div class="col-6 form-group">
              <label id="modal-labels">{{ lang?.First_Name }}<span style="color: red">*</span></label>
              <input type="tel" id="primaryPhone" placeholder="Primary" formControlName="firstName"
                class="form-control" />
              <div *ngIf="addressForm['firstName'].touched && addressForm['firstName'].invalid"
                class="help-block text-danger">
                <div *ngIf="addressForm['firstName'].errors && addressForm['firstName'].errors['required']">
                  {{lang?.Please_enter_first_name}}
                </div>
              </div>
            </div>
            <div class="col-6 form-group">
              <label id="modal-labels">{{ lang?.Last_Name }}</label>
              <input type="tel" id="secondaryPhone" placeholder="Secondary" formControlName="lastName"
                class="form-control" />
              <div *ngIf="addressForm['lastName'].touched && addressForm['lastName'].invalid"
                class="help-block text-danger">
                <div *ngIf="addressForm['lastName'].errors && addressForm['lastName'].errors['required']">
                  {{lang?.Please_enter_last_name}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6 form-group">
              <label id="modal-labels">{{ lang?.Email }}<span style="color: red">*</span></label>
              <input type="tel" id="primaryPhone" placeholder="Primary" formControlName="email" class="form-control" />
              <div *ngIf="addressForm['email'].touched && addressForm['email'].invalid" class="help-block text-danger">
                <div *ngIf="addressForm['email'].errors && addressForm['email'].errors['required']">
                  {{ lang?.Please_enter_email }}
                </div>
                <div *ngIf="addressForm['email'].errors && addressForm['email'].errors['pattern']">
                  {{ lang?.Please_enter_valid_email }}
                </div>
              </div>
            </div>
            <div class="col-6 form-group">
              <label id="modal-labels">{{ lang?.Date_of_Birth }}<span style="color: red">*</span></label>
              <input type="text" placeholder="MM-DD-YYYY" class="form-control checking-field" formControlName="dob"
                [minDate]="minDate" (blur)="checkDateOfBirth($event)" [maxDate]="maxDate" bsDatepicker
                [bsConfig]="{ dateInputFormat: 'MMM-DD-YYYY',showWeekNumbers: false }" />
              <div *ngIf="addressForm['dob'].touched && addressForm['dob'].invalid" class="help-block text-danger">
                <div *ngIf="addressForm['dob'].errors && addressForm['dob'].errors['required']">
                  {{ lang?.Please_enter_Date_of_birth }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6 form-group">
              <label id="modal-labels">{{lang?.Gender}}<span style="color: red">*</span></label>
              <select class="form-select" formControlName="gender">
                <option value="">{{ lang.Select }}</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Non-Binary">Non Binary</option>
                <option value="Undisclosed">Undisclosed</option>
              </select>
              <div *ngIf="addressForm['gender'].touched && addressForm['gender'].invalid"
                class="help-block text-danger">
                <div *ngIf="addressForm['gender'].errors && addressForm['gender'].errors['required']">Please select
                  gender
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6 form-group">
              <label id="modal-labels">{{ lang.Primary_Phone }}<span style="color: red">*</span></label>
              <input type="tel" id="primaryPhone" placeholder="Primary" formControlName="primaryPhone"
                class="form-control" (input)="phoneFormat($event)" (blur)="phoneFormat($event)" />
              <div *ngIf="addressForm['primaryPhone'].touched && addressForm['primaryPhone'].invalid"
                class="help-block text-danger">
                <div *ngIf="addressForm['primaryPhone'].errors && addressForm['primaryPhone'].errors['required']">
                  {{ lang?.Please_enter_Primary_Number }}
                </div>
                <div *ngIf="addressForm['primaryPhone'].errors && addressForm['primaryPhone'].errors['tenDigits']">
                  {{ lang?.Phone_number_must_be_equal_to_10_digits }}
                </div>
              </div>
            </div>
            <div class="col-6 form-group">
              <label id="modal-labels">{{ lang?.Secondary }} phone</label>
              <input type="tel" id="secondaryPhone" placeholder="Secondary" formControlName="secondaryPhone"
                class="form-control" (input)="phoneFormat($event)" (blur)="phoneFormat($event)" />
              <div *ngIf="addressForm['secondaryPhone'].touched && addressForm['secondaryPhone'].invalid"
                class="help-block text-danger">
                <div *ngIf="addressForm['secondaryPhone'].errors && addressForm['secondaryPhone'].errors['tenDigits']">
                  {{ lang?.Phone_number_must_be_equal_to_10_digits }}
                </div>
              </div>
              <div class="help-block text-danger" *ngIf="secondaryphonecheck">
                {{ lang?.Phone_number_already_exists }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 form-group mt-2">
              <label id="modal-labels">{{ lang?.Street_Address }}<span style="color: red">*</span></label>
              <input type="text" id="line1" placeholder="{{ lang?.Street_Address }}" formControlName="line1"
                class="form-control" (input)="checkFirstCharacter($event, addressform)" />
              <div *ngIf="addressForm['line1'].touched && addressForm['line1'].invalid" class="help-block text-danger">
                <div *ngIf="addressForm['line1'].errors && addressForm['line1'].errors['required']">
                  {{ lang?.Please_enter_street_address }}
                </div>
              </div>
            </div>
            <div class="col-md-6 form-group mt-2">
              <label id="modal-labels">{{ lang?.Street_Address_Line_2 }}</label>
              <input type="text" id="line2" placeholder="{{ lang?.Street_Address_Line_2 }}" formControlName="line2"
                class="form-control" (input)="checkFirstCharacter($event, addressform)" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 col-6 form-group mt-2">
              <label id="modal-labels">{{ lang?.Country }}<span style="color: red">*</span></label>
              <select class="form-select" formControlName="country">
                <option value="" disabled>{{ lang?.Select }}</option>
                <option value="Canada">Canada</option>
              </select>
              <div *ngIf="addressForm['country'].touched && addressForm['country'].invalid"
                class="help-block text-danger">
                <div *ngIf="addressForm['country'].errors && addressForm['country'].errors['required']">
                  {{ lang?.Please_select_country }}
                </div>
              </div>
            </div>
            <div class="col-md-3 col-6 form-group mt-2">
              <label id="modal-labels">{{ lang?.City }}<span style="color: red">*</span></label>
              <input type="text" id="city" placeholder="City" formControlName="city" class="form-control" (keypress)="
                    (($event.charCode >= 65 && $event.charCode < 91) ||
                      ($event.charCode >= 97 && $event.charCode < 123) ||
                      $event.charCode == 32)
                  " (input)="checkFirstCharacter($event, addressform)" />
              <div *ngIf="addressForm['city'].touched && addressForm['city'].invalid" class="help-block text-danger">
                <div *ngIf="addressForm['city'].errors && addressForm['city'].errors['required']">
                  {{ lang?.Please_enter_city }}
                </div>
              </div>
            </div>
            <div class="col-md-3 col-6 form-group mt-2" *ngIf="formConfiguration">
              <label id="modal-labels">{{ lang?.Province }}<span style="color: red">*</span></label>
              <select class="form-select" formControlName="province" (change)="provincelist($event)">
                <option value="" disabled>{{ lang?.Select }}</option>
                <option *ngFor="let state of provianceList" [value]="state.shortName">
                  {{ state.shortName }}
                </option>
              </select>
              <div *ngIf="addressForm['province'].touched && addressForm['province'].invalid"
                class="help-block text-danger">
                <div *ngIf="addressForm['province'].errors && addressForm['province'].errors['required']">
                  {{ lang?.Please_select_province }}
                </div>
              </div>
            </div>
            <div class="col-md-3 col-6 form-group mt-2">
              <label id="modal-labels">{{ lang?.Postal_Code }}<span style="color: red">*</span></label>
              <input type="text" id="postalCode" placeholder="Postal Code" formControlName="postalCode"
                class="form-control" (input)="changeTextToUppercase($event)" />
              <div *ngIf="addressForm['postalCode'].touched && addressForm['postalCode'].invalid"
                class="help-block text-danger">
                <div *ngIf="addressForm['postalCode'].errors && addressForm['postalCode'].errors['required']">
                  {{ lang?.Please_enter_postal_code }}
                </div>
              </div>
              <div class="help-block text-danger" *ngIf="
                    (addressForm['postalCode'].touched && addressForm['postalCode'].hasError('invalidPostalCode')) ||
                    addressForm['postalCode'].invalid ||
                    (invalidpostalcodeprivince && !addressForm['province'].hasError('required'))
                  ">
                {{ lang?.Please_enter_valid_postal_code }}
              </div>
            </div>
          </div>

          <!-- Viking only -->
          <div class="row" *ngIf="isViking">
            <div class="col-md-6 col-6 form-group mt-2">
              <label id="modal-labels">Initial</label>
              <input type="text" placeholder="Initial" formControlName="initial" class="form-control" />
            </div>
            <div class="col-md-6 col-6 form-group mt-2">
              <label id="modal-labels">Province Health Card Number</label>
              <input type="text" placeholder="Province Health Card Number" formControlName="provinceHealthCareNumber"
                class="form-control" />
            </div>
          </div>
          <div class="row" *ngIf="isViking">
            <div class="col-md-6 col-6 form-group mt-2">
              <label id="modal-labels">Date of Retirement</label>
              <input type="text" (paste)="(false)" class="form-control" formControlName="dateOfRetirement"
                [minDate]="minDate" [bsConfig]="{dateInputFormat: 'MMM-DD-YYYY', showWeekNumbers: false}"
                placeholder="MM-DD-YYYY" bsDatepicker />
            </div>
            <div class="col-md-6 col-6 form-group mt-2">
              <label id="modal-labels">P.O. Box</label>
              <input type="text" placeholder="P.O. Box" formControlName="poBox" class="form-control" />
            </div>
          </div>

          <ng-container *ngIf="isViking">
            <div class="col-12 mt-3 mb-1">
              <strong id="modal-labels">Prior Group Coverage</strong>
              <hr class="mt-1 mb-2" />
            </div>
            <div class="row">
              <div class="col-md-6 col-6 form-group mt-2">
                <label id="modal-labels">Previous Employer</label>
                <input type="text" class="form-control" placeholder="Previous Employer"
                  formControlName="previousEmployer" />
              </div>
              <div class="col-md-6 col-6 form-group mt-2">
                <label id="modal-labels">Employer Phone or Email</label>
                <input type="text" class="form-control" placeholder="Phone or Email"
                  formControlName="employerPhoneOrEmail" style="text-transform: none;" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 col-6 form-group mt-2">
                <label id="modal-labels">Last Day of Group Benefits</label>
                <input type="text" (paste)="(false)" class="form-control" formControlName="lastDayOfGroupBenefits"
                  [bsConfig]="{dateInputFormat: 'MMM-DD-YYYY', showWeekNumbers: false}" placeholder="MM-DD-YYYY"
                  bsDatepicker />
              </div>
              <div class="col-md-6 col-6 form-group mt-2">
                <label id="modal-labels">Certificate / Policy Number</label>
                <input type="text" class="form-control" placeholder="Certificate / Policy Number"
                  formControlName="certificatePolicyNumber" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 col-6 form-group mt-2">
                <label id="modal-labels">Previous Benefit Provider</label>
                <input type="text" class="form-control" placeholder="Previous Benefit Provider"
                  formControlName="previousBenefitProvider" />
              </div>
            </div>
          </ng-container>
        </form>
      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
          <b>{{ lang?.Cancel }}</b></button>&nbsp;
        <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="updateAddress()">
          {{ lang?.Update }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Beneficiary Add/Edit Modal (ported from admin portal) -->
<div id="beneficiaryListModal" class="modal modal-lg fade" data-bs-backdrop="static" data-bs-keyboard="false"
  tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content">
      <div class="modal-header" id="backgroundColor">
        <span class="modal-title">Beneficiary Information</span>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal" (click)="onClose()"></i>
      </div>
      <div class="modal-body" style="overflow-x:auto; max-height: 70vh; overflow-y: auto;">

        <form [formGroup]="benficiaryForm" *ngIf="showBenificiaryForm && benficiaryForm">
          <div class="row g-2 mb-3">

            <div class="col-6 col-md-3 form-group">
              <label id="modal-labels">Type<span style="color:red">*</span></label>
              <select class="form-select border border-dark text-black" formControlName="type">
                <option value="PRIMARY">Primary</option>
                <option value="CONTINGENT">Contingent</option>
              </select>
            </div>

            <div class="col-6 col-md-3 form-group">
              <label id="modal-labels">First Name<span style="color:red">*</span></label>
              <input class="form-control border border-dark" placeholder="First Name" type="text"
                formControlName="firstName" (keypress)="alphabatesOnly($event)" />
              <div class="help-block text-danger" *ngIf="b['firstName'].errors && b['firstName'].touched">
                Please enter First Name
              </div>
            </div>

            <div class="col-6 col-md-3 form-group">
              <label id="modal-labels">Last Name<span style="color:red">*</span></label>
              <input class="form-control border border-dark" placeholder="Last Name" type="text"
                formControlName="lastName" (keypress)="alphabatesOnly($event)" />
              <div class="help-block text-danger" *ngIf="b['lastName'].errors && b['lastName'].touched">
                Please enter Last Name
              </div>
            </div>

            <div class="col-6 col-md-3 form-group">
              <label id="modal-labels">Email</label>
              <input class="form-control border border-dark" type="email" placeholder="Email" formControlName="email" />
              <div class="help-block text-danger" *ngIf="b['email'].errors && b['email'].touched">
                Please enter a valid Email
              </div>
            </div>

            <div class="col-6 col-md-3 form-group">
              <label id="modal-labels">Phone Number</label>
              <input class="form-control border border-dark" placeholder="Phone Number" formControlName="phoneNumber"
                (blur)="phoneFormatBeneficiary($event)" />
              <div class="help-block text-danger" *ngIf="b['phoneNumber'].errors && b['phoneNumber'].touched">
                Please enter a valid Phone Number
              </div>
            </div>

            <div class="col-6 col-md-3 form-group">
              <label id="modal-labels">Relationship<span style="color:red">*</span></label>
              <select class="form-select border border-dark text-black" formControlName="relationship"
                (change)="isChildCheck($event)">
                <option [ngValue]="null" disabled>Select</option>
                <option *ngFor="let rel of beneficiaryRelationships" [value]="rel.value">{{ rel.label }}</option>
              </select>
              <div class="help-block text-danger" *ngIf="b['relationship'].errors && b['relationship'].touched">
                Please select Relationship
              </div>
            </div>

            <div class="col-6 col-md-3 form-group" *ngIf="benficiaryForm.get('relationship')?.value === 'OTHER'">
              <label id="modal-labels">Specify Relationship<span style="color:red">*</span></label>
              <input class="form-control border border-dark" type="text" formControlName="relationshipSpecific"
                (keypress)="alphabatesOnly($event)" />
              <div class="help-block text-danger"
                *ngIf="b['relationshipSpecific'].errors && b['relationshipSpecific'].touched">
                Please specify the Relationship
              </div>
            </div>

            <div class="col-6 col-md-3 form-group">
              <label id="modal-labels">DOB<span style="color:red">*</span></label>
              <input type="text" class="form-control border border-dark" formControlName="dob" placeholder="MM-DD-YYYY"
                [bsConfig]="{dateInputFormat: 'MMM-DD-YYYY', showWeekNumbers: false}" [minDate]="minDate"
                [maxDate]="childmaxDate" bsDatepicker (bsValueChange)="onDateChange($event)"
                (blur)="checkDateOfBirthMinor($event)" />
              <div class="help-block text-danger" *ngIf="b['dob'].errors && b['dob'].touched">
                Please enter Date of Birth
              </div>
            </div>

            <div class="col-6 col-md-3 form-group">
              <label id="modal-labels">Gender<span style="color:red">*</span></label>
              <select class="form-select border border-dark text-black" formControlName="gender">
                <option [ngValue]="null" disabled>Select</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Non-Binary">Non-Binary</option>
                <option value="Undisclosed">Undisclosed</option>
              </select>
              <div class="help-block text-danger" *ngIf="b['gender'].errors && b['gender'].touched">
                Please select Gender
              </div>
            </div>

            <ng-container *ngIf="benficiaryForm.get('relationship')?.value === 'CHILDREN'">
              <div class="col-6 col-md-3 form-group">
                <label id="modal-labels">Trustee First Name<span style="color:red">*</span></label>
                <input class="form-control border border-dark" placeholder="Trustee First Name" type="text"
                  formControlName="trusteeFirstName" (keypress)="alphabatesOnly($event)" />
                <div class="help-block text-danger"
                  *ngIf="b['trusteeFirstName'].errors && b['trusteeFirstName'].touched">
                  Please enter Trustee First Name
                </div>
              </div>
              <div class="col-6 col-md-3 form-group">
                <label id="modal-labels">Trustee Last Name<span style="color:red">*</span></label>
                <input class="form-control border border-dark" placeholder="Trustee Last Name" type="text"
                  formControlName="trusteeLastName" (keypress)="alphabatesOnly($event)" />
                <div class="help-block text-danger"
                  *ngIf="b['trusteeLastName'].errors && b['trusteeLastName'].touched">
                  Please enter Trustee Last Name
                </div>
              </div>
              <div class="col-6 col-md-3 form-group">
                <label id="modal-labels">Trustee Relation<span style="color:red">*</span></label>
                <input class="form-control border border-dark" type="text" placeholder="Trustee Relation"
                  formControlName="trusteeRelation" (keypress)="alphabatesOnly($event)" />
                <div class="help-block text-danger"
                  *ngIf="b['trusteeRelation'].errors && b['trusteeRelation'].touched">
                  Please enter Trustee Relation
                </div>
              </div>
            </ng-container>

            <div class="col-6 col-md-3 form-group">
              <label id="modal-labels">Percentage<span style="color:red">*</span></label>
              <input class="form-control border border-dark" type="text" placeholder="%" formControlName="percentage"
                (keypress)="numbersOnly($event)" (blur)="checkpercentagevalue($event)" />
              <div class="help-block text-danger" *ngIf="b['percentage'].errors && b['percentage'].touched">
                {{ b['percentage'].errors['required'] ? 'Please enter Percentage' : 'Percentage cannot be 0' }}
              </div>
            </div>

          </div>

          <div class="d-flex justify-content-end mb-3">
            <button type="button" class="btn btn-sm btn-light" id="updateButton" [disabled]="benficiaryForm.invalid"
              (click)="savebenficiary(benficiaryForm.value)">
              {{ BenficairyModalAddAndUpdateButton === 'Update' ? 'Update Beneficiary' : 'Save Beneficiary' }}
            </button>
          </div>
        </form>

        <div style="overflow-x:auto;">
          <table class="table table-bordered mt-2" *ngIf="stagingBeneficiaryData.length > 0">
            <thead>
              <tr>
                <th>Type</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Relationship</th>
                <th>DOB</th>
                <th>Gender</th>
                <th>Trustee</th>
                <th>%</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let broker of stagingBeneficiaryData; let i = index">
                <td>{{ broker.type }}</td>
                <td>{{ broker.firstName }}</td>
                <td>{{ broker.lastName }}</td>
                <td>
                  {{ broker.relationship?.toLowerCase()?.startsWith('other')
                  ? capitalizeFirstLetter(broker.relationship.split('-').slice(1).join('-'))
                  : capitalizeFirstLetter(getBenRelation(broker.relationship)) }}
                </td>
                <td>{{ broker.dob === null ? 'NA' : (broker.dob | customDate) }}</td>
                <td>{{ broker.gender }}</td>
                <td>
                  {{ broker.trusteeFirstName === '' || !broker.trusteeFirstName ? 'NA'
                  : broker.trusteeFirstName + ' ' + broker.trusteeLastName + ' - ' + broker.trusteeRelation }}
                </td>
                <td>{{ broker.percentage }}%</td>
                <td class="text-nowrap">
                  <i class="fa fa-pencil-square-o icon me-2" role="button"
                    (click)="editbenficiary($event, i, broker)"></i>
                  <i class="fa fa-trash icon text-danger" role="button" (click)="deleteBenficiaryPopup(broker, i)"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="text-end" *ngIf="stagingBeneficiaryData.length > 0">
          <button type="button" class="btn btn-sm btn-outline-dark" (click)="addnewbenficiary()">+ Add</button>
        </div>

        <div class="text-danger mt-2" *ngIf="benficiaryCount">{{ benficiaryCountMessage }}</div>
      </div>

      <div class="modal-footer py-2">
        <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
          (click)="onClose()"><b>Close</b></button>&nbsp;
        <button type="button" class="btn btn-sm btn-light" id="updateButton" *ngIf="stagingBeneficiaryData.length > 0"
          (click)="finalbenificiarySubmit()">
          Submit
        </button>
      </div>
    </div>
  </div>
</div>

<div id="viewBeneficiary" class="modal modalposition modal-md" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 800px">
    <div class="modal-content">
      <div class="modal-header" id="backgroundColor">
        <h6 class="modal-title">
          {{ lang?.Beneficiary_Information }}
          <span class="text-capitalize">( {{ currentBeneficiary.customerType }} )</span>
        </h6>
              </div>
      <div class="modal-body">
        <table id="table" class="beneficiaryTable">
          <thead>
            <tr>
                            <th>{{ lang?.Name }}</th>
                            <th>{{ lang?.Relation }}</th>
              <th>{{ lang?.Percentage }}</th>
              <th>{{ lang?.age_18 }}</th>
              <th class="text-wrap">{{ lang?.Trustee_Details_if_minor }}</th>
              <th class="text-wrap">{{ lang?.Contingent_Beneficiary }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let beneficiary of beneficiaries; let i = index">
                            <td>
                <input class="form-control view text-capitalize mb-1" style="width: 120px" disabled
                  value="{{ beneficiary.firstName }}" />
                <input class="form-control view text-capitalize" style="width: 120px" disabled
                  value="{{ beneficiary.lastName }}" />
              </td>
              <td>
                <input class="form-control view text-capitalize" style="width: 120px" disabled
                  value="{{ removeUnderscores(beneficiary.relationship) }}" />
              </td>
              <td>
                <input class="form-control view text-capitalize" style="width: 70px" style="width: 70px" disabled
                  value="{{ beneficiary.percentage }}" />
              </td>
              <td style="width: 120px">
                <div class="text-nowrap">
                  <div *ngIf="beneficiary.isMinor">
                    &nbsp;&nbsp;Yes&nbsp;&nbsp;
                  </div>
                  <div *ngIf="!beneficiary.isMinor">
                    &nbsp;&nbsp;No&nbsp;&nbsp;
                  </div>
                </div>
                <div *ngIf="beneficiary.isMinor">
                  {{ beneficiary.dob | customDate }}
                </div>
              </td>
              <td>
                <input class="form-control view text-capitalize my-1" style="width: 120px"
                  placeholder="{{ lang?.First_Name }}" value="{{ beneficiary.trusteeDetails.firstName }}" disabled />
                <input class="form-control view text-capitalize" style="width: 120px"
                  placeholder="{{ lang?.Last_Name }}" value="{{ beneficiary.trusteeDetails.lastName }}" disabled />
              </td>
              <td>
                <input class="form-control view text-capitalize mb-1" style="width: 120px"
                  placeholder="{{ lang?.First_Name }}" disabled value="{{
                      beneficiary.contactDetails.contingentBeneficiary.firstName
                    }}" />
                    <input class="form-control view text-capitalize" style="width: 120px"
                      placeholder="{{ lang?.Last_Name }}" disabled value="{{
                      beneficiary.contactDetails.contingentBeneficiary.lastName
                    }}" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer py-2">
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
              <b>{{ lang?.Close }}</b></button>&nbsp;
          </div>
        </div>
      </div>
    </div>

    <div id="updateBeneficiary" class="modal modalposition modal-md" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered" style="max-width: 900px">
        <div class="modal-content">
          <div class="modal-header" id="backgroundColor">
            <h6 class="modal-title">
              {{ lang?.Update_Beneficiary_Information }}
              <span class="text-capitalize">( {{ currentBeneficiary.customerType }} )</span>
            </h6>
                        <button class="btn btn-sm btn-light" (click)="addBenficiaryRow()">
              {{lang?.Add}} +
            </button>
                      </div>
          <div class="modal-body" style="max-height: 60vh; overflow-y: auto">
            <table id="table" class="beneficiaryTable">
              <thead>
                <tr>
                                    <th>{{ lang?.Name }}</th>
                  <th>{{ lang?.Relation }}</th>
                  <th>{{ lang?.Percentage }}</th>
                  <th>{{ lang?.age_18 }}</th>
                  <th class="text-wrap">{{ lang?.Trustee_Details_if_minor }}</th>
                  <th class="text-wrap">{{ lang?.Contingent_Beneficiary }}</th>
                  <th>{{ lang?.Action }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let beneficiary of beneficiaries; let i = index">
                  <td hidden>
                    <select class="form-select" [(ngModel)]="beneficiary.customerType" style="width: 100px">
                      <option *ngFor="
                        let beneficiary of beneficiaryValidations.customerType;
                        let i = index
                      " value="{{ beneficiary.value }}">
                        {{ beneficiary.label }}
                      </option>
                    </select>
                  </td>
                  <td hidden>
                    <select class="form-select" styled="width:120px;" [(ngModel)]="beneficiary.type"
                      style="width: 120px">
                      <option *ngFor="
                        let beneficiary of beneficiaryValidations.type;
                        let i = index
                      " value="{{ beneficiary.value }}">
                        {{ beneficiary.label }}
                      </option>
                    </select>
                  </td>
                  <td>
                    <input class="form-control text-capitalize mb-1" placeholder="{{ lang?.First_Name }}"
                      [(ngModel)]="beneficiary.firstName" style="width: 120px"
                      onkeydown="return /[a-z\s]/i.test(event.key)" />
                    <input class="form-control text-capitalize" placeholder="{{ lang?.Last_Name }}"
                      [(ngModel)]="beneficiary.lastName" style="width: 120px"
                      onkeydown="return /[a-z\s]/i.test(event.key)" />
                  </td>
                  <td>
                    <select class="form-select" [(ngModel)]="beneficiary.relationship" style="width: 120px"
                      (change)="onRelationshipChange(beneficiary)">
                      <option *ngFor="
                        let beneficiary of beneficiaryValidations.relationship;
                        let i = index
                      " value="{{ beneficiary.value }}">
                        {{ beneficiary.label }}
                      </option>
                    </select>
                                      </td>
                  <td>
                    <input class="form-control text-capitalize" style="width: 70px" min="0" max="100" type="number"
                      [(ngModel)]="beneficiary.percentage" />
                  </td>
                  <td>
                    <div class="text-nowrap d-flex justify-content-evenly align-items-center">
                      <div class="d-flex">
                        <!-- (change)="checkMinor(beneficiary)" -->
                        <input type="radio" name="{{ i }}-update-gender" class="m-0" [value]="true"
                          [(ngModel)]="beneficiary.isMinor" [disabled]="beneficiary.relationship !== 'CHILD'"
                          (change)="checkMinor(beneficiary, i)" />
                        {{lang?.Yes}}
                      </div>
                      <div class="d-flex">
                        <!-- (change)="checkMinor(beneficiary)" -->
                        <input type="radio" name="{{ i }}-update-gender" class="m-0" [value]="false"
                          [(ngModel)]="beneficiary.isMinor" [disabled]="beneficiary.relationship !== 'CHILD'"
                          (change)="checkMinor(beneficiary, i)" />
                        {{lang?.No}}
                      </div>
                    </div>
                    <div *ngIf="beneficiary.isMinor" style="width: 120px; margin: auto">
                      <!-- [minDate]="minDate"
                          [maxDate]="maxDate"  -->
                      <input type="text" placeholder="{{ lang?.Date_of_Birth }}" class="form-control mb-1"
                        [minDate]="maxDate" bsDatepicker [(ngModel)]="beneficiary.dob"
                        [bsConfig]="{ dateInputFormat: 'MMM-DD-YYYY',showWeekNumbers: false }" />
                                          </div>
                  </td>
                  <td>
                    <div style="width: 120px; margin: auto">
                      <input class="form-control view text-capitalize mb-1" placeholder="{{ lang?.First_Name }}"
                        [(ngModel)]="beneficiary.trusteeDetails.firstName" [disabled]="!beneficiary.isMinor"
                        onkeydown="return /[a-z\s]/i.test(event.key)" />
                      <input class="form-control view text-capitalize" placeholder="{{ lang?.Last_Name }}"
                        [(ngModel)]="beneficiary.trusteeDetails.lastName" [disabled]="!beneficiary.isMinor"
                        onkeydown="return /[a-z\s]/i.test(event.key)" />
                    </div>
                  </td>
                  <td>
                    <div style="width: 120px; margin: auto">
                      <input class="form-control view text-capitalize mb-1" placeholder="{{ lang?.First_Name }}"
                        [(ngModel)]="
                        beneficiary.contactDetails.contingentBeneficiary.firstName
                      " onkeydown="return /[a-z\s]/i.test(event.key)" />
                      <input class="form-control view text-capitalize" placeholder="{{ lang?.Last_Name }}" [(ngModel)]="
                        beneficiary.contactDetails.contingentBeneficiary.lastName
                      " onkeydown="return /[a-z\s]/i.test(event.key)" />
                    </div>
                  </td>
                  <td>
                    <a class="btn btn-default deleteicon" title="Delete" data-toggle="tooltip"
                      (click)="deleteBeneficiary(beneficiary)"><i class="bi bi-trash-fill"></i></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer py-2">
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
              <b>{{ lang?.Cancel }}</b></button>&nbsp;
            <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="updateBeneficiaries()">
              <!-- [disabled]="beneficiaries.length==0" -->
              {{ beneficiariesConst.length>0 ? lang?.Update : lang.Add }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--  Dependent Update Modal -->
    <div id="updateDependent" class="modal fade modalposition modal-md" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content" id="dependent-content">
          <div class="modal-header" id="backgroundColor">
            <h6 *ngIf="dependentUpdate" class="modal-title">
              {{ lang?.Update_Dependent_Info }}
            </h6>
            <h6 *ngIf="!dependentUpdate" class="modal-title">
              {{ lang?.Dependents }}
            </h6>
            <i #closeDependentmodal class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
          </div>
          <div class="modal-body">
            <form [formGroup]="dependentform" *ngIf="dependentStatus">
              <div class="row">
                <div class="col-md-6 form-group">
                  <label id="modal-labels">{{ lang?.First_Name }}<span style="color: red">*</span></label>
                  <input type="text" placeholder="{{ lang?.First_Name }}" id="firstName" formControlName="firstName"
                    class="form-control" (keypress)="
                    (($event.charCode >= 65 && $event.charCode < 91) ||
                      ($event.charCode >= 97 && $event.charCode < 123) ||
                      $event.charCode == 32)
                  " (input)="checkFirstCharacter($event, dependentform)" />
                  <div *ngIf="
                    dependentForm['firstName'].touched &&
                    dependentForm['firstName'].invalid
                  " class="help-block text-danger">
                    <div *ngIf="
                      dependentForm['firstName'].errors &&
                      dependentForm['firstName'].errors['required']
                    ">
                      {{ lang?.Please_enter_first_name }}
                    </div>
                    <div *ngIf="
                      dependentForm['firstName'].errors &&
                      dependentForm['firstName'].errors['minlength']
                    ">
                      First name should be atleast 1 character
                                          </div>
                  </div>
                </div>
                <div class="col-md-6 form-group">
                  <label id="modal-labels">{{ lang?.Last_Name }}<span style="color: red">*</span></label>
                  <input type="text" placeholder="{{ lang?.Last_Name }}" id="lastName" formControlName="lastName"
                    class="form-control" (keypress)="
                    (($event.charCode >= 65 && $event.charCode < 91) ||
                      ($event.charCode >= 97 && $event.charCode < 123) ||
                      $event.charCode == 32)
                  " (input)="checkFirstCharacter($event, dependentform)" />
                  <div *ngIf="
                    dependentForm['lastName'].touched &&
                    dependentForm['lastName'].invalid
                  " class="help-block text-danger">
                    <div *ngIf="
                      dependentForm['lastName'].errors &&
                      dependentForm['lastName'].errors['required']
                    ">
                      {{ lang?.Please_enter_last_name }}
                    </div>
                    <div *ngIf="
                      dependentForm['lastName'].errors &&
                      dependentForm['lastName'].errors['minlength']
                    ">
                      Last name should be atleast 1 character
                                          </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6 form-group">
                  <label id="modal-labels">{{ lang?.Gender }}<span style="color: red">*</span></label>
                  <select class="form-select" formControlName="gender">
                    <option value="" disabled>{{ lang?.Select }}</option>
                    <option *ngFor="let gender of formConfiguration.gender" value="{{ gender }}">
                      {{ gender }}
                    </option>
                  </select>
                  <div *ngIf="
                    dependentForm['gender'].touched &&
                    dependentForm['gender'].invalid
                  " class="help-block text-danger">
                    <div *ngIf="
                      dependentForm['gender'].errors &&
                      dependentForm['gender'].errors['required']
                    ">
                      {{ lang?.Please_select_gender }}
                    </div>
                  </div>
                </div>
                <div class="col-6 form-group">
                  <label id="modal-labels">{{ lang?.Date_of_Birth
                    }}<span style="color: red">*</span></label>
                                    <input type="text" placeholder="MM-DD-YYYY" class="form-control checking-field" id="dob"
                    formControlName="dob" [minDate]="minDatechild" [maxDate]="maxDatechild" bsDatepicker
                    [bsConfig]="{ dateInputFormat: 'MMM-DD-YYYY',showWeekNumbers: false }" />
                  <div *ngIf="
                    dependentForm['dob'].touched && dependentForm['dob'].invalid
                  " class="help-block text-danger">
                    <div *ngIf="
                      dependentForm['dob'].errors &&
                      dependentForm['dob'].errors['required']
                    ">
                      {{ lang?.Please_enter_Date_of_birth }}
                    </div>
                  </div>
                </div>
                              </div>
              <div class="row">
                <div class="col-md-12 form-group">
                  <label id="modal-labels">
                    {{
                    lang?.Is_your_dependent_covered_by_another_Health_and_or_Dental_Insurance_plan
                    }}<span style="color: red">*</span></label>
                </div>
              </div>
              <div class="row">
                <div class="col-3 mt-1">
                  <input type="radio" [value]="true" name="coveredByAnotherPlan" formControlName="coveredByAnotherPlan"
                    [checked]="childCoverage === true" (click)="openDependentCoverage('open')" />&nbsp;<label
                    id="radio-labels" class="align-text-top">{{
                    lang?.Yes
                    }}</label>
                </div>
                <div class="col-3 mt-1">
                  <input type="radio" [value]="false" name="coveredByAnotherPlan" formControlName="coveredByAnotherPlan"
                    [checked]="childCoverage === false" (click)="openDependentCoverage('close')" />&nbsp;<label
                    id="radio-labels" class="align-text-top">{{
                    lang?.No
                    }}</label>
                </div>
                <div *ngIf="
                  dependentForm['coveredByAnotherPlan'].touched &&
                  dependentForm['coveredByAnotherPlan'].invalid
                " class="help-block text-danger">
                  <div *ngIf="
                    dependentForm['coveredByAnotherPlan'].errors &&
                    dependentForm['coveredByAnotherPlan'].errors['required']
                  ">
                    {{ lang?.Please_choose_dependent_insurance_status }}
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="childCoverage === true && relationType == 'spouse'">
                <div class="col-6 form-group">
                  <label id="modal-labels">{{ lang?.Name_of_the_Carrier
                    }}<span style="color: red">*</span></label>
                  <input type="text" placeholder="Name of the Carrier" class="form-control"
                    formControlName="carrierName" id="carrierName" (keypress)="
                    (($event.charCode >= 65 && $event.charCode < 91) ||
                      ($event.charCode >= 97 && $event.charCode < 123) ||
                      $event.charCode == 32)
                  " (input)="checkFirstCharacter($event, dependentform)" />
                  <div *ngIf="
                    dependentForm['carrierName'].touched &&
                    dependentForm['carrierName'].invalid
                  " class="help-block text-danger">
                    <div *ngIf="
                      dependentForm['carrierName'].errors &&
                      dependentForm['carrierName'].errors['required']
                    ">
                      {{ lang?.Please_enter_name_of_carrier }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="childCoverage === true && relationType != 'spouse'">
                <div class="col-6 form-group">
                  <label id="modal-labels">{{ lang?.Name_of_the_Carrier
                    }}<span style="color: red">*</span></label>
                  <input type="text" placeholder="Name of the Carrier" class="form-control"
                    formControlName="carrierName" id="carrierName" (keypress)="
                  (($event.charCode >= 65 && $event.charCode < 91) ||
                    ($event.charCode >= 97 && $event.charCode < 123) ||
                    $event.charCode == 32)
                " (input)="checkFirstCharacter($event, dependentform)" />
                  <div *ngIf="
                  dependentForm['carrierName'].touched &&
                  dependentForm['carrierName'].invalid
                " class="help-block text-danger">
                    <div *ngIf="
                    dependentForm['carrierName'].errors &&
                    dependentForm['carrierName'].errors['required']
                  ">
                      {{ lang?.Please_enter_name_of_carrier }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-8 align-items-center">
                  <div class="row">
                    <div class="col-1" id="checkbox">
                      <input type="checkbox" value="true" formControlName="specialNeeds"
                        [checked]="specialNeeds === 'true'" />
                    </div>
                    <div class="col-11">
                      <b id="modal-labels">{{
                        lang?.Dependent_with_Special_Needs
                        }}</b>&nbsp;<i class="bi bi-info-circle"></i>
                    </div>
                  </div>
                </div>
                              </div>
              <div class="row mt-2">
                <div class="col-md-8 align-items-center">
                  <div class="row">
                    <div class="col-1" id="checkbox">
                      <input type="checkbox" value="true" formControlName="postSecondaryStudent"
                        [checked]="postSecondaryStudent === true" (change)="openGraduationDate($event)" />
                    </div>
                    <div class="col-11">
                      <b id="modal-labels">{{ lang?.Post_Secondary_Student }}</b>&nbsp;<i class="bi bi-info-circle"></i>
                    </div>
                  </div>
                </div>
                              </div>
              <div class="row" *ngIf="postSecondaryStudent && graduationDate">
                <div class="row">
                  <div class="col-md-6 col-6 form-group">
                    <label id="modal-labels">{{ lang?.Graduation_Day
                      }}<span style="color: red">*</span></label>
                                        <input type="text" placeholder="MM-DD-YYYY" class="form-control checking-field"
                      name="graduationDate" formControlName="graduationDate" placement="top" bsDatepicker
                      [bsConfig]="{ dateInputFormat: 'MMM-DD-YYYY',showWeekNumbers: false }" />
                  </div>
                  <div *ngIf="
                      dependentForm['graduationDate'].touched &&
                      dependentForm['graduationDate'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        dependentForm['graduationDate'].errors &&
                        dependentForm['graduationDate'].errors['required']
                      ">
                      {{ lang?.Please_choose_graduation_date }}
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="!dependentUpdate">
                <div class="row">
                  <div class="col-md-6 form-group">
                    <label id="modal-labels">{{ lang?.Effective_Date
                      }}<span style="color: red">*</span></label>
                                        <input type="text" placeholder="MM-DD-YYYY" class="form-control checking-field" name="effectiveDate"
                      formControlName="effectiveDate" placement="top" bsDatepicker
                      [bsConfig]="{ dateInputFormat: 'MMM-DD-YYYY',showWeekNumbers: false }" />
                    <div *ngIf="
                      dependentForm['effectiveDate'].touched &&
                      dependentForm['effectiveDate'].invalid
                    " class="help-block text-danger">
                      <div *ngIf="
                        dependentForm['effectiveDate'].errors &&
                        dependentForm['effectiveDate'].errors['required']
                      ">
                        {{ lang?.Please_choose_effective_date }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mt-2">
                    <button type="button" *ngIf="dependentStatus" class="btn btn-sm btn-light" id="updateButton"
                      (click)="addAnotherDependent()">
                      {{ lang?.Add_another_dependent }}
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <div class="modal-footer py-2">
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
                (click)="closeDependentForm()">
                <b>{{ lang?.Cancel }}</b></button>&nbsp;&nbsp;
              <button type="button" *ngIf="dependentUpdate" class="btn btn-sm btn-light" id="updateButton"
                (click)="updateDependent()">
                {{ lang?.Update }}
              </button>
              <button type="button" *ngIf="!dependentUpdate" class="btn btn-sm btn-light" id="updateButton"
                (click)="addDependentData()">
                {{ lang?.Add }}
              </button>
            </div>
          </div>
        </div>
      </div>
 </div>
      <!--  ROE Modal -->
      <div id="roe" class="modal fade modal-lg modalposition" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
          <div class="modal-content" id="modal-content">
            <div class="modal-header" id="backgroundColor">
              <h6 class="modal-title">{{ lang?.Record_of_Enrollment }}</h6>
              <i #openRoe class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
                (click)="closeRoe()"></i>
            </div>
            <div class="modal-body">
              <div *ngIf="viewRoe">
                <span *ngIf="loading">
                  <img src="../../assets/img/loader.gif" width="100" style="
                  display: block;
                  margin-left: auto;
                  margin-right: auto;
                  width: 5%;
                " />
                </span>
                <pdf-viewer [src]="roe" id="pdf-viewer" (after-load-complete)="pdfLoaded($event)"></pdf-viewer>
              </div>
              <div *ngIf="!viewRoe">
                <h6>{{ lang?.Currently_ROE_is_not_available }}</h6>
              </div>
            </div>
            <div class="modal-footer py-2">
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
                (click)="closeRoe()">
                <b>{{ lang?.Close }}</b>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div id="roa" class="modal fade modal-lg modalposition" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
          <div class="modal-content" id="modal-content">
            <div class="modal-header" id="backgroundColor">
              <h6 class="modal-title">Record of Amendment</h6>
              <i #openRoe class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
                (click)="closeRoe()"></i>
            </div>
            <div class="modal-body">
              <div *ngIf="viewRoe">
                <span *ngIf="loading">
                  <img src="../../assets/img/loader.gif" width="100" style="
                  display: block;
                  margin-left: auto;
                  margin-right: auto;
                  width: 5%;
                " />
                </span>
                <pdf-viewer [src]="roe" id="pdf-viewer" (after-load-complete)="pdfLoaded($event)"></pdf-viewer>
              </div>
              <div *ngIf="!viewRoe">
                <h6>{{ lang?.Currently_ROE_is_not_available }}</h6>
              </div>
            </div>
            <div class="modal-footer py-2">
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
                (click)="closeRoe()">
                <b>{{ lang?.Close }}</b>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!--  HIC Details Modal -->
      <div id="hicDetails" class="modal fade modal-lg modalposition" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
          <div class="modal-content" id="modal-content">
            <div class="modal-header" id="backgroundColor">
              <h6 class="modal-title">{{ lang?.Health_Insurance_Cards_Details }}</h6>
              <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
                (click)="closeHealthCard()"></i>
            </div>
            <div class="modal-body">
              <div *ngIf="card">
                <h6>{{ lang?.Please_check_back_later_or_contact_your_Advisor }}</h6>
              </div>
              <div *ngIf="healthCard">
                <span *ngIf="loading">
                  <img src="../../assets/img/loader.gif" width="100" style="
                  display: block;
                  margin-left: auto;
                  margin-right: auto;
                  width: 5%;
                " />
                </span>
                <pdf-viewer [src]="src" id="pdf-viewer" (after-load-complete)="pdfLoaded($event)"></pdf-viewer>
              </div>
            </div>
            <div class="modal-footer py-2">
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
                (click)="closeHealthCard()">
                <b>{{ lang?.Close }}</b>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!--  Booklet Details Modal -->
      <div id="hpbooklet" class="modal fade modal-lg modalposition" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
          <div class="modal-content" id="modal-content">
            <div class="modal-header" id="backgroundColor">
              <h6 class="modal-title">{{ lang?.View_Plan_Booklets }}</h6>
              <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
                (click)="closeBooklet()"></i>
            </div>
            <div class="modal-body">
              <div>
                <span *ngIf="showViewPlansLoading==true">
                  <img src="../../assets/img/loader.gif" width="100" style="
                  display: block;
                  margin-left: auto;
                  margin-right: auto;
                  width: 5%;
                " />
                </span>
                <pdf-viewer [src]="bookletLink" id="pdf-viewer" [show-all]="false" [page]="page"
                  (after-load-complete)="afterLoadComplete($event)" [original-size]="false" [render-text]="true"
                  style="height: 60vh; z-index:9999; overflow-y: scroll;" class="px-0 w-fill object-fit">
                </pdf-viewer>
                <ng-container *ngIf="showViewPlansLoading==false">
                  <div class="pagination-controls">
                    <button (click)="previousPage()" [disabled]="page <= 1" class="chevron chevron--left">{{'<'}}
                        </button>
                        <span>{{page}} / {{totalPages}}</span>
                        <button (click)="nextPage()" [disabled]="page >= totalPages"
                          class="chevron chevron--right">{{'>'}}
                        </button>
                  </div>
                </ng-container>

              </div>
            </div>
            <div class="modal-footer py-2">
                            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
                (click)="closeBooklet()">
                <b>{{ lang?.Close }}</b>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Download All Booklets -->
      <div class="modal modal-lg" tabindex="-1" role="dialog" [ngStyle]="{ display: displayBooklet }">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header" id="backgroundColor">
              <h6 class="modal-title">{{ lang?.Health_Plan_Booklets_Download }}</h6>
              <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
                (click)="closeBooklet()"></i>
            </div>
            <div class="modal-body">
              <div class="table-responsive" *ngIf="!hidebooklet">
                <table class="table-striped" id="table">
                  <thead id="thead">
                    <tr>
                      <th>
                        <input type="checkbox" [checked]="isAllBookletsChecked()" (change)="checkAllBooklets($event)" />
                      </th>
                      <th class="fw-normal">&nbsp;S.No</th>
                      <th class="fw-normal">{{ lang?.Name }}</th>
                      <th class="fw-normal">{{ lang?.Description }}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let booklet of bookletList; let i = index">
                      <td>
                        <input type="checkbox" [checked]="booklet.checked"
                          (change)="booklet.checked = !booklet.checked" />
                      </td>
                      <td>&nbsp;{{ i + 1 }}</td>
                      <td>{{ booklet.name }}</td>
                      <td>{{ booklet.description }}</td>
                      <td id="booklet-td">
                                                <img role="button" src="/assets/img/view.png" alt="" width="20px" height="20px" class="m-2"
                          (click)="viewBooklet(booklet.link)" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div *ngIf="hidebooklet">
                <span *ngIf="loading">
                  <img src="../../assets/img/loader.gif" width="100" style="
                  display: block;
                  margin-left: auto;
                  margin-right: auto;
                  width: 5%;
                " />
                </span>
                <pdf-viewer [src]="bookletLink" style="width: 100%; height: 400px"
                  (after-load-complete)="pdfLoaded($event)"></pdf-viewer>
              </div>
            </div>
            <div class="modal-footer py-2">
              <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="downloadSelected()"
                *ngIf="!hidebooklet">
                <b>{{ lang?.Download }}</b></button>&nbsp;&nbsp;
              <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="closeDownloadBooklet()"
                *ngIf="hidebooklet">
                <b>{{ lang?.Back }}</b></button>&nbsp;&nbsp;
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
                (click)="closeBooklet()">
                <b>{{ lang?.Close }}</b>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Edit CC Modal -->
      <div id="updatePaymentInfo" class="modal fade modalposition" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header" id="backgroundColor">
              <h6 class="modal-title">{{ lang?.Update_Credit_Card_Info }}</h6>
              <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
                (click)="closePaymentInfo()"></i>
            </div>
            <div class="modal-body">
              <form [formGroup]="ccform" #paymentform2
                action="https://payments.subscriptionplatform.com/v2/payments/edit" method="post">
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <input class="form-control" autofocus="autofocus" id="CustomerID" formcontrolname="cutomerId"
                      name="CustomerID" type="hidden" value="{{ fusebillId }}" />
                  </div>
                  <div class="form-group col-md-12">
                    <!-- paymentMethodId -->
                    <input class="form-control" autofocus="autofocus" id="Id" formcontrolname="Id" name="Id"
                      type="hidden" value="{{ paymentMethodId }}" />
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-12">
                    <input class="form-control" id="PublicApiKey" formcontrolname="PublicApiKey" name="PublicApiKey"
                      type="hidden" value="{{ fuseBillKey }}" />
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-12">
                    <input class="form-control" id="SuccessUri" formcontrolname="SuccessUri" name="SuccessUri"
                      type="hidden" value="{{ paymentsuccessuri }}" />
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-12">
                    <input class="form-control" id="FailUri" formcontrolname="FailUri" name="FailUri" type="hidden"
                      value="{{ paymentUri }}" />
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 form-group mt-1">
                    <label id="modal-labels">{{ lang?.First_Name }}<span style="color: red">*</span></label>
                    <input type="text" placeholder="{{ lang?.First_Name }}" class="form-control" id="FirstName"
                      name="FirstName" formControlName="FirstName" (keypress)="
                    (($event.charCode >= 65 && $event.charCode < 91) ||
                      ($event.charCode >= 97 && $event.charCode < 123) ||
                      $event.charCode == 32)
                  " (input)="checkFirstCharacter($event, ccform)" />
                    <div *ngIf="
                    ccForm['FirstName'].touched && ccForm['FirstName'].invalid
                  " class="help-block text-danger">
                      <div *ngIf="
                      ccForm['FirstName'].errors &&
                      ccForm['FirstName'].errors['required']
                    ">
                        {{ lang?.Please_enter_first_name }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 form-group mt-1">
                    <label id="modal-labels">{{ lang?.Last_Name }}<span style="color: red">*</span></label>
                    <input type="text" placeholder="{{ lang?.Last_Name }}" class="form-control" id="LastName"
                      name="LastName" formControlName="LastName" (keypress)="
                    (($event.charCode >= 65 && $event.charCode < 91) ||
                      ($event.charCode >= 97 && $event.charCode < 123) ||
                      $event.charCode == 32)
                  " (input)="checkFirstCharacter($event, ccform)" />
                    <div *ngIf="ccForm['LastName'].touched && ccForm['LastName'].invalid"
                      class="help-block text-danger">
                      <div *ngIf="
                      ccForm['LastName'].errors &&
                      ccForm['LastName'].errors['required']
                    ">
                        {{ lang?.Please_enter_last_name }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 form-group mt-1">
                                        <input type="text" placeholder="{{ lang?.Last_Name }}" class="form-control" id="email" type="hidden"
                      name="email" formControlName="email" value="{{customerData?.email}}" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 form-group mt-1">
                    <label id="modal-labels">{{ lang?.Credit_Card_Number
                      }}<span style="color: red">*</span></label>
                    <div class="input-group">
                      <input type="text" placeholder="{{lang?.Credit_Card_Number}}" class="form-control" id="CardNumber"
                        name="CardNumber" formControlName="CardNumber"
                        (keypress)="($event.charCode >= 48 && $event.charCode < 58)"
                        (input)="creditcardlblurmethod($event)" />
                      <span class="input-group-text text-muted">
                        <i class="fa fa-cc-visa mx-1"></i>
                        <i class="fa fa-cc-amex mx-1"></i>
                        <i class="fa fa-cc-mastercard mx-1"></i>
                      </span>
                      <!-- (input)="creditcardlblurmethod($event, ccform)"> -->
                    </div>
                                        <div class="help-block text-danger" *ngIf="
                    ccForm['CardNumber'].touched &&
                    ccForm['CardNumber'].errors &&
                    ccForm['CardNumber'].errors['required']
                  ">
                      {{ lang?.Please_enter_card_number }}
                    </div>
                    
                    <div class="help-block text-danger" *ngIf="
                    (ccForm['CardNumber'].touched &&
                      ccForm['CardNumber'].hasError(
                        'invalidcreditcarddetails'
                      )) ||
                    invalidcreditcard
                  ">
                      {{ lang?.Please_enter_valid_Card_number }}
                    </div>

                                      </div>
                </div>
                <div class="row">
                  <div class="col-md-4 col-12 form-group mt-1">
                    <label id="modal-labels">Expiry Month<span style="color: red">*</span></label>
                    <div>
                      <div id="yearselect">
                        <select class="form-select" id="ExpirationMonth" name="ExpirationMonth"
                          formControlName="ExpirationMonth" (change)="getMonth($event)">
                          <option value="" disabled selected>
                            {{ lang?.Select }}
                          </option>
                          <option value="01">Jan</option>
                          <option value="02">Feb</option>
                          <option value="03">Mar</option>
                          <option value="04">April</option>
                          <option value="05">May</option>
                          <option value="06">June</option>
                          <option value="07">July</option>
                          <option value="08">Aug</option>
                          <option value="09">Sept</option>
                          <option value="10">Oct</option>
                          <option value="11">Nov</option>
                          <option value="12">Dec</option>
                        </select>
                      </div>
                    </div>
                    <div *ngIf="ccForm['ExpirationMonth'].touched" class="help-block text-danger">
                      <div *ngIf="
                      ccForm['ExpirationMonth'].errors &&
                      ccForm['ExpirationMonth'].errors['required']
                    ">
                        {{ lang?.Please_select_expiration_month }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-12 form-group mt-1">
                    <label id="modal-labels">Expiry Year<span style="color: red">*</span></label>
                    <div>
                      <div>
                        <select class="form-select" id="ExpirationYear" name="ExpirationYear"
                          formControlName="ExpirationYear" (change)="getYear($event)">
                          <option value="" disabled>YYYY</option>
                          <option *ngFor="let item of [].constructor(20); let i = index"
                            value="{{ i + ( currentYear ) }}">
                            {{ i + currentYear }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div *ngIf="ccForm['ExpirationYear'].touched" class="help-block text-danger">
                      <div *ngIf="
                      ccForm['ExpirationYear'].errors &&
                      ccForm['ExpirationYear'].errors['required']
                    ">
                        {{ lang?.Please_select_expiration_year }}
                      </div>
                      <div *ngIf="invalidExpiration">
                        {{ lang?.Please_enter_valid_expiration }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-12 form-group mt-1">
                    <label id="modal-labels">CVV<span style="color: red">*</span>&nbsp;<span
                        (mouseover)="showImage = true" (mouseout)="showImage = false" style="cursor: pointer"><i
                          class="bi bi-question-circle-fill"></i></span></label>
                    <img *ngIf="showImage" src="/assets/img/cvv-number.jpg" width="140px" height="80px" />
                    <input type="text" placeholder="CVV" class="form-control" id="Cvv" name="Cvv" formControlName="Cvv"
                      (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                    <div *ngIf="ccForm['Cvv'].touched && ccForm['Cvv'].invalid" class="help-block text-danger">
                      <div *ngIf="
                      ccForm['Cvv'].errors && ccForm['Cvv'].errors['required']
                    ">
                        {{ lang?.Please_enter_CVV }}
                      </div>
                      <div *ngIf="
                      ccForm['Cvv'].errors && ccForm['Cvv'].errors['minlength']
                    ">
                        {{ lang?.CVV_number_minimum_3_digits }}
                      </div>
                      <div *ngIf="
                      ccForm['Cvv'].errors && ccForm['Cvv'].errors['maxlength']
                    ">
                        {{ lang?.CVV_number_maximum_4_digits }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <input class="form-control" id="MakeDefault" placeholder="Name on the card" value="true"
                      type="hidden" name="MakeDefault" />
                  </div>
                </div>
                <div class="form-row captchavalidation mt-2">
                  <re-captcha (resolved)="resolved($event)" formControlName="recaptchaReactive"
                    siteKey="{{ fusbillinfocaptchavalue }}">
                  </re-captcha>
                  <input id="recaptcha_token" type="hidden" name="recaptcha_token" [value]="recaptchaResponse" />
                </div>
              </form>
            </div>
            <div class="modal-footer py-2">
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
                (click)="closeCcInfo()">
                <b>{{ lang?.Cancel }}</b></button>&nbsp;
              <button type="submit" class="btn btn-sm btn-light" id="updateButton" [disabled]="invalidExpiration"
                (click)="updateCcInfo(ccform.value, paymentform2)">
                {{ lang?.Update }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- PAD Update Modal -->
      <div id="updatePADinfo" class="modal fade modalposition" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered" id="updatePadModal">
          <div class="modal-content">
            <div class="modal-header" id="backgroundColor">
              <h6 class="modal-title">{{ lang?.Update_PAD_Details }}</h6>
              <i #closePaymentmodal class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
                (click)="closepadinfo()"></i>
            </div>
            <div class="modal-body">
              <form [formGroup]="padform">
                <div class="row">
                  <div class="col-md-4 form-group">
                    <label id="modal-labels">{{ lang?.Bank_Id }}<span style="color: red">*</span></label>
                    <input type="text" placeholder="Bank Number" formControlName="bankcode" class="form-control"
                      (input)="padformValid()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                    <div *ngIf="
                    padForm['bankcode'].touched && padForm['bankcode'].invalid
                  " class="help-block text-danger">
                      <div *ngIf="
                      padForm['bankcode'].errors &&
                      padForm['bankcode'].errors['required']
                    ">
                        {{ lang?.Please_enter_bank_number }}
                      </div>
                      <div *ngIf="
                      padForm['bankcode'].errors &&
                      padForm['bankcode'].errors['minlength']
                    ">
                        {{ lang?.Bank_number_must_be_equal_to_3_digits }}
                      </div>
                      <div *ngIf="
                      padForm['bankcode'].errors &&
                      padForm['bankcode'].errors['maxlength']
                    ">
                        {{ lang?.Bank_number_must_be_equal_to_3_digits }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 form-group">
                    <label id="modal-labels">{{ lang?.Transit }}<span style="color: red">*</span></label>
                    <input type="text" placeholder="Transit Number" formControlName="transitNumber" class="form-control"
                      (input)="padformValid()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                    <div *ngIf="
                    padForm['transitNumber'].touched &&
                    padForm['transitNumber'].invalid
                  " class="help-block text-danger">
                      <div *ngIf="
                      padForm['transitNumber'].errors &&
                      padForm['transitNumber'].errors['required']
                    ">
                        {{ lang?.Please_enter_transit_number }}
                      </div>
                      <div *ngIf="
                      padForm['transitNumber'].errors &&
                      padForm['transitNumber'].errors['minlength']
                    ">
                        {{ lang?.Transit_number_must_be_equal_to_5_digits }}
                      </div>
                      <div *ngIf="
                      padForm['transitNumber'].errors &&
                      padForm['transitNumber'].errors['maxlength']
                    ">
                        {{ lang?.Transit_number_must_be_equal_to_5_digits }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 form-group">
                    <label id="modal-labels">{{ lang?.Account }}<span style="color: red">*</span></label>
                    <input type="text" placeholder="Account Number" formControlName="accountNo" class="form-control"
                      (input)="padformValid()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                    <div *ngIf="
                    padForm['accountNo'].touched && padForm['accountNo'].invalid
                  " class="help-block text-danger">
                      <div *ngIf="
                      padForm['accountNo'].errors &&
                      padForm['accountNo'].errors['required']
                    ">
                        {{ lang?.Please_enter_account_number }}
                      </div>
                      <div *ngIf="
                      padForm['accountNo'].errors &&
                      padForm['accountNo'].errors['minlength']
                    ">
                        {{ lang?.Account_number_minimum_5_digits }}
                      </div>
                      <div *ngIf="
                      padForm['accountNo'].errors &&
                      padForm['accountNo'].errors['maxlength']
                    ">
                        {{ lang?.Account_number_maximum_12_digits }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" *ngIf="bankinfo">
                  <div class="col-md-12 form-group">
                    <label id="modal-labels">{{ lang?.Bank_Details }}</label>
                                        <textarea class="form-control checking-field" id="bankname" style="color: rgba(85, 85, 85, 0.9)"
                      [value]="banknameres" (change)="updateBankDetails($event)" rows="6"></textarea>
                  </div>
                </div>
                <div class="mt-2">
                  <button type="button" class="btn btn-sm btn-light" id="updateButton" *ngIf="resetbutton"
                    (click)="resetPadForm()">
                    {{ lang?.Clear }}
                  </button>
                  <button type="button" class="btn btn-sm btn-light" id="updateButton"
                    *ngIf="padform.valid && !bankinfo" (click)="updateBankInfo()">
                    {{ lang?.Verify }}
                  </button>
                </div>
                <div class="mt-2">
                  <button type="button" class="btn btn-sm btn-light" id="updateButton" *ngIf="existVoid && bankinfo"
                    data-bs-toggle="modal" data-bs-target="#updatepreviewAgreement" (click)="existingVoidCheque()">
                    {{ lang?.Click_here_to_view_Void_Cheque }}
                  </button>
                </div>
                <div class="form-group" *ngIf="cheque && !existVoid">
                  <label id="modal-labels">{{ lang?.Upload_Void_Cheque
                    }}<span style="color: red">*</span></label>
                  <div class="row">
                    <div class="col-8 pt-1">
                      <input type="file" formControlName="file" (change)="fileSelect($event)" />
                    </div>
                    <div class="col-4" *ngIf="updatepreviewbutton">
                      <button class="btn btn-sm btn-dark" data-bs-toggle="modal"
                        data-bs-target="#updatepreviewAgreement" (click)="updatePadpreview()">
                        {{lang?.Preview}}
                      </button>
                    </div>
                  </div>
                  <div *ngIf="padForm['file'].touched && padForm['file'].invalid" class="help-block text-danger">
                    <div *ngIf="
                    padForm['file'].errors && padForm['file'].errors['required']
                  ">
                      {{ lang?.Please_upload_void_cheque }}
                    </div>
                  </div>
                </div>
                <div class="mt-2">
                  <button class="btn btn-sm btn-success primaryInfoLabels" data-bs-dismiss="modal"
                    data-bs-toggle="modal" data-bs-target="#padAgreement" *ngIf="cheque && !existVoid" [disabled]="
                  padform.get('file')?.value == null ||
                  padform.get('file')?.value == ''
                " (click)="updateCorporatePAD()">
                    {{ lang?.Review_and_Sign_the_PAD_Agreement }}
                  </button>
                </div>
              </form>
            </div>
            <div class="modal-footer py-2">
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
                (click)="closepadinfo()">
                <b>{{ lang?.Cancel }}</b></button>&nbsp;
            </div>
          </div>
        </div>
      </div>

<div id="updateClaimsInfo" class="modal fade modalposition" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered" id="updateClaimsModal">
    <div class="modal-content">
      <div class="modal-header" id="backgroundColor">
        <h6 class="modal-title">{{ claimsUpdate ? 'Update Claims Details' : 'Add Claims Details' }}</h6>
        <i #closeClaimsmodal class="bi bi-x-circle" role="button" aria-hidden="true"
          data-bs-dismiss="modal" (click)="clearClaimsForm()"></i>
      </div>
      <div class="modal-body">

        <!-- Same as Payment Method / Other -->
        <div class="row mb-2" *ngIf="paymentMethod === 'ACH'">
          <div class="col-12 form-group">
            <label id="modal-labels"><b>Banking details for Claims Deposits</b></label>
          </div>
          <div class="col-6 d-flex align-items-center">
            <input type="radio" id="claimsSame" name="claimsPaymentMethod" class="claims-radio"
              [checked]="claimsPaymentMethodOption === 'same'"
              (change)="selectClaimsPaymentOption('same')" />
            <label for="claimsSame" id="radio-labels" class="align-text-top claims-radio-label">
              Same as payment method
            </label>
          </div>
          <div class="col-6 d-flex align-items-center">
            <input type="radio" id="claimsOther" name="claimsPaymentMethod" class="claims-radio"
              [checked]="claimsPaymentMethodOption === 'other'"
              (change)="selectClaimsPaymentOption('other')" />
            <label for="claimsOther" id="radio-labels" class="align-text-top claims-radio-label">
              Other
            </label>
          </div>
        </div>

        <form [formGroup]="claimsform">
          <div class="row" *ngIf="claimsPaymentMethodOption">
            <div class="col-md-4 form-group">
              <label id="modal-labels">{{ lang?.Bank_Id }}<span style="color: red">*</span></label>
              <input type="text" placeholder="Bank Number" formControlName="bankcode" class="form-control"
              [readonly]="claimsPaymentMethodOption === 'same'"
                (input)="claimsBankVerified = false"
                (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
              <div *ngIf="claimsForm['bankcode'].touched && claimsForm['bankcode'].invalid" class="help-block text-danger">
                <div *ngIf="claimsForm['bankcode'].errors?.['required']">Please enter bank number</div>
                <div *ngIf="claimsForm['bankcode'].errors?.['minlength'] || claimsForm['bankcode'].errors?.['maxlength']">
                  Bank number must be equal to 3 digits
                </div>
              </div>
            </div>
            <div class="col-md-4 form-group">
              <label id="modal-labels">{{ lang?.Transit }}<span style="color: red">*</span></label>
              <input type="text" placeholder="Transit Number" formControlName="transitNumber" class="form-control"
              [readonly]="claimsPaymentMethodOption === 'same'"
                (input)="claimsBankVerified = false"
                (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
              <div *ngIf="claimsForm['transitNumber'].touched && claimsForm['transitNumber'].invalid" class="help-block text-danger">
                <div *ngIf="claimsForm['transitNumber'].errors?.['required']">Please enter transit number</div>
                <div *ngIf="claimsForm['transitNumber'].errors?.['minlength'] || claimsForm['transitNumber'].errors?.['maxlength']">
                  Transit number must be equal to 5 digits
                </div>
              </div>
            </div>
            <div class="col-md-4 form-group">
              <label id="modal-labels">{{ lang?.Account }}<span style="color: red">*</span></label>
              <input type="text" placeholder="Account Number" formControlName="accountNo" class="form-control"
              [readonly]="claimsPaymentMethodOption === 'same'"
                (input)="claimsBankVerified = false"
                (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
              <div *ngIf="claimsForm['accountNo'].touched && claimsForm['accountNo'].invalid" class="help-block text-danger">
                <div *ngIf="claimsForm['accountNo'].errors?.['required']">Please enter account number</div>
                <div *ngIf="claimsForm['accountNo'].errors?.['minlength']">Account number minimum 5 digits</div>
                <div *ngIf="claimsForm['accountNo'].errors?.['maxlength']">Account number maximum 12 digits</div>
              </div>
            </div>
          </div>

<!-- Bank Details — only appears after Verify succeeds, same as PAD -->
<div class="row" *ngIf="claimsBankVerified && (claimsPaymentMethodOption === 'same' ? bankinformation : claimsBankInfo?.address)">
  <div class="col-md-12 form-group">
    <label id="modal-labels">{{ lang?.Bank_Details }}</label>
  <textarea class="form-control checking-field" id="claimsbankname"
  style="color: rgba(85,85,85,0.9)"
[value]="claimsPaymentMethodOption === 'same' ? bankinformation : claimsBankInfo.formattedAddress"
  rows="6" readonly></textarea>
  </div>
</div>
          <div class="mt-2">
            <button type="button" class="btn btn-sm btn-light" id="updateButton"
              *ngIf="claimsResetButton" (click)="clearClaimsForm()">
              {{ lang?.Clear }}
            </button>
            <button type="button" class="btn btn-sm btn-light" id="updateButton"
              *ngIf="claimsform.valid && !claimsBankVerified" (click)="verifyClaimsBank()">
              {{ lang?.Verify }}
            </button>
          </div>

          <!-- Upload Void Cheque — NOT mandatory (differs from PAD) -->
<div class="form-group mt-2" *ngIf="claimsBankVerified && claimsPaymentMethodOption !== 'same'">
  <label id="modal-labels">{{ lang?.Upload_Void_Cheque }} <small>(optional)</small></label>
  <div class="row">
    <div class="col-8 pt-1">
      <input type="file" formControlName="files" (change)="onClaimsFileSelect($event)" />
    </div>
    <div class="col-4" *ngIf="claimsImageDisplay">
      <button type="button" class="btn btn-sm btn-dark" data-bs-toggle="modal"
        data-bs-target="#claimsVoidPreview" (click)="claimsUpdatePreview()">
        {{ lang?.Preview }}
      </button>
    </div>
  </div>
</div>
        </form>
      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
          (click)="clearClaimsForm()">
          <b>{{ lang?.Cancel }}</b>
        </button>
<button type="button" class="btn btn-sm btn-light" id="updateButton"
  *ngIf="claimsBankVerified && claimsPaymentMethodOption" (click)="submitClaims()">
  {{ lang?.Submit ?? 'Submit' }}
</button>
      </div>
    </div>
  </div>
</div>
<!-- Preview Claims Void Cheque -->
<div id="claimsVoidPreview" class="modal fade modalposition modal-lg" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header" id="backgroundColor">
        <h6 class="modal-title">{{ lang?.Preview }}</h6>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal" data-bs-toggle="modal"
  data-bs-target="#updateClaimsInfo"></i>
      </div>
     <div class="modal-body">
  <div *ngIf="claimsFileType == 'image/jpeg'">
    <img [src]="claimsVoidCheckImage" />
  </div>
  <div *ngIf="claimsFileType == 'application/pdf'">
    <span *ngIf="claimsLoading">
      <img src="../../assets/img/loader.gif" width="100" style="
      display: block;
      margin-left: auto;
      margin-right: auto;
      width: 5%;
    " />
    </span>
    <pdf-viewer [src]="claimsVoidCheckImage" style="height: 400px"
      (after-load-complete)="claimsPdfLoaded($event)"></pdf-viewer>
  </div>
</div>
    </div>
  </div>
</div>
      <!--  Change to PAD Modal -->
      <div id="updatePaymentMethodPAD" class="modal fade modalposition" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header" id="backgroundColor">
              <h6 class="modal-title">{{ lang?.Update_Payment_Method }}</h6>
              <i #closePaymentmodal class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
                (click)="closeChangeToPad()"></i>
            </div>
            <div class="modal-body">
              <form [formGroup]="paymentMethodForm">
                <div class="row">
                  <div class="col-md-12 form-group">
                    <label id="modal-labels"><b>{{
                        lang?.Do_you_want_to_change_payment_method_to_Pre_Authorized_Debit
                        }}<span style="color: red">*</span></b></label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    <input type="radio" value="yes" formControlName="paymentmethod" id="paymentmethod"
                      name="paymentmethod" (click)="openPaymentDetails('open')" />&nbsp;<label id="radio-labels"
                      class="align-text-top">{{
                      lang?.Yes
                      }}</label>
                  </div>
                  <div class="col-3">
                    <input type="radio" value="no" formControlName="paymentmethod" id="paymentmethod"
                      name="paymentmethod" (click)="openPaymentDetails('close')" />&nbsp;<label id="radio-labels"
                      class="align-text-top">{{
                      lang?.No
                      }}</label>
                  </div>
                </div>
                <div class="row" *ngIf="openUpdatePaymentForm === 'open'">
                  <div class="col-md-4 form-group">
                    <label id="modal-labels">{{ lang?.Bank_Id }}<span style="color: red">*</span></label>
                    <input type="text" placeholder="{{ lang?.Bank_Number }}" formControlName="bankCode"
                      class="form-control" (input)="paymentMethodFormValid()"
                      (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                    <div *ngIf="
                    paymentMethodControls['bankCode'].touched &&
                    paymentMethodControls['bankCode'].invalid
                  " class="help-block text-danger">
                      <div *ngIf="
                      paymentMethodControls['bankCode'].errors &&
                      paymentMethodControls['bankCode'].errors['required']
                    ">
                        {{ lang?.Please_enter_bank_number }}
                      </div>
                      <div *ngIf="
                      paymentMethodControls['bankCode'].errors &&
                      paymentMethodControls['bankCode'].errors['minlength']
                    ">
                        {{ lang?.Bank_number_must_be_equal_to_3_digits }}
                      </div>
                      <div *ngIf="
                      paymentMethodControls['bankCode'].errors &&
                      paymentMethodControls['bankCode'].errors['maxlength']
                    ">
                        {{ lang?.Bank_number_must_be_equal_to_3_digits }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 form-group">
                    <label id="modal-labels">{{ lang?.Transit }}<span style="color: red">*</span></label>
                    <input type="text" placeholder="{{ lang?.Transit_Number }}" formControlName="branchCode"
                      class="form-control" (input)="paymentMethodFormValid()"
                      (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                    <div *ngIf="
                    paymentMethodControls['branchCode'].touched &&
                    paymentMethodControls['branchCode'].invalid
                  " class="help-block text-danger">
                      <div *ngIf="
                      paymentMethodControls['branchCode'].errors &&
                      paymentMethodControls['branchCode'].errors['required']
                    ">
                        {{ lang?.Please_enter_transit_number }}
                      </div>
                      <div *ngIf="
                      paymentMethodControls['branchCode'].errors &&
                      paymentMethodControls['branchCode'].errors['minlength']
                    ">
                        {{ lang?.Transit_number_must_be_equal_to_5_digits }}
                      </div>
                      <div *ngIf="
                      paymentMethodControls['branchCode'].errors &&
                      paymentMethodControls['branchCode'].errors['maxlength']
                    ">
                        {{ lang?.Transit_number_must_be_equal_to_5_digits }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 form-group">
                    <label id="modal-labels">{{ lang?.Account }}<span style="color: red">*</span></label>
                    <input type="text" placeholder="{{ lang?.Account_Number }}" formControlName="accountNumber"
                      class="form-control" (input)="paymentMethodFormValid()"
                      (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                    <div *ngIf="
                    paymentMethodControls['accountNumber'].touched &&
                    paymentMethodControls['accountNumber'].invalid
                  " class="help-block text-danger">
                      <div *ngIf="
                      paymentMethodControls['accountNumber'].errors &&
                      paymentMethodControls['accountNumber'].errors['required']
                    ">
                        {{ lang?.Please_enter_account_number }}
                      </div>
                      <div *ngIf="
                      paymentMethodControls['accountNumber'].errors &&
                      paymentMethodControls['accountNumber'].errors['minlength']
                    ">
                        {{ lang?.Account_number_minimum_5_digits }}
                      </div>
                      <div *ngIf="
                      paymentMethodControls['accountNumber'].errors &&
                      paymentMethodControls['accountNumber'].errors['maxlength']
                    ">
                        {{ lang?.Account_number_maximum_12_digits }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" *ngIf="bankDetails">
                  <div class="col-md-12 form-group">
                    <label id="modal-labels">{{ lang?.Bank_Details }}</label>
                    <div id="bankInfo">
                      <div id="bankDetails">
                        <div>{{ bankInfo.name }}</div>
                        <div *ngFor="let bankAddress of bankAddress">
                          {{ bankAddress }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-2">
                  <button type="button" class="btn btn-sm btn-light" id="updateButton" *ngIf="resetButton"
                    (click)="resetPaymentForm()">
                    {{ lang?.Clear }}
                  </button>
                  <button type="button" class="btn btn-sm btn-light" id="updateButton"
                    *ngIf="paymentMethodForm.valid && !bankDetails" (click)="getBankInfo()">
                    {{ lang?.Verify }}
                  </button>
                </div>
                <div class="form-group" *ngIf="uploadCheque">
                  <label id="modal-labels">{{ lang?.Upload_Void_Cheque
                    }}<span style="color: red">*</span></label>
                  <div class="row">
                    <div class="col-8 pt-1">
                      <input type="file" formControlName="files" (change)="onFileSelect($event)" />
                    </div>
                    <div class="col-4" *ngIf="previewbutton">
                      <button class="btn btn-sm btn-dark" data-bs-toggle="modal" data-bs-target="#previewAgreement"
                        (click)="changepad()">
                        {{lang?.Preview}}
                      </button>
                    </div>
                  </div>
                  <div *ngIf="
                  paymentMethodControls['files'].touched &&
                  paymentMethodControls['files'].invalid
                " class="help-block text-danger">
                    <div *ngIf="
                    paymentMethodControls['files'].errors &&
                    paymentMethodControls['files'].errors['required']
                  ">
                      {{lang?.Please_upload_void_cheque}}
                    </div>
                  </div>
                </div>
                <div class="mt-2">
                  <button class="btn btn-sm btn-success" data-bs-dismiss="modal" data-bs-toggle="modal"
                    data-bs-target="#padAgreement" *ngIf="uploadCheque"
                    [disabled]="paymentMethodForm.get('files')?.value === ''" (click)="generateCorporatePAD()">
                    {{ lang?.Review_and_Sign_the_PAD_Agreement }}
                  </button>
                </div>
              </form>
            </div>
            <div class="modal-footer py-2">
              <button #closePaymenttoPAD type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal"
                id="cancelButton" (click)="closeChangeToPad()">
                <b>{{ lang?.Cancel }}</b></button>&nbsp;
            </div>
          </div>
        </div>
      </div>

      <!--  create to CC Modal -->
      <div id="changeToCC" class="modal fade modalposition" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
          <div class="modal-content" id="modal-content">
            <div class="modal-header" id="backgroundColor">
              <h6 class="modal-title">{{ lang?.Change_to_Credit_Card }}</h6>
              <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
                (click)="closePaymentInfo()"></i>
            </div>
            <div class="modal-body">
              <form [formGroup]="paymentform" #paymentform1
                action="https://payments.subscriptionplatform.com/v2/payments/create" method="post">
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <input class="form-control" autofocus="autofocus" id="CustomerID" formcontrolname="cutomerId"
                      name="CustomerID" type="hidden" value="{{ customerID }}" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <input class="form-control" id="PublicApiKey" formcontrolname="PublicApiKey" name="PublicApiKey"
                      type="hidden" value="{{ fuseBillKey }}" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <input class="form-control" id="SuccessUri" formcontrolname="SuccessUri" name="SuccessUri"
                      type="hidden" value="{{ paymentsuccessuri }}" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <input class="form-control" id="FailUri" formcontrolname="FailUri" name="FailUri" type="hidden"
                      value="{{ paymentUri }}" />
                  </div>
                </div>

                <div>
                  <div class="row">
                    <div class="col-md-6 form-group mt-1">
                      <label id="modal-labels">{{ lang?.First_Name
                        }}<span style="color: red">*</span></label>
                      <input type="text" placeholder="{{ lang?.First_Name }}" class="form-control" id="FirstName"
                        name="FirstName" formControlName="FirstName" (keypress)="
                      (($event.charCode >= 65 && $event.charCode < 91) ||
                        ($event.charCode >= 97 && $event.charCode < 123) ||
                        $event.charCode == 32)
                    " (input)="checkFirstCharacter($event, paymentform)" />
                      <div *ngIf="
                      paymentForm['FirstName'].touched &&
                      paymentForm['FirstName'].invalid
                    " class="help-block text-danger">
                        <div *ngIf="
                        paymentForm['FirstName'].errors &&
                        paymentForm['FirstName'].errors['required']
                      ">
                          {{ lang?.Please_enter_first_name }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 form-group mt-1">
                      <label id="modal-labels">{{ lang?.Last_Name }}<span style="color: red">*</span></label>
                      <input type="text" placeholder="{{ lang?.Last_Name }}" class="form-control" id="LastName"
                        name="lastName" formControlName="LastName" (keypress)="
                      (($event.charCode >= 65 && $event.charCode < 91) ||
                        ($event.charCode >= 97 && $event.charCode < 123) ||
                        $event.charCode == 32)
                    " (input)="checkFirstCharacter($event, paymentform)" />
                      <div *ngIf="
                      paymentForm['LastName'].touched &&
                      paymentForm['LastName'].invalid
                    " class="help-block text-danger">
                        <div *ngIf="
                        paymentForm['LastName'].errors &&
                        paymentForm['LastName'].errors['required']
                      ">
                          {{ lang?.Please_enter_last_name }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 form-group mt-1">
                      <label id="modal-labels">{{ lang?.Credit_Card_Number
                        }}<span style="color: red">*</span></label>
                      <div class="input-group">
                        <input type="text" placeholder="{{lang?.Credit_Card_Number}}" class="form-control"
                          id="CardNumber" name="CardNumber" formControlName="CardNumber"
                          (keypress)="($event.charCode >= 48 && $event.charCode < 58)"
                          (input)="creditcardlblurmethod($event)" />
                        <span class="input-group-text text-muted">
                          <i class="fa fa-cc-visa mx-1"></i>
                          <i class="fa fa-cc-amex mx-1"></i>
                          <i class="fa fa-cc-mastercard mx-1"></i>
                        </span>
                      </div>
                      <div class="help-block text-danger" *ngIf="
                      paymentForm['CardNumber'].touched &&
                      paymentForm['CardNumber'].errors &&
                      paymentForm['CardNumber'].errors['required']
                    ">
                        {{ lang?.Please_enter_card_number }}
                      </div>
                      <div class="help-block text-danger" *ngIf="
                      (paymentForm['CardNumber'].touched &&
                        paymentForm['CardNumber'].hasError(
                          'invalidcreditcarddetails'
                        )) ||
                      invalidcreditcard
                    ">
                        {{ lang?.Please_enter_valid_Card_number }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 col-12 form-group mt-1">
                      <label id="modal-labels">Expiry Month<span style="color: red">*</span></label>
                      <div>
                        <div id="yearselect">
                          <select class="form-select" id="ExpirationMonth" name="ExpirationMonth"
                            formControlName="ExpirationMonth" (change)="getMonth($event)">
                            <option value="" disabled selected>
                              {{ lang?.Select }}
                            </option>
                            <option value="01">Jan</option>
                            <option value="02">Feb</option>
                            <option value="03">Mar</option>
                            <option value="04">April</option>
                            <option value="05">May</option>
                            <option value="06">June</option>
                            <option value="07">July</option>
                            <option value="08">Aug</option>
                            <option value="09">Sept</option>
                            <option value="10">Oct</option>
                            <option value="11">Nov</option>
                            <option value="12">Dec</option>
                          </select>
                        </div>
                      </div>
                      <div *ngIf="paymentForm['ExpirationMonth'].touched" class="help-block text-danger">
                        <div *ngIf="
                        paymentForm['ExpirationMonth'].errors &&
                        paymentForm['ExpirationMonth'].errors['required']
                      ">
                          {{ lang?.Please_select_expiration_month }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 col-12 form-group mt-1">
                      <label id="modal-labels">Expiry Year<span style="color: red">*</span></label>
                      <div>
                        <div>
                          <select class="form-select" id="ExpirationYear" name="ExpirationYear"
                            formControlName="ExpirationYear" (change)="getYear($event)">
                            <option value="" disabled>YYYY</option>
                            <option *ngFor="let item of [].constructor(20); let i = index"
                              value="{{ i + ( currentYear ) }}">
                              {{ i + currentYear }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div *ngIf="paymentForm['ExpirationYear'].touched" class="help-block text-danger">
                        <div *ngIf="
                        paymentForm['ExpirationYear'].errors &&
                        paymentForm['ExpirationYear'].errors['required']
                      ">
                          {{ lang?.Please_select_expiration_year }}
                        </div>
                        <div *ngIf="invalidExpiration">
                          {{ lang?.Please_enter_valid_expiration }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 col-12 form-group mt-1">
                      <label id="modal-labels">CVV<span style="color: red">*</span>&nbsp;<span
                          (mouseover)="showImage = true" (mouseout)="showImage = false" style="cursor: pointer"><i
                            class="bi bi-question-circle-fill"></i></span></label>
                      <img *ngIf="showImage" src="/assets/img/cvv-number.jpg" width="140px" height="80px" />
                      <input type="text" placeholder="CVV" class="form-control" id="Cvv" name="Cvv"
                        formControlName="Cvv" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                      <div *ngIf="
                      paymentForm['Cvv'].touched && paymentForm['Cvv'].invalid
                    " class="help-block text-danger">
                        <div *ngIf="
                        paymentForm['Cvv'].errors &&
                        paymentForm['Cvv'].errors['required']
                      ">
                          {{ lang?.Please_enter_CVV }}
                        </div>
                        <div *ngIf="
                        paymentForm['Cvv'].errors &&
                        paymentForm['Cvv'].errors['minlength']
                      ">
                          {{ lang?.CVV_number_minimum_3_digits }}
                        </div>
                        <div *ngIf="
                        paymentForm['Cvv'].errors &&
                        paymentForm['Cvv'].errors['maxlength']
                      ">
                          {{ lang?.CVV_number_maximum_4_digits }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <input class="form-control" id="MakeDefault" placeholder="{{ lang?.Name_on_the_card }}"
                        value="true" type="hidden" name="MakeDefault" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 form-group mt-1">
                      <label id="modal-labels">{{ lang?.Email }}<span style="color: red">*</span></label>
                      <input type="text" placeholder="Email" class="form-control" id="email" name="email"
                        formControlName="email" />
                      <div *ngIf="
                      paymentForm['email'].touched && paymentForm['email'].invalid
                    " class="help-block text-danger">
                        <div *ngIf="
                        paymentForm['email'].errors &&
                        paymentForm['email'].errors['required']
                      ">
                          {{ lang?.Please_enter_email }}
                        </div>
                        <div *ngIf="
                        paymentForm['email'].errors &&
                        paymentForm['email'].errors['pattern']
                      ">
                          {{ lang?.Please_enter_valid_email }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row captchavalidation mt-2">
                    <div class="col-12">
                      <re-captcha (resolved)="resolved($event)" formControlName="recaptchaReactive"
                        siteKey="{{ fusbillinfocaptchavalue }}">
                      </re-captcha>
                      <input id="recaptcha_token" type="hidden" name="recaptcha_token" [value]="recaptchaResponse" />
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="modal-footer py-2">
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
                (click)="closePaymentInfo()">
                <b>{{ lang?.Cancel }}</b></button>&nbsp;
              <button type="button" class="btn btn-sm btn-light" id="updateButton" [disabled]="invalidExpiration"
                (click)="saveCcPayment(paymentform.value, paymentform1)">
                {{ lang?.Save }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- PAD Agreement -->
      <div id="padAgreement" class="modal fade modalposition modal-lg" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header" id="backgroundColor">
              <h6 class="modal-title">{{ lang?.PAD_Agreement }}</h6>
              <i #closeAgreement class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
            </div>
            <div class="modal-body">
              <div>
                <span *ngIf="loading">
                  <img src="../../assets/img/loader.gif" width="100" style="
                  display: block;
                  margin-left: auto;
                  margin-right: auto;
                  width: 5%;
                " />
                </span>
                <pdf-viewer [src]="pad" style="height: 400px" (after-load-complete)="pdfLoaded($event)"></pdf-viewer>
              </div>
            </div>
            <div class="modal-footer py-2">
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" data-bs-toggle="modal"
                data-bs-target="#signaturepad" id="updateButton" (click)="clearpadsignature()">
                <b>{{ lang.Sign_Agree }}</b>
              </button>
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="updateButton"
                (click)="closepadinfo()">
                <b>{{ lang?.Reject }}</b>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- view pad agreement -->
      <div id="view-padAgreement" class="modal fade modalposition modal-lg" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header" id="backgroundColor">
              <h6 class="modal-title">{{ lang?.PAD_Agreement }}</h6>
              <i #closeAgreement class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
            </div>
            <div class="modal-body">
              <div>
                <span *ngIf="loading">
                  <img src="../../assets/img/loader.gif" width="100" style="
                  display: block;
                  margin-left: auto;
                  margin-right: auto;
                  width: 5%;
                " />
                </span>
                <pdf-viewer [src]="padAgreement" style="height: 400px"
                  (after-load-complete)="pdfLoaded($event)"></pdf-viewer>
              </div>
            </div>
            <div class="modal-footer py-2">
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
                <b>{{ lang?.Close }}</b>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Signature Pad Modal -->
      <div id="signaturepad" class="modal fade modalposition" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header" id="backgroundColor">
              <label>
                <h6 class="modal-title">{{ lang?.Signature }}</h6>
              </label>
            </div>
            <div class="modal-body">
              <div class="signature-container">
                <signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()"
                  (onEndEvent)="drawComplete()"></signature-pad>
              </div>
              <div class="buttons">
                <button class="btn btn-sm btn-light" id="cancelButton" (click)="clearSignature()">
                  {{ lang?.Clear }}
                </button>
              </div>
            </div>
            <div class="modal-footer py-2">
          <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="savePad()">
  {{ lang?.Confirm }}
</button>
            </div>
          </div>
        </div>
      </div>

      <div id="viewinvoice" class="modal fade modal-lg modalposition" tabindex="-1" role="dialog"
        aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
          <div class="modal-content" id="modal-content">
            <div class="modal-header" id="backgroundColor">
              <span class="modal-title">{{ lang?.View_Invoice }}</span>
              <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
                (click)="closeBooklet()"></i>
            </div>
            <div class="modal-body">
                            <span *ngIf="showViewPlansLoading">
                <img src=".../../assets/img/loader.gif" width="100" style="
                display: block;
                margin-left: auto;
                margin-right: auto;
                width: 5%;
              " />
              </span>
              <div>
                
                <pdf-viewer [src]="invoiceslink" id="pdf-viewer" [show-all]="false" [page]="page"
                  (after-load-complete)="afterLoadComplete($event)" [original-size]="false" [render-text]="true"
                  style="height: 60vh; z-index:9999; overflow-y: scroll;" class="px-0 w-fill object-fit">
                </pdf-viewer>

                <ng-container *ngIf="showViewPlansLoading==false">
                  <div class="pagination-controls">
                    <button (click)="previousPage()" [disabled]="page <= 1" class="chevron chevron--left">{{'<'}}
                        </button>
                        <span>{{page}} / {{totalPages}}</span>
                        <button (click)="nextPage()" [disabled]="page >= totalPages"
                          class="chevron chevron--right">{{'>'}}
                        </button>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="modal-footer py-2">
                            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
                <b>{{ lang?.Close }}</b>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Signed PAD Agreement -->
      <div id="signedPad" class="modal fade modalposition modal-lg" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header" id="backgroundColor">
              <h6 class="modal-title">{{ lang?.PAD_Agreement }}</h6>
              <i #closeAgreement class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
            </div>
            <div class="modal-body">
              <div>
                <span *ngIf="loading">
                  <img src="../../assets/img/loader.gif" width="100" style="
                  display: block;
                  margin-left: auto;
                  margin-right: auto;
                  width: 5%;
                " />
                </span>
                <pdf-viewer [src]="signedPad" style="height: 400px"
                  (after-load-complete)="pdfLoaded($event)"></pdf-viewer>
              </div>
            </div>
            <div class="modal-footer py-2">
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="updateButton"
                (click)="changeToPAD()">
                <b>{{ lang?.Agree }}</b>
              </button>
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="updateButton"
                (click)="closepadinfo()">
                <b>{{ lang?.Reject }}</b>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Preview change PAD Agreement -->
      <div id="previewAgreement" class="modal fade modalposition modal-lg" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header" id="backgroundColor">
              <h6 class="modal-title">{{ lang?.Preview }}</h6>
              <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal" data-bs-toggle="modal"
                data-bs-target="#updatePaymentMethodPAD" (click)="openUpdatePaymentMethodPAD()"></i>
            </div>
            <div class="modal-body">
              <div>
                <div *ngIf="voidCheckFileType == 'image/jpeg'">
                  <img [src]="imagedisplay" />
                </div>
                <div *ngIf="voidCheckFileType == 'application/pdf'">
                  <span *ngIf="loading">
                    <img src="../../assets/img/loader.gif" width="100" style="
                    display: block;
                    margin-left: auto;
                    margin-right: auto;
                    width: 5%;
                  " />
                  </span>
                  <pdf-viewer [src]="voidCheque1" style="height: 400px"
                    (after-load-complete)="pdfLoaded($event)"></pdf-viewer>
                </div>
              </div>
            </div>
            <div class="modal-footer py-2">
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" data-bs-toggle="modal"
                data-bs-target="#updatePaymentMethodPAD" (click)="openUpdatePaymentMethodPAD()" id="cancelButton">
                <b>{{ lang?.Close }}</b>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Preview update PAD Agreement -->
      <div id="updatepreviewAgreement" class="modal fade modalposition modal-lg" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header" id="backgroundColor">
              <h6 class="modal-title">{{ lang?.Preview }}</h6>
              <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal" data-bs-toggle="modal"
                data-bs-target="#updatePADinfo"></i>
            </div>
            <div class="modal-body">
              <div *ngIf="voidCheckFileType?.includes('image')">
                <img [src]="voidCheckImage" />
              </div>
              <div *ngIf="voidCheckFileType == 'application/pdf'">
                <span *ngIf="loading">
                  <img src=".../../assets/img/loader.gif" width="100" style="
                  display: block;
                  margin-left: auto;
                  margin-right: auto;
                  width: 5%;
                " />
                </span>
                <pdf-viewer [src]="voidCheque2" style="height: 400px"
                  (after-load-complete)="pdfLoaded($event)"></pdf-viewer>
              </div>
            </div>
            <div class="modal-footer py-2">
              <button *ngIf="existVoid" type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal"
                data-bs-toggle="modal" data-bs-target="#updatePADinfo" id="updateButton" (click)="uploadNewVoid()">
                <b>{{ lang?.Upload }}</b>
              </button>
              <button *ngIf="existVoid" type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal"
                data-bs-toggle="modal" data-bs-target="#padAgreement" id="updateButton" (click)="updateCorporatePAD()">
                <b>{{ lang?.Continue }}</b>
              </button>
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" data-bs-toggle="modal"
                data-bs-target="#updatePADinfo" id="cancelButton">
                <b>{{ lang?.Close }}</b>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade modal-lg modalposition" data-bs-backdrop="static" id="videoform">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
          <div class="modal-content">
            <div class="modal-header" id="backgroundColor">
              <h6 class="modal-title">{{ videoTitle }}</h6>
              <i class="bi bi-x-circle closevideo" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
            </div>
            <div class="modal-body" id="video-modal-body">
              <video controls (canplay)="pauseVideo(videoplayer)" #videoPlayer>
                <source src="{{ videoLink }}" type="video/mp4" />

                {{ lang?.Your_browser_does_not_support_the_video_tag }}
              </video>
            </div>
            <div class="modal-footer py-2">
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
                <b class="closevideo">{{ lang?.Close }}</b>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!--  -->
      <div class="modal fade modal-lg modalposition" data-bs-backdrop="static" id="iframeform">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
          <div class="modal-content" id="modal-content">
            <div class="modal-header" id="backgroundColor">
              <h6 class="modal-title">{{ iframeTitle }}</h6>
              <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
            </div>
            <div class="modal-body">
                            <iframe *ngIf="iframeLink" width="100%" [src]="iframeLink" id="pdf-viewer"
                (after-load-complete)="pdfLoaded($event)"></iframe>
            </div>
            <div class="modal-footer py-2">
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
                <b>{{ lang?.Close }}</b>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!--  -->
      <div class="modal fade modal-lg modalposition" data-bs-backdrop="static" id="equitable">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
          <div class="modal-content" id="modal-content">
            <div class="modal-header" id="backgroundColor">
              <h6 class="modal-title">{{ headerName }}</h6>
              <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
            </div>
            <div class="modal-body">
                            <span *ngIf="loading">
                <img src="../../assets/img/loader.gif" width="100" style="
                display: block;
                margin-left: auto;
                margin-right: auto;
                width: 5%;
              " />
              </span>
              <pdf-viewer [src]="booklet_link" *ngIf="booklet_link" id="pdf-viewer"
                (after-load-complete)="pdfLoaded($event)"></pdf-viewer>
            </div>
            <div class="modal-footer py-2">
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
                <b>{{ lang?.Close }}</b>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!--  -->
      <div class="modal fade modal-lg modalposition" data-bs-backdrop="static" id="support">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
          <div class="modal-content" id="modal-content">
            <div class="modal-header" id="backgroundColor">
              <h6 class="modal-title">{{ lang?.Student_VIP }}</h6>
              <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
            </div>
            <div class="modal-body">
              <iframe *ngIf="support_link" [src]="support_link" width="100%" id="pdf-viewer"
                (after-load-complete)="pdfLoaded($event)"></iframe>
            </div>
            <div class="modal-footer py-2">
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
                <b>{{ lang?.Close }}</b>
              </button>
            </div>
          </div>
        </div>
      </div>

 <div class="modal d-block cancel-modal-overlay" *ngIf="showCancelModal" style="z-index: 99999;">
  <div class="modal-dialog modal-sm modal-dialog-centered">
    <div class="modal-content cancel-modal-content">
      
<div class="modal-header cancel-modal-header">
  <h6 class="modal-title">
    Cancel Booking for {{ selectedCancelCoverage === 'spouse' ? 'Spouse' : selectedCancelCoverage === 'both' ? 'Both' : 'Member' }}
  </h6>
</div>

<div style="position: relative;">
  <div *ngIf="isCancelling" style="position:absolute; top:0; left:0; width:100%; height:100%; background:rgba(255,255,255,0.7); z-index:9999; display:flex; align-items:center; justify-content:center;">
    <img src="/assets/img/loader.gif" style="width: 60px;" />
  </div>

  <div class="modal-body" style="text-align:center; padding: 10px 16px; white-space: nowrap;">
    <p style="margin: 0; font-size: 13px;">Are you sure you want to Cancel?</p>
  </div>

  <div class="modal-footer cancel-modal-footer">
    <button class="btn btn-sm order-btn me-2"
      (pointerdown)="confirmCancel(selectedCancelCoverage || 'self'); $event.stopPropagation(); $event.preventDefault()">
      Yes
    </button>
    <button class="btn btn-sm order-btn" (click)="showCancelModal = false">
      Close
    </button>
  </div>
</div>
  </div>
</div>
</div>

      <app-header *ngIf="false" (selectedlanguage)="setlanguage($event)" [formConfig]="formConfiguration"></app-header>

            <!-- Parent Template -->
<app-booking #bookingRef [signaturePadOptions]="signaturePadOptions" [eligibilityMap]="eligibilityMap"
  [typeOfForm]="selectedResource?.typeOfForm" [customerData]="customerData"
  (bookingCreated)="onChildBookingCreated($event)">
</app-booking>

     